var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/constants/ai.ts
var AI_ATTACHMENT_LIMITS = {
  maxRows: 300,
  maxCols: 60,
  maxCellChars: 500,
  maxTextChars: 3e4
};

// src/enums/app-onboarding.enum.ts
var AppOnboardingStage = /* @__PURE__ */ (function(AppOnboardingStage2) {
  AppOnboardingStage2["NOT_SENT"] = "not_sent";
  AppOnboardingStage2["SENT"] = "sent";
  AppOnboardingStage2["INSTALLED"] = "installed";
  AppOnboardingStage2["LOGGED_IN"] = "logged_in";
  AppOnboardingStage2["PASSWORD_CHANGED"] = "password_changed";
  AppOnboardingStage2["TUTORIAL_DONE"] = "tutorial_done";
  return AppOnboardingStage2;
})({});
var AppTutorialStep = /* @__PURE__ */ (function(AppTutorialStep2) {
  AppTutorialStep2["NOTIFICATIONS"] = "notifications";
  AppTutorialStep2["SHIFTS"] = "shifts";
  AppTutorialStep2["REQUESTS"] = "requests";
  AppTutorialStep2["PAYSLIP"] = "payslip";
  AppTutorialStep2["REPORT"] = "report";
  AppTutorialStep2["AI_ASSISTANT"] = "ai_assistant";
  return AppTutorialStep2;
})({});
var AppOnboardingChecklistStep = /* @__PURE__ */ (function(AppOnboardingChecklistStep2) {
  AppOnboardingChecklistStep2["CONTACTS"] = "contacts";
  AppOnboardingChecklistStep2["PASSWORD_POLICY"] = "password_policy";
  AppOnboardingChecklistStep2["SEND_GUIDE"] = "send_guide";
  AppOnboardingChecklistStep2["INSTALL_STATUS"] = "install_status";
  AppOnboardingChecklistStep2["RESEND"] = "resend";
  AppOnboardingChecklistStep2["NOTICE"] = "notice";
  AppOnboardingChecklistStep2["COMPLETE"] = "complete";
  return AppOnboardingChecklistStep2;
})({});

// src/enums/attendance.enum.ts
var AttendanceMethod = /* @__PURE__ */ (function(AttendanceMethod2) {
  AttendanceMethod2["SECOM"] = "secom";
  AttendanceMethod2["APP"] = "app";
  AttendanceMethod2["MANUAL"] = "manual";
  return AttendanceMethod2;
})({});
var ShiftResolutionSource = /* @__PURE__ */ (function(ShiftResolutionSource2) {
  ShiftResolutionSource2["SCHEDULE"] = "schedule";
  ShiftResolutionSource2["EMPLOYEE_SHIFT"] = "employee_shift";
  ShiftResolutionSource2["GROUP_SHIFT"] = "group_shift";
  ShiftResolutionSource2["WORK_PATTERN_DEFAULT"] = "work_pattern_default";
  ShiftResolutionSource2["JOB_DUTY_DEFAULT"] = "job_duty_default";
  ShiftResolutionSource2["TEAM_REPRESENTATIVE"] = "team_representative";
  ShiftResolutionSource2["ORG_DEFAULT_SHIFT"] = "org_default_shift";
  ShiftResolutionSource2["ORG_DEFAULT_TIME"] = "org_default_time";
  ShiftResolutionSource2["OFF_DAY"] = "off_day";
  ShiftResolutionSource2["INFERRED"] = "inferred";
  ShiftResolutionSource2["PREVIOUS"] = "previous";
  return ShiftResolutionSource2;
})({});
var ShiftAssignmentSource = /* @__PURE__ */ (function(ShiftAssignmentSource2) {
  ShiftAssignmentSource2["MANUAL"] = "manual";
  ShiftAssignmentSource2["WORK_PATTERN_DEFAULT"] = "work_pattern_default";
  ShiftAssignmentSource2["JOB_DUTY_DEFAULT"] = "job_duty_default";
  ShiftAssignmentSource2["TEAM_REPRESENTATIVE"] = "team_representative";
  ShiftAssignmentSource2["BULK_ASSIGN"] = "bulk_assign";
  ShiftAssignmentSource2["BULK_UPLOAD"] = "bulk_upload";
  ShiftAssignmentSource2["SHEET"] = "sheet";
  ShiftAssignmentSource2["SELF"] = "self";
  ShiftAssignmentSource2["CARRIED"] = "carried";
  ShiftAssignmentSource2["MIGRATION"] = "migration";
  return ShiftAssignmentSource2;
})({});

// src/constants/app-onboarding.ts
var WORKS_APP_STORE_URL = "https://apps.apple.com/kr/app/hereby-works/id6762249116";
var WORKS_PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=me.hereby.works";
var APP_ONBOARDING_STAGE_ORDER = [
  AppOnboardingStage.NOT_SENT,
  AppOnboardingStage.SENT,
  AppOnboardingStage.INSTALLED,
  AppOnboardingStage.LOGGED_IN,
  AppOnboardingStage.PASSWORD_CHANGED,
  AppOnboardingStage.TUTORIAL_DONE
];
var APP_ONBOARDING_STAGE_LABELS = {
  [AppOnboardingStage.NOT_SENT]: "\uBBF8\uC548\uB0B4",
  [AppOnboardingStage.SENT]: "\uC548\uB0B4 \uBC1C\uC1A1\uB428",
  [AppOnboardingStage.INSTALLED]: "\uC571 \uC124\uCE58\uB428",
  [AppOnboardingStage.LOGGED_IN]: "\uCCAB \uB85C\uADF8\uC778 \uC644\uB8CC",
  [AppOnboardingStage.PASSWORD_CHANGED]: "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD \uC644\uB8CC",
  [AppOnboardingStage.TUTORIAL_DONE]: "\uD29C\uD1A0\uB9AC\uC5BC \uC644\uB8CC"
};
var APP_ONBOARDING_STAGE_SHORT_LABELS = {
  [AppOnboardingStage.NOT_SENT]: "\uBBF8\uC548\uB0B4",
  [AppOnboardingStage.SENT]: "\uBBF8\uC124\uCE58",
  [AppOnboardingStage.INSTALLED]: "\uBBF8\uB85C\uADF8\uC778",
  [AppOnboardingStage.LOGGED_IN]: "\uBE44\uBC00\uBC88\uD638 \uBBF8\uBCC0\uACBD",
  [AppOnboardingStage.PASSWORD_CHANGED]: "\uD29C\uD1A0\uB9AC\uC5BC \uC804",
  [AppOnboardingStage.TUTORIAL_DONE]: "\uC644\uB8CC"
};
function resolveAppOnboardingStage(flags) {
  if (!flags.sent) {
    return AppOnboardingStage.NOT_SENT;
  }
  if (!flags.installed) {
    return AppOnboardingStage.SENT;
  }
  if (!flags.loggedIn) {
    return AppOnboardingStage.INSTALLED;
  }
  if (!flags.passwordChanged) {
    return AppOnboardingStage.LOGGED_IN;
  }
  if (!flags.tutorialDone) {
    return AppOnboardingStage.PASSWORD_CHANGED;
  }
  return AppOnboardingStage.TUTORIAL_DONE;
}
__name(resolveAppOnboardingStage, "resolveAppOnboardingStage");
function appOnboardingStageAtLeast(a, b) {
  return APP_ONBOARDING_STAGE_ORDER.indexOf(a) >= APP_ONBOARDING_STAGE_ORDER.indexOf(b);
}
__name(appOnboardingStageAtLeast, "appOnboardingStageAtLeast");
var APP_ONBOARDING_GOAL_STAGE = AppOnboardingStage.LOGGED_IN;
var APP_ONBOARDING_TARGET_RATE_DEFAULT = 80;
var APP_ONBOARDING_TARGET_RATE_MIN = 10;
var APP_ONBOARDING_TARGET_RATE_MAX = 100;
var APP_HOSPITAL_CODE_MIN_LENGTH = 3;
var APP_HOSPITAL_CODE_MAX_LENGTH = 32;
var APP_HOSPITAL_CODE_PATTERN = /^[A-Z0-9-]{3,32}$/;
var APP_GUIDE_PLACEHOLDERS = [
  "{\uBCD1\uC6D0\uBA85}",
  "{\uC774\uB984}",
  "{\uD68C\uC0AC\uCF54\uB4DC}",
  "{\uB85C\uADF8\uC778ID}",
  "{\uC784\uC2DC\uBE44\uBC00\uBC88\uD638}",
  "{\uC571\uB9C1\uD06C}",
  "{\uB85C\uADF8\uC778\uB9C1\uD06C}"
];
var APP_GUIDE_LOGIN_LINK_PLACEHOLDER = "{\uB85C\uADF8\uC778\uB9C1\uD06C}";
var APP_GUIDE_HOSPITAL_CODE_PLACEHOLDER = "{\uD68C\uC0AC\uCF54\uB4DC}";
var APP_GUIDE_PASSWORD_PLACEHOLDER = "{\uC784\uC2DC\uBE44\uBC00\uBC88\uD638}";
function findUnknownAppGuidePlaceholders(template) {
  const known = new Set(APP_GUIDE_PLACEHOLDERS);
  const found = /* @__PURE__ */ new Set();
  for (const m of (template ?? "").matchAll(/\{\{[^{}\n]*\}\}|\{[^{}\n]*\}/g)) {
    if (!known.has(m[0])) {
      found.add(m[0]);
    }
  }
  return [
    ...found
  ];
}
__name(findUnknownAppGuidePlaceholders, "findUnknownAppGuidePlaceholders");
function appGuideTemplateIncludesPassword(template) {
  return (template ?? "").includes(APP_GUIDE_PASSWORD_PLACEHOLDER);
}
__name(appGuideTemplateIncludesPassword, "appGuideTemplateIncludesPassword");
var DEFAULT_APP_GUIDE_SMS_TEMPLATE = `[{\uBCD1\uC6D0\uBA85}] {\uC774\uB984}\uB2D8, \uC9C1\uC6D0 \uC571(hereby Works) \uC124\uCE58 \uC548\uB0B4\uC785\uB2C8\uB2E4.
\uC544\uB798 \uB9C1\uD06C\uC5D0\uC11C \uC571\uC744 \uC124\uCE58\uD55C \uB4A4, \uD68C\uC0AC \uCF54\uB4DC\uB97C \uC785\uB825\uD558\uACE0 \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694.
{\uC571\uB9C1\uD06C}
\uD68C\uC0AC \uCF54\uB4DC: {\uD68C\uC0AC\uCF54\uB4DC}
\uB85C\uADF8\uC778 ID: {\uB85C\uADF8\uC778ID}
\uC784\uC2DC \uBE44\uBC00\uBC88\uD638: {\uC784\uC2DC\uBE44\uBC00\uBC88\uD638}
\uC124\uCE58 \uD6C4 \uC774 \uB9C1\uD06C\uB97C \uB204\uB974\uBA74 ID\xB7\uBE44\uBC00\uBC88\uD638\uAC00 \uC790\uB3D9\uC73C\uB85C \uC785\uB825\uB3FC\uC694: {\uB85C\uADF8\uC778\uB9C1\uD06C}
\uCCAB \uB85C\uADF8\uC778 \uD6C4 \uBE44\uBC00\uBC88\uD638\uB97C \uAF2D \uBCC0\uACBD\uD574 \uC8FC\uC138\uC694.`;
var DEFAULT_APP_GUIDE_EMAIL_TEMPLATE = `{\uC774\uB984}\uB2D8, \uC548\uB155\uD558\uC138\uC694. {\uBCD1\uC6D0\uBA85}\uC785\uB2C8\uB2E4.
\uC9C1\uC6D0 \uC571(hereby Works)\uC744 \uC124\uCE58\uD558\uACE0 \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694. \uADFC\uBB34\uD45C\xB7\uCD9C\uD1F4\uADFC\xB7\uD734\uAC00 \uC2E0\uCCAD\xB7\uAE09\uC5EC\uBA85\uC138\uC11C\uB97C \uC571\uC5D0\uC11C \uBCFC \uC218 \uC788\uC5B4\uC694.
\uC571\uC744 \uCC98\uC74C \uC5F4\uBA74 \uD68C\uC0AC \uCF54\uB4DC\uB97C \uBB3B\uACE0, \uADF8\uB2E4\uC74C \uB85C\uADF8\uC778 ID \uC640 \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC694.

\uC571 \uC124\uCE58: {\uC571\uB9C1\uD06C}
\uD68C\uC0AC \uCF54\uB4DC: {\uD68C\uC0AC\uCF54\uB4DC}
\uB85C\uADF8\uC778 ID: {\uB85C\uADF8\uC778ID}
\uC784\uC2DC \uBE44\uBC00\uBC88\uD638: {\uC784\uC2DC\uBE44\uBC00\uBC88\uD638}

\uCCAB \uB85C\uADF8\uC778 \uD6C4 \uBE44\uBC00\uBC88\uD638\uB97C \uAF2D \uBCC0\uACBD\uD574 \uC8FC\uC138\uC694. \uC571 \uC0AC\uC6A9 \uC911 \uBD88\uD3B8\uD55C \uC810\uC740 \uB354\uBCF4\uAE30 \u203A \u300C\uBD88\uD3B8\xB7\uAE30\uB2A5 \uC2E0\uACE0\u300D \uB85C \uC54C\uB824 \uC8FC\uC138\uC694.`;
var DEFAULT_APP_ONBOARDING_NOTICE = {
  title: "\uC9C1\uC6D0 \uC571(hereby Works) \uC124\uCE58 \uC548\uB0B4",
  content: `\uC9C1\uC6D0 \uC5EC\uB7EC\uBD84, \uC548\uB155\uD558\uC138\uC694.
\uADFC\uBB34\uD45C\xB7\uCD9C\uD1F4\uADFC\xB7\uD734\uAC00 \uC2E0\uCCAD\xB7\uAE09\uC5EC\uBA85\uC138\uC11C\uB97C \uBCFC \uC218 \uC788\uB294 \uC9C1\uC6D0 \uC571(hereby Works)\uC744 \uBC30\uD3EC\uD569\uB2C8\uB2E4.

1. \uC571 \uC124\uCE58
{\uC571\uB9C1\uD06C}

2. \uB85C\uADF8\uC778
\uC571\uC744 \uCC98\uC74C \uC5F4\uBA74 \uD68C\uC0AC \uCF54\uB4DC\uB97C \uBB3C\uC5B4\uC694. \uD68C\uC0AC \uCF54\uB4DC {\uD68C\uC0AC\uCF54\uB4DC} \uB97C \uC785\uB825\uD55C \uB4A4, \uBB38\uC790(\uB610\uB294 \uC774\uBA54\uC77C)\uB85C \uBC1B\uC740 \uB85C\uADF8\uC778 ID \uC640 \uC784\uC2DC \uBE44\uBC00\uBC88\uD638\uB85C \uB85C\uADF8\uC778\uD558\uACE0 \uBE44\uBC00\uBC88\uD638\uB97C \uAF2D \uBCC0\uACBD\uD574 \uC8FC\uC138\uC694.

3. \uBB38\uC758
\uB85C\uADF8\uC778\uC774 \uC548 \uB418\uAC70\uB098 \uC548\uB0B4\uB97C \uBABB \uBC1B\uC73C\uC168\uB2E4\uBA74 \uC778\uC0AC \uB2F4\uB2F9\uC790\uC5D0\uAC8C \uB9D0\uC500\uD574 \uC8FC\uC138\uC694.
\uC571 \uC0AC\uC6A9 \uC911 \uBD88\uD3B8\uD55C \uC810\uC740 \uC571\uC758 \uB354\uBCF4\uAE30 \u203A \u300C\uBD88\uD3B8\xB7\uAE30\uB2A5 \uC2E0\uACE0\u300D \uB85C \uBCF4\uB0B4 \uC8FC\uC138\uC694.`
};
var DEFAULT_APP_ONBOARDING_SETTINGS = {
  targetRate: APP_ONBOARDING_TARGET_RATE_DEFAULT,
  smsTemplate: DEFAULT_APP_GUIDE_SMS_TEMPLATE,
  emailTemplate: DEFAULT_APP_GUIDE_EMAIL_TEMPLATE,
  downloadUrl: null,
  hospitalCode: null,
  tutorialSteps: {
    [AppTutorialStep.NOTIFICATIONS]: true,
    [AppTutorialStep.SHIFTS]: true,
    [AppTutorialStep.REQUESTS]: true,
    [AppTutorialStep.PAYSLIP]: true,
    [AppTutorialStep.REPORT]: true,
    [AppTutorialStep.AI_ASSISTANT]: true
  },
  checklistSteps: {
    [AppOnboardingChecklistStep.CONTACTS]: true,
    [AppOnboardingChecklistStep.PASSWORD_POLICY]: true,
    [AppOnboardingChecklistStep.SEND_GUIDE]: true,
    [AppOnboardingChecklistStep.INSTALL_STATUS]: true,
    [AppOnboardingChecklistStep.RESEND]: true,
    [AppOnboardingChecklistStep.NOTICE]: true,
    [AppOnboardingChecklistStep.COMPLETE]: true
  },
  noticeId: null,
  completedAt: null
};
function clampRate(value) {
  const n = typeof value === "number" && Number.isFinite(value) ? Math.round(value) : Number.NaN;
  if (Number.isNaN(n)) {
    return APP_ONBOARDING_TARGET_RATE_DEFAULT;
  }
  return Math.min(APP_ONBOARDING_TARGET_RATE_MAX, Math.max(APP_ONBOARDING_TARGET_RATE_MIN, n));
}
__name(clampRate, "clampRate");
function nonEmpty(value, fallback) {
  return typeof value === "string" && value.trim().length > 0 ? value : fallback;
}
__name(nonEmpty, "nonEmpty");
function normalizeAppHospitalCode(value) {
  if (typeof value !== "string") {
    return null;
  }
  const code = value.trim().toUpperCase();
  return APP_HOSPITAL_CODE_PATTERN.test(code) ? code : null;
}
__name(normalizeAppHospitalCode, "normalizeAppHospitalCode");
function appGuideTemplateNeedsHospitalCode(template) {
  return template.includes(APP_GUIDE_HOSPITAL_CODE_PLACEHOLDER);
}
__name(appGuideTemplateNeedsHospitalCode, "appGuideTemplateNeedsHospitalCode");
function resolveAppOnboardingSettings(config) {
  const d = DEFAULT_APP_ONBOARDING_SETTINGS;
  const tutorialSteps = {
    ...d.tutorialSteps
  };
  for (const key of Object.values(AppTutorialStep)) {
    const v = config?.tutorialSteps?.[key];
    if (typeof v === "boolean") {
      tutorialSteps[key] = v;
    }
  }
  const checklistSteps = {
    ...d.checklistSteps
  };
  for (const key of Object.values(AppOnboardingChecklistStep)) {
    const v = config?.checklistSteps?.[key];
    if (typeof v === "boolean") {
      checklistSteps[key] = v;
    }
  }
  checklistSteps[AppOnboardingChecklistStep.COMPLETE] = true;
  const downloadUrl = typeof config?.downloadUrl === "string" && config.downloadUrl.trim() ? config.downloadUrl.trim() : null;
  return {
    targetRate: clampRate(config?.targetRate),
    smsTemplate: nonEmpty(config?.smsTemplate, d.smsTemplate),
    emailTemplate: nonEmpty(config?.emailTemplate, d.emailTemplate),
    downloadUrl,
    hospitalCode: normalizeAppHospitalCode(config?.hospitalCode),
    tutorialSteps,
    checklistSteps,
    noticeId: typeof config?.noticeId === "string" && config.noticeId ? config.noticeId : null,
    completedAt: typeof config?.completedAt === "string" && config.completedAt ? config.completedAt : null
  };
}
__name(resolveAppOnboardingSettings, "resolveAppOnboardingSettings");
function appGuideLinkText(downloadUrl) {
  if (downloadUrl) {
    return downloadUrl;
  }
  return `iOS: ${WORKS_APP_STORE_URL}
Android: ${WORKS_PLAY_STORE_URL}`;
}
__name(appGuideLinkText, "appGuideLinkText");
function renderAppGuideTemplate(template, vars) {
  const hospitalCode = vars.hospitalCode ?? null;
  const kept = template.split("\n").filter((line) => vars.temporaryPassword || !line.includes(APP_GUIDE_PASSWORD_PLACEHOLDER)).filter((line) => hospitalCode || !line.includes(APP_GUIDE_HOSPITAL_CODE_PLACEHOLDER)).filter((line) => vars.loginLink || !line.includes(APP_GUIDE_LOGIN_LINK_PLACEHOLDER));
  return kept.join("\n").split("{\uBCD1\uC6D0\uBA85}").join(vars.organizationName).split("{\uC774\uB984}").join(vars.employeeName).split(APP_GUIDE_HOSPITAL_CODE_PLACEHOLDER).join(hospitalCode ?? "").split("{\uB85C\uADF8\uC778ID}").join(vars.loginId).split(APP_GUIDE_PASSWORD_PLACEHOLDER).join(vars.temporaryPassword ?? "").split("{\uC571\uB9C1\uD06C}").join(appGuideLinkText(vars.downloadUrl)).split(APP_GUIDE_LOGIN_LINK_PLACEHOLDER).join(vars.loginLink ?? "").trim();
}
__name(renderAppGuideTemplate, "renderAppGuideTemplate");
var APP_TUTORIAL_STEP_DEFS = [
  {
    key: AppTutorialStep.NOTIFICATIONS,
    order: 1,
    title: "\uC54C\uB9BC\uC744 \uD5C8\uC6A9\uD574 \uC8FC\uC138\uC694",
    body: "\uADFC\uBB34\uD45C \uBCC0\uACBD\xB7\uACB0\uC7AC \uACB0\uACFC\xB7\uACF5\uC9C0\uB97C \uB193\uCE58\uC9C0 \uC54A\uAC8C \uC54C\uB9BC\uC744 \uCF1C \uB450\uC138\uC694.",
    guideAnchor: "guides/employee-app.html#s21"
  },
  {
    key: AppTutorialStep.SHIFTS,
    order: 2,
    title: "\uB0B4 \uADFC\uBB34\uD45C\uC640 \uCD9C\uD1F4\uADFC",
    body: "\u300C\uADFC\uBB34\u300D \uD0ED\uC5D0\uC11C \uC624\uB298 \uADFC\uBB34\uC640 \uADFC\uBB34\uD45C\uB97C \uBCF4\uACE0, \uCD9C\uADFC\xB7\uD1F4\uADFC \uBC84\uD2BC\uC73C\uB85C \uAE30\uB85D\uD574\uC694.",
    guideAnchor: "guides/employee-app.html#s3"
  },
  {
    key: AppTutorialStep.REQUESTS,
    order: 3,
    title: "\uD734\uAC00\xB7\uC5F0\uC7A5\uADFC\uBB34\uB294 \uC5EC\uAE30\uC11C \uC2E0\uCCAD\uD574\uC694",
    body: "\u300C\uACB0\uC7AC \uC2E0\uCCAD\u300D\uC5D0\uC11C \uD56D\uBAA9\uC744 \uB204\uB974\uBA74 \uC2E0\uCCAD\uC11C\uAC00 \uC5F4\uB824\uC694. \uBCF4\uB0B4\uAE30 \uC804\uC5D0 \uACB0\uC7AC\uC120\uC744 \uD55C \uBC88 \uB354 \uD655\uC778\uD574\uC694.",
    guideAnchor: "guides/employee-app.html#s4"
  },
  {
    key: AppTutorialStep.AI_ASSISTANT,
    order: 4,
    title: "\uAD81\uAE08\uD55C \uAC74 AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8\uC5D0\uAC8C \uBB3C\uC5B4\uBCF4\uC138\uC694",
    body: "\uC790\uC8FC \uD558\uB294 \uC5C5\uBB34 \uBC14\uB85C\uAC00\uAE30, \uC785\uB825\uD558\uBA74 \uB728\uB294 \uD654\uBA74 \uBBF8\uB9AC\uBCF4\uAE30, \uCC44\uD305\uC73C\uB85C \uBB3B\uAE30\uB97C \uCC28\uB840\uB85C \uBCF4\uC5EC \uB4DC\uB824\uC694.",
    guideAnchor: ""
  }
];
var APP_TUTORIAL_SHIFTS_COPY = {
  [AttendanceMethod.APP]: {
    title: "\uCD9C\uADFC\uD558\uBA74 \uC774 \uBC84\uD2BC\uC744 \uB20C\uB7EC\uC694",
    body: "\uB204\uB974\uBA74 \uBC14\uB85C \uAE30\uB85D\uB418\uACE0, \uAE30\uB85D\uB41C \uC2DC\uAC01\uC774 \uCE74\uB4DC\uC5D0 \uB0A8\uC544\uC694. \uD1F4\uADFC\uD560 \uB54C\uB3C4 \uAC19\uC740 \uBC84\uD2BC\uC744 \uB20C\uB7EC\uC694."
  },
  [AttendanceMethod.SECOM]: {
    title: "\uC624\uB298 \uADFC\uBB34\uB97C \uC5EC\uAE30\uC11C \uBD10\uC694",
    body: "\uCD9C\uD1F4\uADFC\uC740 \uC9C0\uBB38 \uB2E8\uB9D0\uAE30\uB85C \uAE30\uB85D\uB3FC\uC694. \uAE30\uB85D\uC774 \uD2C0\uB9AC\uBA74 \u300C\uADFC\uBB34\uAE30\uB85D\u300D\uC5D0\uC11C \uCD9C\uD1F4\uADFC \uC815\uC815\uC744 \uC694\uCCAD\uD574\uC694."
  },
  [AttendanceMethod.MANUAL]: {
    title: "\uC624\uB298 \uADFC\uBB34\uB97C \uC5EC\uAE30\uC11C \uBD10\uC694",
    body: "\uCD9C\uD1F4\uADFC\uC740 \uAD00\uB9AC\uC790\uAC00 \uAE30\uB85D\uD574\uC694. \uAE30\uB85D\uC774 \uD2C0\uB9AC\uBA74 \u300C\uADFC\uBB34\uAE30\uB85D\u300D\uC5D0\uC11C \uCD9C\uD1F4\uADFC \uC815\uC815\uC744 \uC694\uCCAD\uD574\uC694."
  }
};
function appTutorialShiftsCopy(method) {
  return APP_TUTORIAL_SHIFTS_COPY[method] ?? APP_TUTORIAL_SHIFTS_COPY[AttendanceMethod.APP];
}
__name(appTutorialShiftsCopy, "appTutorialShiftsCopy");
var APP_TUTORIAL_AI_SUBSTEPS = [
  {
    title: "\uC790\uC8FC \uD558\uB294 \uC5C5\uBB34\uB294 \uBC14\uB85C \uC5F4\uC5B4\uC694",
    body: "\uBC84\uD2BC\uC744 \uB204\uB974\uBA74 \uBA54\uB274\uB97C \uCC3E\uC544 \uB4E4\uC5B4\uAC08 \uD544\uC694 \uC5C6\uC774 \uADF8 \uD654\uBA74\uC774 \uBC14\uB85C \uC5F4\uB824\uC694."
  },
  {
    title: "\uC785\uB825\uD558\uBA74 \uAC08 \uC218 \uC788\uB294 \uD654\uBA74\uC774 \uBA3C\uC800 \uB5A0\uC694",
    body: "\uC785\uB825\uCE78\uC5D0 \uAE00\uC790\uB97C \uCE58\uBA74 AI \uB2F5\uC744 \uAE30\uB2E4\uB9AC\uC9C0 \uC54A\uACE0, \uB204\uB974\uBA74 \uBC14\uB85C \uC5F4\uB9AC\uB294 \uD654\uBA74\uC744 \uBA3C\uC800 \uBCF4\uC5EC \uC918\uC694."
  },
  {
    title: "\uB9D0\uB85C \uBB3C\uC5B4\uBD10\uB3C4 \uB3FC\uC694",
    body: "\uC774\uB807\uAC8C \uCC44\uD305\uD558\uB4EF \uBB3C\uC5B4\uBCF4\uACE0 \uBCF4\uB0B4\uAE30\uB97C \uB204\uB974\uBA74 \uCC3E\uC544\uC11C \uB2F5\uD574\uC694. \uC2E0\uCCAD\xB7\uC81C\uCD9C\uC740 \uB2F5\uC5D0 \uB098\uC628 \uD654\uBA74\uC5D0\uC11C \uC9C1\uC811 \uD574\uC694."
  }
];
var APP_TUTORIAL_ENTRY_COPY = {
  [AppTutorialStep.REQUESTS]: {
    title: "\uD734\uAC00\xB7\uC5F0\uC7A5\uADFC\uBB34 \uC2E0\uCCAD\uC740 \u300C\uACB0\uC7AC\u300D \uD0ED\uC5D0\uC11C \uD574\uC694",
    body: "\uC544\uB798 \u300C\uACB0\uC7AC\u300D \uD0ED\uC744 \uB20C\uB7EC \uBCF4\uC138\uC694."
  },
  [AppTutorialStep.AI_ASSISTANT]: {
    title: "AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8\uB294 \uC774 \uBC84\uD2BC\uC73C\uB85C \uC5F4\uC5B4\uC694",
    body: "\uC544\uB798 \uC624\uB978\uCABD \uB3D9\uADF8\uB780 \uBC84\uD2BC\uC744 \uB20C\uB7EC \uBCF4\uC138\uC694. \uC5B4\uB290 \uD654\uBA74\uC5D0\uC11C\uB4E0 \uAC19\uC740 \uC790\uB9AC\uC5D0 \uC788\uC5B4\uC694."
  }
};
function enabledAppTutorialSteps(settings) {
  return APP_TUTORIAL_STEP_DEFS.filter((s) => settings.tutorialSteps[s.key]);
}
__name(enabledAppTutorialSteps, "enabledAppTutorialSteps");
var APP_TUTORIAL_VERSION = 2;
var APP_ONBOARDING_CHECKLIST_DEFS = [
  {
    key: AppOnboardingChecklistStep.CONTACTS,
    order: 1,
    label: "\uC5F0\uB77D\uCC98 \uC810\uAC80",
    howTo: "\uD734\uB300\uD3F0\xB7\uC774\uBA54\uC77C\uC774 \uBAA8\uB450 \uBE44\uC5B4 \uC788\uB294 \uC9C1\uC6D0\uC740 \uC548\uB0B4\uB97C \uBC1B\uC744 \uC218 \uC5C6\uC5B4\uC694. \uC9C1\uC6D0 \uAD00\uB9AC\uC5D0\uC11C \uCC44\uC6B0\uAC70\uB098 \uC885\uC774 \uC548\uB0B4\uBB38 \uB300\uC0C1\uC73C\uB85C \uB450\uC138\uC694."
  },
  {
    key: AppOnboardingChecklistStep.PASSWORD_POLICY,
    order: 2,
    label: "\uC784\uC2DC \uBE44\uBC00\uBC88\uD638 \uC815\uCC45 \uD655\uC778",
    howTo: "\uBCD1\uC6D0 \uC124\uC815 \u203A \uBE44\uBC00\uBC88\uD638 \uC815\uCC45\uC5D0\uC11C \uC784\uC2DC \uBE44\uBC00\uBC88\uD638 \uD615\uC2DD(\uACE0\uC815\uAC12/\uBB34\uC791\uC704)\uC744 \uC815\uD574\uC694. \uCCAB \uB85C\uADF8\uC778 \uBCC0\uACBD\uC740 \uD56D\uC0C1 \uAC15\uC81C\uB3FC\uC694."
  },
  {
    key: AppOnboardingChecklistStep.SEND_GUIDE,
    order: 3,
    label: "\uC571 \uC548\uB0B4 \uBC1C\uC1A1",
    howTo: "\uBBF8\uB9AC\uBCF4\uAE30\xB7\uD14C\uC2A4\uD2B8 \uBC1C\uC1A1\uC73C\uB85C \uBB38\uAD6C\uB97C \uD655\uC778\uD55C \uB4A4 \uC804\uCCB4 \uBC1C\uC1A1\uD574\uC694. \uC2E4\uD328 \uAC74\uC740 3\uB2E8\uACC4\uC5D0\uC11C \uB2E4\uC2DC \uBCF4\uB0BC \uC218 \uC788\uC5B4\uC694."
  },
  {
    key: AppOnboardingChecklistStep.INSTALL_STATUS,
    order: 4,
    label: "\uC124\uCE58\xB7\uB85C\uADF8\uC778 \uD604\uD669",
    howTo: "\uD300\uBCC4 \uC124\uCE58\uC728\xB7\uB85C\uADF8\uC778\uC728\uC744 \uBCF4\uACE0 \uBBF8\uC644\uB8CC\uC790\uB97C \uD655\uC778\uD574\uC694. \uC9C1\uC6D0 \uAD00\uB9AC \u300C\uC571 \uC0C1\uD0DC\u300D \uC5F4\uACFC \uAC19\uC740 \uD310\uC815\uC774\uC5D0\uC694."
  },
  {
    key: AppOnboardingChecklistStep.RESEND,
    order: 5,
    label: "\uBBF8\uC644\uB8CC\uC790 \uC7AC\uC548\uB0B4",
    howTo: "\uC544\uC9C1 \uC124\uCE58\xB7\uB85C\uADF8\uC778\uD558\uC9C0 \uC54A\uC740 \uC9C1\uC6D0\uC5D0\uAC8C \uC120\uD0DD \uC7AC\uBC1C\uC1A1\uD558\uAC70\uB098, \uC5F0\uB77D\uCC98\uAC00 \uC5C6\uB294 \uC9C1\uC6D0\uC740 \uC885\uC774 \uC548\uB0B4\uBB38(QR)\uC744 \uC778\uC1C4\uD574\uC694."
  },
  {
    key: AppOnboardingChecklistStep.NOTICE,
    order: 6,
    label: "\uACF5\uC9C0 \uB4F1\uB85D",
    howTo: "\uC9C1\uC6D0 \uC571 \uC548\uB0B4 \uACF5\uC9C0(\uC124\uCE58 \uB9C1\uD06C\xB7\uBB38\uC758\uCC98\xB7\uBD88\uD3B8 \uC2E0\uACE0 \uC548\uB0B4)\uB97C \uD55C \uBC88\uC5D0 \uAC8C\uC2DC\uD574\uC694."
  },
  {
    key: AppOnboardingChecklistStep.COMPLETE,
    order: 7,
    label: "\uC644\uB8CC \uAE30\uC900 \uD310\uC815",
    howTo: "\uBAA9\uD45C \uBE44\uC728\uC5D0 \uB3C4\uB2EC\uD558\uBA74 \uC644\uB8CC\uB85C \uD45C\uC2DC\uB418\uACE0 \uBC30\uD3EC \uC644\uB8CC \uBCF4\uACE0(\uD300\uBCC4 \uC218\uCE58)\uB97C \uB0B4\uB824\uBC1B\uC744 \uC218 \uC788\uC5B4\uC694."
  }
];

// src/enums/approval.enum.ts
var ApprovalRequestType = /* @__PURE__ */ (function(ApprovalRequestType2) {
  ApprovalRequestType2["LEAVE"] = "leave";
  ApprovalRequestType2["OVERTIME"] = "overtime";
  ApprovalRequestType2["OFFSITE_WORK"] = "offsite_work";
  ApprovalRequestType2["INCENTIVE"] = "incentive";
  ApprovalRequestType2["TREATMENT_SESSION"] = "treatment_session";
  ApprovalRequestType2["ATTENDANCE_CORRECTION"] = "attendance_correction";
  return ApprovalRequestType2;
})({});
var ApprovalStepStatus = /* @__PURE__ */ (function(ApprovalStepStatus2) {
  ApprovalStepStatus2["WAITING"] = "waiting";
  ApprovalStepStatus2["PENDING"] = "pending";
  ApprovalStepStatus2["APPROVED"] = "approved";
  ApprovalStepStatus2["REJECTED"] = "rejected";
  ApprovalStepStatus2["SKIPPED"] = "skipped";
  return ApprovalStepStatus2;
})({});

// src/constants/approval-state.ts
function approvalStepReadText(step, format) {
  if (step.status === "pending") {
    if (step.viewedAt) {
      return `\uD655\uC778\uD568 \xB7 ${format(step.viewedAt)}`;
    }
    if (step.viewedAt === void 0 && !step.pendingAt) {
      return "";
    }
    const parts = [];
    if (step.pendingAt) {
      parts.push(`\uC54C\uB9BC \uBCF4\uB0C4 \xB7 ${format(step.pendingAt)}`);
    }
    parts.push("\uC544\uC9C1 \uD655\uC778 \uC804");
    if (step.remindedAt) {
      parts.push(`\uB2E4\uC2DC \uC54C\uB9BC ${format(step.remindedAt)}`);
    }
    return parts.join(" \xB7 ");
  }
  if ((step.status === "approved" || step.status === "rejected") && step.viewedAt) {
    return `\uD655\uC778 ${format(step.viewedAt)}`;
  }
  return "";
}
__name(approvalStepReadText, "approvalStepReadText");
var APPROVAL_REMINDER_HOURS_DEFAULT = 24;
var APPROVAL_REMINDER_HOURS_MAX = 168;
function resolveApprovalReminderHours(raw) {
  const n = typeof raw === "number" && Number.isFinite(raw) ? Math.trunc(raw) : Number.NaN;
  if (Number.isNaN(n)) {
    return APPROVAL_REMINDER_HOURS_DEFAULT;
  }
  return Math.min(APPROVAL_REMINDER_HOURS_MAX, Math.max(0, n));
}
__name(resolveApprovalReminderHours, "resolveApprovalReminderHours");
function approvalReminderDue(step, now, hours) {
  if (hours <= 0 || step.status !== "pending" || step.viewedAt || step.remindedAt || !step.pendingAt) {
    return false;
  }
  const since = new Date(step.pendingAt).getTime();
  return Number.isFinite(since) && now - since >= hours * 60 * 60 * 1e3;
}
__name(approvalReminderDue, "approvalReminderDue");
function approvalRowState(state, isPending) {
  if (!isPending) {
    return "closed";
  }
  if (!state || state.isLegacy) {
    return "legacy";
  }
  if (state.mine) {
    return "mine";
  }
  if (state.canDelegate) {
    return "delegate";
  }
  return "others";
}
__name(approvalRowState, "approvalRowState");
function approvalRowActionable(row) {
  return row === "mine" || row === "delegate" || row === "legacy";
}
__name(approvalRowActionable, "approvalRowActionable");
function approvalProgressLabel(state, isPending, opts = {}) {
  if (!state || state.isLegacy) {
    return isPending ? "\uACB0\uC7AC\uC790 \uC9C0\uC815 \uC5C6\uC74C" : "";
  }
  if (isPending && state.currentStepOrder !== null) {
    const step = `${state.currentStepOrder}/${state.totalSteps}`;
    if (state.mine) {
      return `\uB0B4 \uCC28\uB840 \xB7 ${step}`;
    }
    if (opts.withName === false) {
      return `\uD655\uC778 \uC911 \xB7 ${step}`;
    }
    return `${state.currentApproverName ?? "\uACB0\uC7AC\uC790"} \uB2D8 \uD655\uC778 \uC911 \xB7 ${step}`;
  }
  if (state.outcome === "approved") {
    return `${state.totalSteps}/${state.totalSteps} \uC644\uB8CC`;
  }
  if (state.outcome === "rejected") {
    return "\uBC18\uB824\uB428";
  }
  return "";
}
__name(approvalProgressLabel, "approvalProgressLabel");
function approvalNextLabel(state) {
  return state?.nextApproverName ? `\u2192 ${state.nextApproverName}` : null;
}
__name(approvalNextLabel, "approvalNextLabel");
function approvalStatusDetail(state, isPending) {
  if (!(isPending && state) || state.isLegacy || state.currentStepOrder === null) {
    return null;
  }
  const base = `${state.currentStepOrder}/${state.totalSteps}\uB2E8\uACC4 ${state.currentApproverName ?? ""} \uB2D8`.replace("  ", " ");
  if (state.currentViewedAt === null) {
    return `${base} \xB7 \uD655\uC778 \uC804`;
  }
  if (state.currentViewedAt) {
    return `${base} \xB7 \uD655\uC778\uD568`;
  }
  return base;
}
__name(approvalStatusDetail, "approvalStatusDetail");
function approvalDecisionHint(state, decision) {
  const delegatePrefix = state && !state.isLegacy && state.canDelegate && !state.mine && state.currentApproverName ? `${state.currentApproverName} \uB2D8 \uB300\uC2E0 \uCC98\uB9AC\uB3FC\uC694 \xB7 ` : "";
  if (decision === "rejected") {
    return `${delegatePrefix}\uBC18\uB824\uD558\uBA74 \uC2E0\uCCAD\uC790\uC5D0\uAC8C \uBC14\uB85C \uC54C\uB824\uC694`;
  }
  if (state?.nextApproverName) {
    return `${delegatePrefix}\uC2B9\uC778\uD558\uBA74 ${state.nextApproverName} \uB2D8\uC5D0\uAC8C \uB118\uC5B4\uAC00\uC694`;
  }
  return `${delegatePrefix}\uCD5C\uC885 \uC2B9\uC778\uB3FC\uC694`;
}
__name(approvalDecisionHint, "approvalDecisionHint");
function approvalStepReplaceable(status) {
  return status === ApprovalStepStatus.PENDING || status === ApprovalStepStatus.WAITING;
}
__name(approvalStepReplaceable, "approvalStepReplaceable");
function approvalReplaceHint(step, toName) {
  const head = `${step.approverName} \uB2D8 \u2192 ${toName} \uB2D8\uC73C\uB85C \uBC14\uAFD4\uC694.`;
  if (step.status === ApprovalStepStatus.PENDING) {
    return `${head} ${toName} \uB2D8\uC5D0\uAC8C \uACB0\uC7AC\uD560 \uBB38\uC11C \uC54C\uB9BC\uC774 \uAC00\uACE0, ${step.approverName} \uB2D8\uC758 \uACB0\uC7AC\uD568\uC5D0\uC11C\uB294 \uBE60\uC838\uC694.`;
  }
  return `${head} \uCC28\uB840\uAC00 \uB418\uBA74 ${toName} \uB2D8\uC5D0\uAC8C \uC54C\uB9BC\uC774 \uAC00\uC694.`;
}
__name(approvalReplaceHint, "approvalReplaceHint");
function approvalOthersTurnMessage(state) {
  return state?.currentApproverName ? `\uC9C0\uAE08\uC740 ${state.currentApproverName} \uB2D8 \uCC28\uB840\uC608\uC694` : "\uC9C0\uAE08\uC740 \uB2E4\uB978 \uC0AC\uB78C \uCC28\uB840\uC608\uC694";
}
__name(approvalOthersTurnMessage, "approvalOthersTurnMessage");
var APPROVAL_STEP_STATUS_VIEW = {
  [ApprovalStepStatus.WAITING]: {
    label: "\uB300\uAE30",
    tone: "light-gray"
  },
  [ApprovalStepStatus.PENDING]: {
    label: "\uD655\uC778 \uC911",
    tone: "yellow"
  },
  [ApprovalStepStatus.APPROVED]: {
    label: "\uC2B9\uC778",
    tone: "green"
  },
  [ApprovalStepStatus.REJECTED]: {
    label: "\uBC18\uB824",
    tone: "red"
  },
  [ApprovalStepStatus.SKIPPED]: {
    label: "\uAC74\uB108\uB700",
    tone: "gray"
  }
};
function approvalStepStatusView(status) {
  return APPROVAL_STEP_STATUS_VIEW[status] ?? {
    label: status,
    tone: "light-gray"
  };
}
__name(approvalStepStatusView, "approvalStepStatusView");
function approvalOutcomeFromSteps(steps) {
  if (steps.length === 0 || steps.some((s) => s.status === ApprovalStepStatus.PENDING)) {
    return null;
  }
  if (steps.some((s) => s.status === ApprovalStepStatus.REJECTED)) {
    return "rejected";
  }
  return steps.every((s) => s.status === ApprovalStepStatus.APPROVED) ? "approved" : null;
}
__name(approvalOutcomeFromSteps, "approvalOutcomeFromSteps");

// src/constants/approval-types.ts
var APPROVAL_TYPE_CATALOG = [
  {
    type: ApprovalRequestType.LEAVE,
    label: "\uD734\uAC00",
    lineEnabledByDefault: true,
    fallbackLabel: "\uD734\uAC00 \uC2B9\uC778 \uAD8C\uD55C\uC774 \uC788\uB294 \uBD84"
  },
  {
    type: ApprovalRequestType.OVERTIME,
    label: "\uC5F0\uC7A5\uADFC\uBB34",
    lineEnabledByDefault: true,
    fallbackLabel: "\uC5F0\uC7A5\uADFC\uBB34 \uC2B9\uC778 \uAD8C\uD55C\uC774 \uC788\uB294 \uBD84"
  },
  {
    type: ApprovalRequestType.OFFSITE_WORK,
    label: "\uC678\uADFC",
    lineEnabledByDefault: true,
    fallbackLabel: "\uC678\uADFC \uC2B9\uC778 \uAD8C\uD55C\uC774 \uC788\uB294 \uBD84"
  },
  {
    type: ApprovalRequestType.INCENTIVE,
    label: "\uC778\uC13C\uD2F0\uBE0C",
    lineEnabledByDefault: true,
    fallbackLabel: "\uC778\uC13C\uD2F0\uBE0C \uC2B9\uC778 \uAD8C\uD55C\uC774 \uC788\uB294 \uBD84"
  },
  {
    type: ApprovalRequestType.TREATMENT_SESSION,
    label: "\uCE58\uB8CC \uC138\uC158",
    lineEnabledByDefault: true,
    fallbackLabel: "\uC778\uC13C\uD2F0\uBE0C \uC2B9\uC778 \uAD8C\uD55C\uC774 \uC788\uB294 \uBD84"
  },
  // 2026-10-02 「승인은 관리자만」 결정을 초기값으로 — 병원이 켜면 팀장 등 결재선의 결재자가 차례로 처리한다
  {
    type: ApprovalRequestType.ATTENDANCE_CORRECTION,
    label: "\uCD9C\uD1F4\uADFC \uC815\uC815",
    lineEnabledByDefault: false,
    fallbackLabel: "\uADFC\uD0DC \uC2B9\uC778 \uAD8C\uD55C\uC774 \uC788\uB294 \uAD00\uB9AC\uC790"
  }
];
var APPROVAL_TYPE_LABEL = Object.fromEntries(APPROVAL_TYPE_CATALOG.map((t) => [
  t.type,
  t.label
]));
function approvalTypeInfo(type) {
  return APPROVAL_TYPE_CATALOG.find((t) => t.type === type) ?? null;
}
__name(approvalTypeInfo, "approvalTypeInfo");
function approvalLineEnabledFor(overrides, type) {
  const info = approvalTypeInfo(type);
  if (!info) {
    return false;
  }
  const saved = overrides?.[type];
  return typeof saved === "boolean" ? saved : info.lineEnabledByDefault;
}
__name(approvalLineEnabledFor, "approvalLineEnabledFor");
function approvalLineEnabledTypes(overrides) {
  return APPROVAL_TYPE_CATALOG.filter((t) => approvalLineEnabledFor(overrides, t.type)).map((t) => t.type);
}
__name(approvalLineEnabledTypes, "approvalLineEnabledTypes");
function parseApprovalLineEnabled(raw) {
  const out = {};
  if (!raw || typeof raw !== "object") {
    return out;
  }
  for (const [key, value] of Object.entries(raw)) {
    if (typeof value === "boolean" && approvalTypeInfo(key)) {
      out[key] = value;
    }
  }
  return out;
}
__name(parseApprovalLineEnabled, "parseApprovalLineEnabled");
var APPROVAL_VISIBILITY_DEFAULT = "line";
function resolveApprovalVisibility(raw) {
  return raw === "scope" ? "scope" : APPROVAL_VISIBILITY_DEFAULT;
}
__name(resolveApprovalVisibility, "resolveApprovalVisibility");

// src/constants/attendance.ts
var ATTENDANCE_DEFAULT_CHECK_IN = "09:00";
var ATTENDANCE_DEFAULT_CHECK_OUT = "18:00";
var SHIFT_RESOLUTION_SOURCE_LABELS = {
  [ShiftResolutionSource.SCHEDULE]: "\uADFC\uBB34\uD45C \uBC30\uC815",
  [ShiftResolutionSource.EMPLOYEE_SHIFT]: "\uC9C1\uC6D0 \uADFC\uBB34 \uBC30\uC815",
  [ShiftResolutionSource.GROUP_SHIFT]: "\uADFC\uBB34 \uADF8\uB8F9 \uC790\uB3D9 \uC120\uD0DD",
  [ShiftResolutionSource.WORK_PATTERN_DEFAULT]: "\uADFC\uB85C\uD615\uD0DC \uAE30\uBCF8 \uADFC\uBB34",
  [ShiftResolutionSource.JOB_DUTY_DEFAULT]: "\uC9C1\uBB34 \uAE30\uBCF8 \uADFC\uBB34",
  [ShiftResolutionSource.TEAM_REPRESENTATIVE]: "\uD300 \uB300\uD45C \uADFC\uBB34",
  [ShiftResolutionSource.ORG_DEFAULT_SHIFT]: "\uC870\uC9C1 \uAE30\uBCF8 \uADFC\uBB34\uD615\uD0DC",
  [ShiftResolutionSource.ORG_DEFAULT_TIME]: "\uC870\uC9C1 \uAE30\uBCF8 \uAE30\uC900\uC2DC\uAC04",
  [ShiftResolutionSource.OFF_DAY]: "\uC26C\uB294 \uC694\uC77C",
  // 아래 둘은 2026-09-22 이전 지문 전용 사다리가 남긴 기록의 표시용 — 새 기록은 위 여섯 값만 쓴다
  [ShiftResolutionSource.INFERRED]: "\uC9C0\uBB38 \uC790\uB3D9 \uCD94\uC815",
  [ShiftResolutionSource.PREVIOUS]: "\uC774\uC804 \uAE30\uB85D \uC720\uC9C0"
};
var SHIFT_ASSIGNMENT_SOURCE_LABELS = {
  [ShiftAssignmentSource.MANUAL]: "\uC9C1\uC811 \uC120\uD0DD",
  [ShiftAssignmentSource.WORK_PATTERN_DEFAULT]: "\uADFC\uB85C\uD615\uD0DC \uAE30\uBCF8 \uADFC\uBB34",
  [ShiftAssignmentSource.JOB_DUTY_DEFAULT]: "\uC9C1\uBB34 \uAE30\uBCF8 \uADFC\uBB34",
  [ShiftAssignmentSource.TEAM_REPRESENTATIVE]: "\uD300 \uB300\uD45C \uADFC\uBB34",
  [ShiftAssignmentSource.BULK_ASSIGN]: "\uC77C\uAD04 \uBC30\uC815",
  [ShiftAssignmentSource.BULK_UPLOAD]: "\uC5D1\uC140 \uB300\uB7C9 \uCD94\uAC00",
  [ShiftAssignmentSource.SHEET]: "\uC9C1\uC6D0 \uB9C8\uC2A4\uD130 \uC2DC\uD2B8",
  [ShiftAssignmentSource.SELF]: "\uC9C1\uC6D0 \uC571 \uC790\uAE30 \uC120\uD0DD",
  [ShiftAssignmentSource.CARRIED]: "\uAE30\uC874 \uADFC\uBB34 \uC720\uC9C0",
  [ShiftAssignmentSource.MIGRATION]: "\uC774\uC804 \uB370\uC774\uD130"
};
var SECOM_PUNCH_EVENT_TYPES = [
  "1",
  "2"
];
function isSecomPunchEventType(rawEventType) {
  return rawEventType != null && SECOM_PUNCH_EVENT_TYPES.includes(String(rawEventType).trim());
}
__name(isSecomPunchEventType, "isSecomPunchEventType");
var ATTENDANCE_RECORD_SOURCE_LABELS = {
  secom: "\uC9C0\uBB38",
  app: "\uC571",
  manual: "\uAD00\uB9AC\uC790 \uC785\uB825"
};
function attendanceRecordSourceLabel(source) {
  return source === "secom" || source === "app" || source === "manual" ? ATTENDANCE_RECORD_SOURCE_LABELS[source] : "";
}
__name(attendanceRecordSourceLabel, "attendanceRecordSourceLabel");

// src/constants/certificate-request-fields.ts
var CERTIFICATE_REQUEST_FIELD_KEYS = [
  "purpose",
  "submitTo",
  "address",
  "quantity",
  "note"
];
var CERTIFICATE_REQUEST_FIELD_CATALOG = [
  {
    key: "purpose",
    label: "\uC6A9\uB3C4",
    variableKey: "purpose",
    inputType: "text",
    placeholder: "\uC608: \uAE08\uC735\uAE30\uAD00 \uC81C\uCD9C\uC6A9",
    alwaysOn: true
  },
  {
    key: "submitTo",
    label: "\uC81C\uCD9C\uCC98",
    variableKey: "submitTo",
    inputType: "text",
    placeholder: "\uC608: \u25CB\u25CB\uC740\uD589 \uAC15\uB0A8\uC9C0\uC810"
  },
  {
    key: "address",
    label: "\uC8FC\uC18C",
    variableKey: "address",
    inputType: "text",
    placeholder: "\uC99D\uBA85\uC11C\uC5D0 \uC778\uC1C4\uD560 \uC8FC\uC18C",
    hint: "\uBE44\uC6CC \uB450\uBA74 \uC778\uC0AC \uC815\uBCF4\uC5D0 \uB4F1\uB85D\uB41C \uC8FC\uC18C\uAC00 \uC778\uC1C4\uB3FC\uC694."
  },
  {
    key: "quantity",
    label: "\uC218\uB7C9",
    variableKey: "quantity",
    inputType: "number",
    placeholder: "1"
  },
  {
    key: "note",
    label: "\uBE44\uACE0",
    variableKey: "requestNote",
    inputType: "textarea",
    placeholder: "\uB2F4\uB2F9\uC790\uC5D0\uAC8C \uC804\uB2EC\uD560 \uB0B4\uC6A9"
  }
];
var DEFAULT_CERTIFICATE_REQUEST_FIELDS = [
  {
    key: "purpose",
    required: true
  },
  {
    key: "submitTo",
    required: false
  },
  {
    key: "address",
    required: false
  },
  {
    key: "quantity",
    required: false
  },
  {
    key: "note",
    required: false
  }
];
function resolveCertificateRequestFields(config) {
  const source = config ?? DEFAULT_CERTIFICATE_REQUEST_FIELDS;
  const byKey = /* @__PURE__ */ new Map();
  for (const c of source) {
    if (!byKey.has(c.key)) {
      byKey.set(c.key, c.required);
    }
  }
  const out = [];
  for (const def of CERTIFICATE_REQUEST_FIELD_CATALOG) {
    if (def.alwaysOn) {
      out.push({
        ...def,
        required: true
      });
      continue;
    }
    if (byKey.has(def.key)) {
      out.push({
        ...def,
        required: byKey.get(def.key) === true
      });
    }
  }
  return out;
}
__name(resolveCertificateRequestFields, "resolveCertificateRequestFields");
function missingRequiredCertificateFields(fields, values) {
  const missing = [];
  for (const f of fields) {
    if (!f.required) {
      continue;
    }
    const v = values[f.key];
    const empty = v === null || v === void 0 || String(v).trim() === "";
    if (empty) {
      missing.push(f.label);
    }
  }
  return missing;
}
__name(missingRequiredCertificateFields, "missingRequiredCertificateFields");
function isCertificateTemplateCode(code) {
  return code.endsWith("_cert");
}
__name(isCertificateTemplateCode, "isCertificateTemplateCode");

// src/enums/employee.enum.ts
var CertificationType = /* @__PURE__ */ (function(CertificationType2) {
  CertificationType2["NURSING"] = "nursing";
  CertificationType2["NURSE_AIDE"] = "nurse_aide";
  CertificationType2["PHYSICAL_THERAPIST"] = "physical_therapist";
  CertificationType2["OCCUPATIONAL_THERAPIST"] = "occupational_therapist";
  CertificationType2["SPEECH_THERAPIST"] = "speech_therapist";
  CertificationType2["RADIOLOGIST"] = "radiologist";
  CertificationType2["CLINICAL_LAB"] = "clinical_lab";
  CertificationType2["PHARMACIST"] = "pharmacist";
  CertificationType2["DIETITIAN"] = "dietitian";
  CertificationType2["SOCIAL_WORKER"] = "social_worker";
  CertificationType2["MEDICAL_DOCTOR"] = "medical_doctor";
  CertificationType2["DENTIST"] = "dentist";
  CertificationType2["EMERGENCY_MEDICAL"] = "emergency_medical";
  CertificationType2["CARE_WORKER"] = "care_worker";
  CertificationType2["OTHER"] = "other";
  return CertificationType2;
})({});
var JobCategory = /* @__PURE__ */ (function(JobCategory2) {
  JobCategory2["NURSE"] = "nurse";
  JobCategory2["NURSE_AIDE"] = "nurse_aide";
  JobCategory2["CARE_WORKER"] = "care_worker";
  JobCategory2["WARD_SUPPORT"] = "ward_support";
  JobCategory2["PHYSICIAN"] = "physician";
  JobCategory2["THERAPIST"] = "therapist";
  JobCategory2["MEDICAL_TECHNICIAN"] = "medical_technician";
  JobCategory2["PHARMACIST"] = "pharmacist";
  JobCategory2["NUTRITION"] = "nutrition";
  JobCategory2["SOCIAL_WORKER"] = "social_worker";
  JobCategory2["ADMINISTRATION"] = "administration";
  JobCategory2["FACILITY"] = "facility";
  JobCategory2["OTHER"] = "other";
  return JobCategory2;
})({});

// src/constants/certification.ts
var CERT_TYPE_LABELS = {
  [CertificationType.NURSING]: "\uAC04\uD638\uC0AC",
  [CertificationType.NURSE_AIDE]: "\uAC04\uD638\uC870\uBB34\uC0AC",
  [CertificationType.PHYSICAL_THERAPIST]: "\uBB3C\uB9AC\uCE58\uB8CC\uC0AC",
  [CertificationType.OCCUPATIONAL_THERAPIST]: "\uC791\uC5C5\uCE58\uB8CC\uC0AC",
  [CertificationType.SPEECH_THERAPIST]: "\uC5B8\uC5B4\uCE58\uB8CC\uC0AC",
  [CertificationType.RADIOLOGIST]: "\uBC29\uC0AC\uC120\uC0AC",
  [CertificationType.CLINICAL_LAB]: "\uC784\uC0C1\uBCD1\uB9AC\uC0AC",
  [CertificationType.PHARMACIST]: "\uC57D\uC0AC",
  [CertificationType.DIETITIAN]: "\uC601\uC591\uC0AC",
  [CertificationType.SOCIAL_WORKER]: "\uC0AC\uD68C\uBCF5\uC9C0\uC0AC",
  [CertificationType.MEDICAL_DOCTOR]: "\uC758\uC0AC",
  [CertificationType.DENTIST]: "\uCE58\uACFC\uC758\uC0AC",
  [CertificationType.EMERGENCY_MEDICAL]: "\uC751\uAE09\uAD6C\uC870\uC0AC",
  [CertificationType.CARE_WORKER]: "\uC694\uC591\uBCF4\uD638\uC0AC",
  [CertificationType.OTHER]: "\uAE30\uD0C0"
};
var LICENSE_SUFFIX_TYPES = /* @__PURE__ */ new Set([
  CertificationType.NURSING,
  CertificationType.MEDICAL_DOCTOR,
  CertificationType.DENTIST,
  CertificationType.PHARMACIST
]);
function defaultCertLicenseName(code) {
  const label = CERT_TYPE_LABELS[code] ?? code;
  if (code === CertificationType.OTHER) {
    return "";
  }
  return LICENSE_SUFFIX_TYPES.has(code) ? `${label} \uBA74\uD5C8\uC99D` : `${label} \uC790\uACA9\uC99D`;
}
__name(defaultCertLicenseName, "defaultCertLicenseName");
var DEFAULT_CERT_FIELD_TEMPLATE = [
  {
    key: "license_name",
    name: "\uBA74\uD5C8\uC99D\uBA85",
    type: "text",
    required: true
  },
  {
    key: "license_number",
    name: "\uBA74\uD5C8\uBC88\uD638",
    type: "text",
    required: true
  },
  {
    key: "issuing_authority",
    name: "\uBC1C\uAE09\uAE30\uAD00",
    type: "text",
    required: true
  },
  {
    key: "issue_date",
    name: "\uBC1C\uAE09\uC77C",
    type: "date",
    required: true
  },
  {
    key: "file",
    name: "\uC6D0\uBCF8 \uD30C\uC77C",
    type: "file",
    required: true
  },
  {
    key: "last_reported_date",
    name: "\uCD5C\uADFC \uBA74\uD5C8 \uC2E0\uACE0\uC77C",
    type: "date",
    required: false
  },
  {
    key: "next_reporting_deadline",
    name: "\uCC28\uAE30 \uBA74\uD5C8 \uC2E0\uACE0\uC77C",
    type: "date",
    required: false
  }
];
var CERT_FIELD_COLUMN_MAP = {
  license_name: "name",
  license_number: "licenseNumber",
  issuing_authority: "issuingAuthority",
  issue_date: "issueDate",
  last_reported_date: "lastReportedDate",
  next_reporting_deadline: "nextReportingDeadline",
  file: "storagePath"
};
function defaultCertFields(code) {
  const licenseName = defaultCertLicenseName(code);
  return DEFAULT_CERT_FIELD_TEMPLATE.map((f) => f.key === "license_name" && licenseName ? {
    ...f,
    defaultValue: licenseName
  } : {
    ...f
  });
}
__name(defaultCertFields, "defaultCertFields");
var DEFAULT_CERTIFICATION_TYPES = Object.values(CertificationType).map((code) => ({
  code,
  name: CERT_TYPE_LABELS[code] ?? code,
  fields: defaultCertFields(code)
}));

// src/constants/document-templates.ts
var FORM_TEMPLATE_CODES = {
  LEAVE_REQUEST: "leave_request_form",
  OVERTIME_REQUEST: "overtime_request_form",
  OFFSITE_WORK: "offsite_work_form",
  PURCHASE_REQUEST: "purchase_request_form",
  HR_APPOINTMENT: "hr_appointment_form",
  EXPENSE_REPORT: "expense_report_form",
  BUSINESS_TRIP: "business_trip_form",
  RESIGNATION: "resignation_form",
  LEAVE_OF_ABSENCE: "leave_of_absence_form"
};
var FORM_BASE_CSS = `.approval-line{width:auto;margin:0 0 24px auto}
.approval-line th{width:auto;min-width:72px;text-align:center;font-size:12px;padding:4px 10px}
.approval-line td{width:auto;height:52px;font-size:12px;text-align:center;vertical-align:bottom;padding:4px 10px}
.items-table th,.items-table td{width:auto;text-align:center}
.items-table td{height:30px}
.blank-lg{height:80px}
.sign{text-align:right;font-size:15px;margin-top:32px}`;
var CERTIFICATE_PRESETS = [
  {
    code: "employment_cert",
    name: "\uC7AC\uC9C1\uC99D\uBA85\uC11C",
    description: "\uD604\uC7AC \uC7AC\uC9C1 \uC911\uC784\uC744 \uC99D\uBA85\uD558\uB294 \uBB38\uC11C",
    sortOrder: 1,
    kind: "certificate",
    bodyTemplate: `<h1>\uC7AC \uC9C1 \uC99D \uBA85 \uC11C</h1>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0DD\uB144\uC6D4\uC77C</th><td>{{\uC0DD\uB144\uC6D4\uC77C}}</td></tr>
  <tr><th>\uC8FC \uC18C</th><td>{{\uC8FC\uC18C}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uC785\uC0AC\uC77C</th><td>{{\uC785\uC0AC\uC77C}}</td></tr>
</table>

<div class="statement">
  \uC704 \uC0AC\uB78C\uC740 \uD604\uC7AC \uBCF8 \uAE30\uAD00\uC5D0 \uC7AC\uC9C1\uD558\uACE0 \uC788\uC74C\uC744 \uC99D\uBA85\uD569\uB2C8\uB2E4.
</div>

<div class="purpose">
  \uC6A9 \uB3C4: <strong>{{\uC6A9\uB3C4}}</strong>
</div>

<div class="date">{{\uBC1C\uAE09\uC77C}}</div>`
  },
  {
    code: "career_cert",
    name: "\uACBD\uB825\uC99D\uBA85\uC11C",
    description: "\uC7AC\uC9C1 \uACBD\uB825\uC744 \uC99D\uBA85\uD558\uB294 \uBB38\uC11C",
    sortOrder: 2,
    kind: "certificate",
    bodyTemplate: `<h1>\uACBD \uB825 \uC99D \uBA85 \uC11C</h1>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0DD\uB144\uC6D4\uC77C</th><td>{{\uC0DD\uB144\uC6D4\uC77C}}</td></tr>
  <tr><th>\uC8FC \uC18C</th><td>{{\uC8FC\uC18C}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uC7AC\uC9C1\uAE30\uAC04</th><td>{{\uC785\uC0AC\uC77C}} ~ \uD604\uC7AC</td></tr>
</table>

<div class="statement">
  \uC704 \uC0AC\uB78C\uC774 \uC0C1\uAE30 \uAE30\uAC04 \uB3D9\uC548 \uBCF8 \uAE30\uAD00\uC5D0\uC11C \uADFC\uBB34\uD558\uC600\uC74C\uC744 \uC99D\uBA85\uD569\uB2C8\uB2E4.
</div>

<div class="purpose">
  \uC6A9 \uB3C4: <strong>{{\uC6A9\uB3C4}}</strong>
</div>

<div class="date">{{\uBC1C\uAE09\uC77C}}</div>`
  },
  {
    code: "resignation_cert",
    name: "\uD1F4\uC9C1\uC99D\uBA85\uC11C",
    description: "\uD1F4\uC9C1 \uC0AC\uC2E4\uC744 \uC99D\uBA85\uD558\uB294 \uBB38\uC11C",
    sortOrder: 3,
    kind: "certificate",
    bodyTemplate: `<h1>\uD1F4 \uC9C1 \uC99D \uBA85 \uC11C</h1>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0DD\uB144\uC6D4\uC77C</th><td>{{\uC0DD\uB144\uC6D4\uC77C}}</td></tr>
  <tr><th>\uC8FC \uC18C</th><td>{{\uC8FC\uC18C}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uC785\uC0AC\uC77C</th><td>{{\uC785\uC0AC\uC77C}}</td></tr>
  <tr><th>\uD1F4\uC0AC\uC77C</th><td></td></tr>
  <tr><th>\uD1F4\uC9C1\uC0AC\uC720</th><td></td></tr>
</table>

<div class="statement">
  \uC704 \uC0AC\uB78C\uC774 \uBCF8 \uAE30\uAD00\uC5D0\uC11C \uADFC\uBB34\uD558\uB2E4 \uC0C1\uAE30 \uC77C\uC790\uC5D0 \uD1F4\uC9C1\uD558\uC600\uC74C\uC744 \uC99D\uBA85\uD569\uB2C8\uB2E4.
</div>

<div class="purpose">
  \uC6A9 \uB3C4: <strong>{{\uC6A9\uB3C4}}</strong>
</div>

<div class="date">{{\uBC1C\uAE09\uC77C}}</div>`
  }
];
var FORM_PRESETS = [
  {
    code: FORM_TEMPLATE_CODES.LEAVE_REQUEST,
    name: "\uD734\uAC00\uC2E0\uCCAD\uC11C",
    description: "\uD734\uAC00 \uC2E0\uCCAD \uACB0\uC7AC \uC11C\uC2DD (\uC804\uC790\uACB0\uC7AC \uD734\uAC00 \uAC74 \uCD9C\uB825\uC5D0 \uC0AC\uC6A9)",
    sortOrder: 10,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uD734 \uAC00 \uC2E0 \uCCAD \uC11C</h1>

<table class="approval-line">
  <tr><th>\uC2E0 \uCCAD</th><th>\uAC80 \uD1A0</th><th>\uC2B9 \uC778</th></tr>
  <tr><td>{{\uC131\uBA85}} {{\uC11C\uBA85}}</td><td></td><td>{{\uC2B9\uC778\uC790}}</td></tr>
</table>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uD734\uAC00 \uC885\uB958</th><td>{{\uD734\uAC00\uC885\uB958}}</td></tr>
  <tr><th>\uD734\uAC00 \uAE30\uAC04</th><td>{{\uD734\uAC00\uAE30\uAC04}}</td></tr>
  <tr><th>\uD734\uAC00 \uC77C\uC218</th><td>{{\uD734\uAC00\uC77C\uC218}}</td></tr>
  <tr><th>\uC0AC \uC720</th><td>{{\uD734\uAC00\uC0AC\uC720}}</td></tr>
  <tr><th>\uBE44\uC0C1 \uC5F0\uB77D\uCC98</th><td></td></tr>
</table>

<div class="statement">
  \uC704\uC640 \uAC19\uC774 \uD734\uAC00\uB97C \uC2E0\uCCAD\uD558\uC624\uB2C8 \uD5C8\uAC00\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uC2E0\uCCAD\uC77C}}</div>

<div class="sign">\uC2E0\uCCAD\uC778: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  },
  {
    code: FORM_TEMPLATE_CODES.OVERTIME_REQUEST,
    name: "\uC2DC\uAC04\uC678\uADFC\uBB34\uC2E0\uCCAD\uC11C",
    description: "\uC2DC\uAC04\uC678(\uC5F0\uC7A5) \uADFC\uBB34 \uC2E0\uCCAD \uACB0\uC7AC \uC11C\uC2DD (\uC804\uC790\uACB0\uC7AC \uC5F0\uC7A5\uADFC\uBB34 \uAC74 \uCD9C\uB825\uC5D0 \uC0AC\uC6A9)",
    sortOrder: 11,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uC2DC \uAC04 \uC678 \uADFC \uBB34 \uC2E0 \uCCAD \uC11C</h1>

<table class="approval-line">
  <tr><th>\uC2E0 \uCCAD</th><th>\uAC80 \uD1A0</th><th>\uC2B9 \uC778</th></tr>
  <tr><td>{{\uC131\uBA85}} {{\uC11C\uBA85}}</td><td></td><td>{{\uC2B9\uC778\uC790}}</td></tr>
</table>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uADFC\uBB34 \uC77C\uC790</th><td>{{\uADFC\uBB34\uC77C\uC790}}</td></tr>
  <tr><th>\uADFC\uBB34 \uC2DC\uAC04</th><td>{{\uADFC\uBB34\uC2DC\uAC04}}</td></tr>
  <tr><th>\uC5F0\uC7A5 \uC2DC\uAC04</th><td>{{\uC5F0\uC7A5\uC2DC\uAC04}}</td></tr>
  <tr><th>\uADFC\uBB34 \uC720\uD615</th><td>{{\uADFC\uBB34\uC720\uD615}}</td></tr>
  <tr><th>\uC5C5\uBB34 \uB0B4\uC6A9</th><td>{{\uADFC\uBB34\uB0B4\uC6A9}}</td></tr>
</table>

<div class="statement">
  \uC704\uC640 \uAC19\uC774 \uC2DC\uAC04\uC678 \uADFC\uBB34\uB97C \uC2E0\uCCAD\uD558\uC624\uB2C8 \uD5C8\uAC00\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uC2E0\uCCAD\uC77C}}</div>

<div class="sign">\uC2E0\uCCAD\uC778: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  },
  {
    code: FORM_TEMPLATE_CODES.OFFSITE_WORK,
    name: "\uC678\uADFC\uC2E0\uCCAD\uC11C",
    description: "\uC678\uADFC \uC2E0\uCCAD \uACB0\uC7AC \uC11C\uC2DD (\uC804\uC790\uACB0\uC7AC \uC678\uADFC \uAC74 \uCD9C\uB825\uC5D0 \uC0AC\uC6A9)",
    sortOrder: 12,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uC678 \uADFC \uC2E0 \uCCAD \uC11C</h1>

<table class="approval-line">
  <tr><th>\uC2E0 \uCCAD</th><th>\uAC80 \uD1A0</th><th>\uC2B9 \uC778</th></tr>
  <tr><td>{{\uC131\uBA85}} {{\uC11C\uBA85}}</td><td></td><td>{{\uC2B9\uC778\uC790}}</td></tr>
</table>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uC678\uADFC \uC77C\uC790</th><td>{{\uC678\uADFC\uC77C\uC790}}</td></tr>
  <tr><th>\uC678\uADFC \uC2DC\uAC04</th><td>{{\uC678\uADFC\uC2DC\uAC04}}</td></tr>
  <tr><th>\uC678\uADFC \uC7A5\uC18C</th><td>{{\uC678\uADFC\uC7A5\uC18C}}</td></tr>
  <tr><th>\uC678\uADFC \uC720\uD615</th><td>{{\uC678\uADFC\uC720\uD615}}</td></tr>
  <tr><th>\uC5C5\uBB34 \uB0B4\uC6A9</th><td>{{\uC678\uADFC\uB0B4\uC6A9}}</td></tr>
  <tr><th>\uC774\uB3D9 \uC218\uB2E8</th><td></td></tr>
</table>

<div class="statement">
  \uC704\uC640 \uAC19\uC774 \uC678\uADFC\uC744 \uC2E0\uCCAD\uD558\uC624\uB2C8 \uD5C8\uAC00\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uC2E0\uCCAD\uC77C}}</div>

<div class="sign">\uC2E0\uCCAD\uC778: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  },
  {
    code: FORM_TEMPLATE_CODES.PURCHASE_REQUEST,
    name: "\uAD6C\uB9E4\uAE30\uC548\uC11C",
    description: "\uBB3C\uD488/\uC6A9\uC5ED \uAD6C\uB9E4 \uAE30\uC548 \uACB0\uC7AC \uC11C\uC2DD",
    sortOrder: 13,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uAD6C \uB9E4 \uAE30 \uC548 \uC11C</h1>

<table class="approval-line">
  <tr><th>\uAE30 \uC548</th><th>\uAC80 \uD1A0</th><th>\uC2B9 \uC778</th></tr>
  <tr><td>{{\uC131\uBA85}} {{\uC11C\uBA85}}</td><td></td><td></td></tr>
</table>

<table>
  <tr><th>\uAE30\uC548 \uBD80\uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uAE30\uC548\uC790</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uAE30\uC548\uC77C</th><td>{{\uAE30\uC548\uC77C}}</td></tr>
  <tr><th>\uC81C \uBAA9</th><td></td></tr>
</table>

<table class="items-table">
  <tr><th>\uD488 \uBA85</th><th>\uADDC \uACA9</th><th>\uC218 \uB7C9</th><th>\uB2E8 \uAC00</th><th>\uAE08 \uC561</th><th>\uBE44 \uACE0</th></tr>
  <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
  <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
  <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
  <tr><td></td><td></td><td></td><td></td><td></td><td></td></tr>
  <tr><th colspan="4">\uD569 \uACC4</th><td></td><td></td></tr>
</table>

<table>
  <tr><th>\uAD6C\uB9E4 \uC0AC\uC720</th><td class="blank-lg"></td></tr>
  <tr><th>\uCCA8 \uBD80</th><td></td></tr>
</table>

<div class="statement">
  \uC704\uC640 \uAC19\uC774 \uAD6C\uB9E4\uD558\uACE0\uC790 \uD558\uC624\uB2C8 \uAC80\uD1A0 \uD6C4 \uC7AC\uAC00\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uAE30\uC548\uC77C}}</div>

<div class="sign">\uAE30\uC548\uC790: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  },
  {
    code: FORM_TEMPLATE_CODES.HR_APPOINTMENT,
    name: "\uC778\uC0AC\uBC1C\uB839\uD488\uC758\uC11C",
    description: "\uC778\uC0AC\uBC1C\uB839(\uC2B9\uC9C4\xB7\uC804\uBCF4\xB7\uD30C\uACAC \uB4F1) \uD488\uC758 \uACB0\uC7AC \uC11C\uC2DD",
    sortOrder: 14,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uC778 \uC0AC \uBC1C \uB839 \uD488 \uC758 \uC11C</h1>

<table class="approval-line">
  <tr><th>\uAE30 \uC548</th><th>\uAC80 \uD1A0</th><th>\uC2B9 \uC778</th></tr>
  <tr><td>{{\uC131\uBA85}} {{\uC11C\uBA85}}</td><td></td><td></td></tr>
</table>

<table>
  <tr><th>\uAE30\uC548 \uBD80\uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uAE30\uC548\uC790</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uAE30\uC548\uC77C</th><td>{{\uAE30\uC548\uC77C}}</td></tr>
  <tr><th>\uBC1C\uB839 \uAD6C\uBD84</th><td>\uC2B9\uC9C4 \xB7 \uC804\uBCF4 \xB7 \uC804\uC9C1 \xB7 \uD30C\uACAC \xB7 \uD734\uC9C1 \xB7 \uBCF5\uC9C1 \xB7 \uAE30\uD0C0 (\uD574\uB2F9 \uD56D\uBAA9 \uD45C\uC2DC)</td></tr>
</table>

<table class="items-table">
  <tr><th>\uC131 \uBA85</th><th>\uC0AC \uBC88</th><th>\uD604 \uC18C\uC18D</th><th>\uD604 \uC9C1\uC704</th><th>\uBC1C\uB839 \uC18C\uC18D</th><th>\uBC1C\uB839 \uC9C1\uC704</th><th>\uBC1C\uB839\uC77C</th></tr>
  <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
  <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
  <tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
</table>

<table>
  <tr><th>\uBC1C\uB839 \uC0AC\uC720</th><td class="blank-lg"></td></tr>
</table>

<div class="statement">
  \uC704\uC640 \uAC19\uC774 \uC778\uC0AC \uBC1C\uB839\uC744 \uD488\uC758\uD558\uC624\uB2C8 \uC7AC\uAC00\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uAE30\uC548\uC77C}}</div>

<div class="sign">\uAE30\uC548\uC790: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  },
  {
    code: FORM_TEMPLATE_CODES.EXPENSE_REPORT,
    name: "\uC9C0\uCD9C\uACB0\uC758\uC11C",
    description: "\uBE44\uC6A9 \uC9C0\uCD9C \uACB0\uC758 \uACB0\uC7AC \uC11C\uC2DD",
    sortOrder: 15,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uC9C0 \uCD9C \uACB0 \uC758 \uC11C</h1>

<table class="approval-line">
  <tr><th>\uAE30 \uC548</th><th>\uAC80 \uD1A0</th><th>\uC2B9 \uC778</th></tr>
  <tr><td>{{\uC131\uBA85}} {{\uC11C\uBA85}}</td><td></td><td></td></tr>
</table>

<table>
  <tr><th>\uAE30\uC548 \uBD80\uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uAE30\uC548\uC790</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uAE30\uC548\uC77C</th><td>{{\uAE30\uC548\uC77C}}</td></tr>
  <tr><th>\uC9C0\uAE09\uCC98</th><td></td></tr>
  <tr><th>\uC9C0\uAE09 \uBC29\uBC95</th><td>\uACC4\uC88C\uC774\uCCB4 \xB7 \uBC95\uC778\uCE74\uB4DC \xB7 \uD604\uAE08 (\uD574\uB2F9 \uD56D\uBAA9 \uD45C\uC2DC)</td></tr>
</table>

<table class="items-table">
  <tr><th>\uC801 \uC694</th><th>\uAE08 \uC561</th><th>\uBE44 \uACE0</th></tr>
  <tr><td></td><td></td><td></td></tr>
  <tr><td></td><td></td><td></td></tr>
  <tr><td></td><td></td><td></td></tr>
  <tr><td></td><td></td><td></td></tr>
  <tr><th>\uD569 \uACC4</th><td></td><td></td></tr>
</table>

<table>
  <tr><th>\uC99D \uBE59</th><td>\uC138\uAE08\uACC4\uC0B0\uC11C \xB7 \uCE74\uB4DC\uC804\uD45C \xB7 \uC601\uC218\uC99D \xB7 \uAE30\uD0C0 (\uD574\uB2F9 \uD56D\uBAA9 \uD45C\uC2DC)</td></tr>
</table>

<div class="statement">
  \uC704\uC640 \uAC19\uC774 \uC9C0\uCD9C\uD558\uACE0\uC790 \uD558\uC624\uB2C8 \uACB0\uC7AC\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uAE30\uC548\uC77C}}</div>

<div class="sign">\uAE30\uC548\uC790: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  },
  {
    code: FORM_TEMPLATE_CODES.BUSINESS_TRIP,
    name: "\uCD9C\uC7A5\uC2E0\uCCAD\uC11C",
    description: "\uCD9C\uC7A5 \uC2E0\uCCAD \uACB0\uC7AC \uC11C\uC2DD",
    sortOrder: 16,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uCD9C \uC7A5 \uC2E0 \uCCAD \uC11C</h1>

<table class="approval-line">
  <tr><th>\uC2E0 \uCCAD</th><th>\uAC80 \uD1A0</th><th>\uC2B9 \uC778</th></tr>
  <tr><td>{{\uC131\uBA85}} {{\uC11C\uBA85}}</td><td></td><td></td></tr>
</table>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uCD9C \uC7A5 \uC9C0</th><td></td></tr>
  <tr><th>\uCD9C\uC7A5 \uAE30\uAC04</th><td></td></tr>
  <tr><th>\uCD9C\uC7A5 \uBAA9\uC801</th><td class="blank-lg"></td></tr>
  <tr><th>\uB3D9 \uD589 \uC790</th><td></td></tr>
  <tr><th>\uAD50\uD1B5 \uC218\uB2E8</th><td></td></tr>
  <tr><th>\uC608\uC0C1 \uACBD\uBE44</th><td></td></tr>
</table>

<div class="statement">
  \uC704\uC640 \uAC19\uC774 \uCD9C\uC7A5\uC744 \uC2E0\uCCAD\uD558\uC624\uB2C8 \uD5C8\uAC00\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uC2E0\uCCAD\uC77C}}</div>

<div class="sign">\uC2E0\uCCAD\uC778: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  },
  {
    code: FORM_TEMPLATE_CODES.RESIGNATION,
    name: "\uC0AC\uC9C1\uC11C",
    description: "\uC0AC\uC9C1 \uC758\uC0AC \uC81C\uCD9C \uC11C\uC2DD",
    sortOrder: 17,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uC0AC \uC9C1 \uC11C</h1>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uC785\uC0AC\uC77C</th><td>{{\uC785\uC0AC\uC77C}}</td></tr>
  <tr><th>\uC0AC\uC9C1 \uC608\uC815\uC77C</th><td></td></tr>
  <tr><th>\uC0AC\uC9C1 \uC0AC\uC720</th><td class="blank-lg"></td></tr>
</table>

<div class="statement">
  \uBCF8\uC778\uC740 \uC704\uC640 \uAC19\uC740 \uC0AC\uC720\uB85C \uC0AC\uC9C1\uD558\uACE0\uC790 \uD558\uC624\uB2C8 \uD5C8\uAC00\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uC2E0\uCCAD\uC77C}}</div>

<div class="sign">\uC2E0\uCCAD\uC778: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  },
  {
    code: FORM_TEMPLATE_CODES.LEAVE_OF_ABSENCE,
    name: "\uD734\uC9C1\uC2E0\uCCAD\uC11C",
    description: "\uD734\uC9C1 \uC2E0\uCCAD \uACB0\uC7AC \uC11C\uC2DD",
    sortOrder: 18,
    kind: "form",
    cssTemplate: FORM_BASE_CSS,
    bodyTemplate: `<h1>\uD734 \uC9C1 \uC2E0 \uCCAD \uC11C</h1>

<table class="approval-line">
  <tr><th>\uC2E0 \uCCAD</th><th>\uAC80 \uD1A0</th><th>\uC2B9 \uC778</th></tr>
  <tr><td>{{\uC131\uBA85}} {{\uC11C\uBA85}}</td><td></td><td></td></tr>
</table>

<table>
  <tr><th>\uC131 \uBA85</th><td>{{\uC131\uBA85}}</td></tr>
  <tr><th>\uC0AC \uBC88</th><td>{{\uC0AC\uBC88}}</td></tr>
  <tr><th>\uBD80 \uC11C</th><td>{{\uBD80\uC11C}}</td></tr>
  <tr><th>\uC9C1 \uC704</th><td>{{\uC9C1\uC704}}</td></tr>
  <tr><th>\uC785\uC0AC\uC77C</th><td>{{\uC785\uC0AC\uC77C}}</td></tr>
  <tr><th>\uD734\uC9C1 \uAE30\uAC04</th><td></td></tr>
  <tr><th>\uBCF5\uC9C1 \uC608\uC815\uC77C</th><td></td></tr>
  <tr><th>\uD734\uC9C1 \uC0AC\uC720</th><td class="blank-lg"></td></tr>
</table>

<div class="statement">
  \uC704\uC640 \uAC19\uC774 \uD734\uC9C1\uC744 \uC2E0\uCCAD\uD558\uC624\uB2C8 \uD5C8\uAC00\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.
</div>

<div class="date">{{\uC2E0\uCCAD\uC77C}}</div>

<div class="sign">\uC2E0\uCCAD\uC778: {{\uC131\uBA85}} {{\uC11C\uBA85}} (\uC778)</div>`
  }
];
var DOCUMENT_TEMPLATE_PRESETS = [
  ...CERTIFICATE_PRESETS,
  ...FORM_PRESETS
];
function documentTemplatePresetByCode(code) {
  return DOCUMENT_TEMPLATE_PRESETS.find((p) => p.code === code);
}
__name(documentTemplatePresetByCode, "documentTemplatePresetByCode");
function missingCertificatePresets(stored, exceptCode) {
  const storedCerts = stored.filter((t) => isCertificateTemplateCode(t.code));
  if (storedCerts.some((t) => t.isActive)) {
    return [];
  }
  const taken = new Set(storedCerts.map((t) => t.code));
  return CERTIFICATE_PRESETS.filter((p) => !taken.has(p.code) && p.code !== exceptCode);
}
__name(missingCertificatePresets, "missingCertificatePresets");

// src/enums/organization.enum.ts
var OrganizationType = /* @__PURE__ */ (function(OrganizationType2) {
  OrganizationType2["CLINIC"] = "CLINIC";
  OrganizationType2["HOSPITAL"] = "HOSPITAL";
  OrganizationType2["GENERAL_HOSPITAL"] = "GENERAL_HOSPITAL";
  OrganizationType2["TERTIARY_HOSPITAL"] = "TERTIARY_HOSPITAL";
  OrganizationType2["LONG_TERM_CARE_HOSPITAL"] = "LONG_TERM_CARE_HOSPITAL";
  OrganizationType2["MENTAL_HOSPITAL"] = "MENTAL_HOSPITAL";
  OrganizationType2["DENTAL_HOSPITAL"] = "DENTAL_HOSPITAL";
  OrganizationType2["ORIENTAL_HOSPITAL"] = "ORIENTAL_HOSPITAL";
  OrganizationType2["MIDWIFERY_CENTER"] = "MIDWIFERY_CENTER";
  OrganizationType2["OTHER"] = "OTHER";
  return OrganizationType2;
})({});
var EmployeeHomeSection = /* @__PURE__ */ (function(EmployeeHomeSection2) {
  EmployeeHomeSection2["CELEBRATIONS"] = "celebrations";
  EmployeeHomeSection2["NOTICES"] = "notices";
  EmployeeHomeSection2["WEEKLY_ATTENDANCE"] = "weeklyAttendance";
  return EmployeeHomeSection2;
})({});

// src/constants/employee-home.ts
var EMPLOYEE_HOME_DEFAULT_SECTION_ORDER = [
  EmployeeHomeSection.WEEKLY_ATTENDANCE,
  EmployeeHomeSection.NOTICES,
  EmployeeHomeSection.CELEBRATIONS
];
var EMPLOYEE_HOME_NOTICE_LIMIT_MIN = 1;
var EMPLOYEE_HOME_NOTICE_LIMIT_MAX = 10;
var EMPLOYEE_HOME_NOTICE_LIMIT_DEFAULT = 3;
var EMPLOYEE_HOME_NOTICE_KEEP_DAYS_MIN = 0;
var EMPLOYEE_HOME_NOTICE_KEEP_DAYS_MAX = 30;
var EMPLOYEE_HOME_NOTICE_KEEP_DAYS_DEFAULT = 7;
var DEFAULT_EMPLOYEE_HOME_LAYOUT = {
  showBirthdays: true,
  showAnniversaries: true,
  showNotices: true,
  showWeeklyAttendance: true,
  noticeLimit: EMPLOYEE_HOME_NOTICE_LIMIT_DEFAULT,
  noticeKeepDays: EMPLOYEE_HOME_NOTICE_KEEP_DAYS_DEFAULT,
  sectionOrder: [
    ...EMPLOYEE_HOME_DEFAULT_SECTION_ORDER
  ]
};
var EMPLOYEE_HOME_SECTION_LABELS = {
  [EmployeeHomeSection.CELEBRATIONS]: "\uC624\uB298\uC758 \uCD95\uD558",
  [EmployeeHomeSection.NOTICES]: "\uACF5\uC9C0",
  [EmployeeHomeSection.WEEKLY_ATTENDANCE]: "\uC774\uBC88 \uC8FC \uADFC\uD0DC"
};
function normalizeEmployeeHomeSectionOrder(order) {
  const known = new Set(EMPLOYEE_HOME_DEFAULT_SECTION_ORDER);
  const result = [];
  for (const key of order ?? []) {
    if (typeof key === "string" && known.has(key) && !result.includes(key)) {
      result.push(key);
    }
  }
  for (const key of EMPLOYEE_HOME_DEFAULT_SECTION_ORDER) {
    if (!result.includes(key)) {
      result.push(key);
    }
  }
  return result;
}
__name(normalizeEmployeeHomeSectionOrder, "normalizeEmployeeHomeSectionOrder");
function clampNoticeLimit(value) {
  const n = typeof value === "number" && Number.isFinite(value) ? Math.trunc(value) : Number.NaN;
  if (Number.isNaN(n)) {
    return EMPLOYEE_HOME_NOTICE_LIMIT_DEFAULT;
  }
  return Math.min(EMPLOYEE_HOME_NOTICE_LIMIT_MAX, Math.max(EMPLOYEE_HOME_NOTICE_LIMIT_MIN, n));
}
__name(clampNoticeLimit, "clampNoticeLimit");
function clampNoticeKeepDays(value) {
  const n = typeof value === "number" && Number.isFinite(value) ? Math.trunc(value) : Number.NaN;
  if (Number.isNaN(n)) {
    return EMPLOYEE_HOME_NOTICE_KEEP_DAYS_DEFAULT;
  }
  return Math.min(EMPLOYEE_HOME_NOTICE_KEEP_DAYS_MAX, Math.max(EMPLOYEE_HOME_NOTICE_KEEP_DAYS_MIN, n));
}
__name(clampNoticeKeepDays, "clampNoticeKeepDays");
function resolveEmployeeHomeLayout(config) {
  return {
    showBirthdays: config?.showBirthdays !== false,
    showAnniversaries: config?.showAnniversaries !== false,
    showNotices: config?.showNotices !== false,
    showWeeklyAttendance: config?.showWeeklyAttendance !== false,
    noticeLimit: clampNoticeLimit(config?.noticeLimit),
    noticeKeepDays: clampNoticeKeepDays(config?.noticeKeepDays),
    sectionOrder: normalizeEmployeeHomeSectionOrder(config?.sectionOrder)
  };
}
__name(resolveEmployeeHomeLayout, "resolveEmployeeHomeLayout");
function visibleEmployeeHomeSections(layout) {
  return layout.sectionOrder.filter((section) => {
    switch (section) {
      case EmployeeHomeSection.CELEBRATIONS:
        return layout.showBirthdays || layout.showAnniversaries;
      case EmployeeHomeSection.WEEKLY_ATTENDANCE:
        return layout.showWeeklyAttendance;
      default:
        return layout.showNotices;
    }
  });
}
__name(visibleEmployeeHomeSections, "visibleEmployeeHomeSections");
function isEmployeeHomeNoticeSeen(notice, readIds) {
  return notice.requiresAcknowledgment ? notice.isAcknowledged : readIds.has(notice.id);
}
__name(isEmployeeHomeNoticeSeen, "isEmployeeHomeNoticeSeen");
var DAY_MS = 24 * 60 * 60 * 1e3;
function selectEmployeeHomeNotices(notices, readIds, now, keepDays) {
  const unseen = [];
  const recentSeen = [];
  const keepMs = Math.max(0, keepDays) * DAY_MS;
  for (const n of notices) {
    if (!isEmployeeHomeNoticeSeen(n, readIds)) {
      unseen.push({
        ...n,
        seen: false
      });
      continue;
    }
    const published = Date.parse(n.publishedAt);
    if (keepMs > 0 && Number.isFinite(published) && now - published <= keepMs) {
      recentSeen.push({
        ...n,
        seen: true
      });
    }
  }
  return [
    ...unseen,
    ...recentSeen
  ];
}
__name(selectEmployeeHomeNotices, "selectEmployeeHomeNotices");

// src/constants/employee-master-fields.ts
var CONTRACT_TYPE_OPTIONS = [
  {
    value: "permanent",
    label: "\uC815\uADDC\uC9C1"
  },
  {
    value: "contract",
    label: "\uACC4\uC57D\uC9C1"
  },
  {
    value: "fixed_term",
    label: "\uAE30\uAC04\uC81C"
  },
  {
    value: "part_time",
    label: "\uD30C\uD2B8\uD0C0\uC784"
  },
  {
    value: "temporary",
    label: "\uC784\uC2DC\uC9C1"
  },
  {
    value: "internship",
    label: "\uC778\uD134"
  },
  {
    value: "contractor",
    label: "\uB3C4\uAE09"
  },
  {
    value: "consultant",
    label: "\uC790\uBB38"
  },
  {
    value: "freelance",
    label: "\uD504\uB9AC\uB79C\uC11C"
  }
];
var WAGE_TYPE_OPTIONS = [
  {
    value: "monthly",
    label: "\uC6D4\uAE09\uC81C"
  },
  {
    value: "annual",
    label: "\uC5F0\uBD09\uC81C"
  },
  {
    value: "hourly",
    label: "\uC2DC\uAE09\uC81C"
  },
  {
    value: "daily",
    label: "\uC77C\uAE09\uC81C"
  },
  {
    value: "weekly",
    label: "\uC8FC\uAE09\uC81C"
  },
  {
    value: "project",
    label: "\uD504\uB85C\uC81D\uD2B8"
  },
  {
    value: "commission",
    label: "\uC131\uACFC\uAE09"
  }
];
var G = {
  base: "\uAE30\uBCF8",
  person: "\uAC1C\uC778\uC815\uBCF4",
  contract: "\uADFC\uB85C\uACC4\uC57D",
  hours: "\uADFC\uB85C\uC2DC\uAC04",
  work: "\uADFC\uBB34",
  pay: "\uAE09\uC5EC \uAD6C\uC870",
  cert1: "\uD544\uC218\uBA74\uD5C8 1",
  cert2: "\uD544\uC218\uBA74\uD5C8 2"
};
var EMPLOYEE_MASTER_FIELDS = [
  // ── employee (읽기 전용 식별) ─────────────────────────────────────────
  {
    refField: "employeeNumber",
    label: "\uC0AC\uBC88",
    target: "employee",
    path: "employeeNumber",
    format: "text",
    writable: false,
    group: G.base
  },
  {
    refField: "employeeName",
    label: "\uC131\uBA85",
    target: "employee",
    path: "name",
    format: "text",
    writable: false,
    group: G.base
  },
  {
    refField: "employeeStatus",
    label: "\uC7AC\uC9C1 \uC0C1\uD0DC",
    target: "employee",
    path: "status",
    format: "text",
    writable: false,
    group: G.base
  },
  // ── team ─────────────────────────────────────────────────────────────
  {
    refField: "teamPath",
    label: "\uBD80\uC11C \uACBD\uB85C",
    target: "team",
    path: "teamPath",
    format: "text",
    writable: false,
    group: G.base
  },
  {
    refField: "teamName",
    label: "\uD300",
    target: "team",
    path: "teamName",
    format: "text",
    writable: true,
    group: G.base
  },
  // ── shift (근태 근무 배정 — 이름으로 매칭) ───────────────────────────
  {
    refField: "shiftGroupName",
    label: "\uADFC\uBB34 \uADF8\uB8F9",
    target: "shift",
    path: "shiftGroupName",
    format: "text",
    writable: true,
    group: G.work
  },
  {
    refField: "shiftName",
    label: "\uADFC\uBB34 \uC720\uD615",
    target: "shift",
    path: "shiftName",
    format: "text",
    writable: true,
    group: G.work
  },
  // 근로형태(work_patterns) — 포괄임금 시간 기준. 병원 원본 시트의 「근무형태」 열(예: 간호 통합병동 나이트)이 이 칸이다.
  // 등록된 이름이어야 하고(미등록·비활성은 issue), 적용하면 월 근로시간·연장·야간·포괄시간·통상시급이 근로형태에서
  // 다시 계산된다(수동으로 둔 필드 제외). 고용형태(contractType: 정규직/계약직)와 다른 칸이다.
  {
    refField: "workPatternName",
    label: "\uADFC\uB85C\uD615\uD0DC",
    target: "workPattern",
    path: "workPatternName",
    format: "text",
    writable: true,
    group: G.work
  },
  // ── employee (쓰기 가능) ─────────────────────────────────────────────
  {
    refField: "position",
    label: "\uC9C1\uCC45",
    target: "employee",
    path: "position",
    format: "text",
    writable: true,
    group: G.base
  },
  // 직원 정보의 직무(employees.jobDuty) — 직무 마스터(job_duties)에 등록된 이름이어야 한다. 커밋 때 이름으로
  // 마스터를 찾아 참조(jobDutyId)와 이름 사본을 함께 쓰고, 미등록·비활성은 issue 로 남긴다.
  // 근로계약의 직무(refField jobDuty, target contract — 계약서에 적힌 값)와는 다른 칸이다.
  {
    refField: "employeeJobDutyName",
    label: "\uC9C1\uBB34",
    target: "employee",
    path: "jobDuty",
    format: "text",
    writable: true,
    group: G.base
  },
  {
    refField: "hireDate",
    label: "\uC785\uC0AC\uC77C",
    target: "employee",
    path: "hireDate",
    format: "date",
    writable: true,
    group: G.base
  },
  // 최종 근무일 = 퇴사일. employees 가 아니라 퇴사 기록에 쓴다 — 시트가
  // 유일한 입력 경로이고, 급여대장의 같은 이름 열은 이 값을 읽기만 한다.
  // 빈 셀은 「변경 없음」이다 (퇴사 취소는 시트로 하지 않는다 — 기록을
  // 되돌리는 일은 퇴사 처리 화면의 몫).
  {
    refField: "resignationDate",
    label: "\uCD5C\uC885 \uADFC\uBB34\uC77C",
    target: "resignation",
    path: "resignationDate",
    format: "date",
    writable: true,
    group: G.base
  },
  {
    refField: "birthDate",
    label: "\uC0DD\uB144\uC6D4\uC77C",
    target: "employee",
    path: "birthDate",
    format: "date",
    writable: true,
    group: G.person
  },
  {
    refField: "residentNumber",
    label: "\uC8FC\uBBFC\uB4F1\uB85D\uBC88\uD638",
    target: "employee",
    path: "residentNumber",
    format: "text",
    writable: true,
    sensitive: "rrn",
    group: G.person
  },
  {
    refField: "addressText",
    label: "\uC8FC\uC18C",
    target: "employee",
    path: "address.street",
    format: "text",
    writable: true,
    group: G.person
  },
  {
    // 주소와 짝을 이루는 칸. 이 열이 없던 동안 이관 데이터는 주소 전체가 「주소」 한 칸에
    // 들어가 상세주소가 비었고, 시트로는 고칠 방법이 없었다(온보딩 9/17 결함).
    refField: "addressDetail",
    label: "\uC0C1\uC138\uC8FC\uC18C",
    target: "employee",
    path: "address.detail",
    format: "text",
    writable: true,
    group: G.person
  },
  {
    refField: "phone",
    label: "\uC5F0\uB77D\uCC98(\uD578\uB4DC\uD3F0)",
    target: "employee",
    path: "phone",
    format: "text",
    writable: true,
    group: G.person
  },
  {
    refField: "email",
    label: "\uC774\uBA54\uC77C",
    target: "employee",
    path: "email",
    format: "text",
    writable: true,
    group: G.person
  },
  {
    refField: "bankName",
    label: "\uC740\uD589",
    target: "employee",
    path: "bankAccount.bankName",
    format: "text",
    writable: true,
    group: G.person
  },
  {
    refField: "bankAccountNumber",
    label: "\uACC4\uC88C\uBC88\uD638",
    target: "employee",
    path: "bankAccount.accountNumber",
    format: "text",
    writable: true,
    sensitive: "account",
    group: G.person
  },
  {
    refField: "bankAccountHolder",
    label: "\uC608\uAE08\uC8FC",
    target: "employee",
    path: "bankAccount.accountHolder",
    format: "text",
    writable: true,
    group: G.person
  },
  // ── contract ─────────────────────────────────────────────────────────
  {
    refField: "contractNumber",
    label: "\uACC4\uC57D\uBC88\uD638",
    target: "contract",
    path: "contractNumber",
    format: "text",
    writable: false,
    group: G.contract
  },
  {
    // 정규직·계약직 구분. 예전 라벨 「근로형태」는 포괄임금 근로형태(workPatternName)와 겹쳐 「고용형태」로 바꿨다.
    refField: "contractType",
    label: "\uACE0\uC6A9\uD615\uD0DC",
    target: "contract",
    path: "contractType",
    format: "select",
    writable: true,
    options: CONTRACT_TYPE_OPTIONS,
    group: G.contract
  },
  {
    refField: "wageType",
    label: "\uC784\uAE08\uD615\uD0DC",
    target: "contract",
    path: "wageType",
    format: "select",
    writable: true,
    options: WAGE_TYPE_OPTIONS,
    group: G.contract
  },
  {
    refField: "jobDuty",
    label: "\uC9C1\uBB34(\uACC4\uC57D)",
    target: "contract",
    path: "jobDuty",
    format: "text",
    writable: true,
    group: G.contract
  },
  {
    refField: "contractStartDate",
    label: "\uACC4\uC57D \uC2DC\uC791\uC77C",
    target: "contract",
    path: "startDate",
    format: "date",
    writable: true,
    group: G.contract
  },
  {
    refField: "contractEndDate",
    label: "\uACC4\uC57D \uC885\uB8CC\uC77C",
    target: "contract",
    path: "endDate",
    format: "date",
    writable: true,
    group: G.contract
  },
  {
    refField: "salaryGradeName",
    label: "\uD638\uBD09",
    target: "contract",
    path: "salaryGradeName",
    format: "text",
    writable: false,
    group: G.contract
  },
  {
    refField: "standardWeeklyHours",
    label: "\uC8FC \uC18C\uC815\uADFC\uB85C\uC2DC\uAC04",
    target: "contract",
    path: "standardWeeklyHours",
    format: "number",
    writable: true,
    group: G.hours
  },
  {
    refField: "maxWeeklyHours",
    label: "\uC8FC \uCD5C\uB300\uADFC\uB85C\uC2DC\uAC04",
    target: "contract",
    path: "maxWeeklyHours",
    format: "number",
    writable: true,
    group: G.hours
  },
  {
    refField: "monthlyHours",
    label: "\uC6D4 \uADFC\uB85C\uC2DC\uAC04",
    target: "contract",
    path: "monthlyHours",
    format: "number",
    writable: true,
    group: G.hours
  },
  {
    refField: "inclusiveHours",
    label: "\uD3EC\uAD04\uC2DC\uAC04",
    target: "contract",
    path: "allowanceHours.inclusiveHours",
    format: "number",
    writable: true,
    group: G.hours
  },
  {
    refField: "overtimeHours",
    label: "\uC5F0\uC7A5\uC2DC\uAC04",
    target: "contract",
    path: "allowanceHours.overtimeHours",
    format: "number",
    writable: true,
    group: G.hours
  },
  {
    refField: "nightHours",
    label: "\uC57C\uAC04\uC2DC\uAC04",
    target: "contract",
    path: "allowanceHours.nightHours",
    format: "number",
    writable: true,
    group: G.hours
  },
  {
    refField: "workPattern",
    label: "\uADFC\uBB34\uC77C \uD615\uD0DC",
    target: "contract",
    path: "workSchedule.pattern",
    format: "text",
    writable: true,
    group: G.hours
  },
  {
    refField: "workHours",
    label: "\uADFC\uBB34\uC2DC\uAC04",
    target: "contract",
    path: "workSchedule.hours",
    format: "text",
    writable: true,
    group: G.hours
  },
  {
    refField: "breakTime",
    label: "\uD734\uAC8C\uC2DC\uAC04",
    target: "contract",
    path: "workSchedule.breakTime",
    format: "text",
    writable: true,
    group: G.hours
  },
  {
    refField: "annualSalary",
    label: "\uC5F0\uBD09",
    target: "contract",
    path: "metadata.annualSalary",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "monthlyPay",
    label: "\uC6D4\uAE09\uC5EC",
    target: "contract",
    path: "metadata.monthlyPay",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "baseSalary",
    label: "\uAE30\uBCF8\uAE09",
    target: "contract",
    path: "baseSalary",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "hourlyRate",
    label: "\uD1B5\uC0C1\uC2DC\uAE09",
    target: "contract",
    path: "hourlyRate",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "hobongAmount",
    label: "\uD638\uBD09\uC218\uB2F9",
    target: "contract",
    path: "hobongAmount",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "longevityAmount",
    label: "\uADFC\uC18D\uC218\uB2F9",
    target: "contract",
    path: "longevityAmount",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "inclusiveOvertimePay",
    label: "\uD3EC\uAD04\uC5F0\uC7A5",
    target: "contract",
    path: "allowances.overtime",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "inclusiveNightPay",
    label: "\uD3EC\uAD04\uC57C\uAC04",
    target: "contract",
    path: "allowances.night",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "positionAllowance",
    label: "\uC9C1\uCC45\uC218\uB2F9",
    target: "contract",
    path: "allowances.position",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "licenseAllowance",
    label: "\uC790\uACA9\uC218\uB2F9",
    target: "contract",
    path: "allowances.license",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "hazardAllowance",
    label: "\uC704\uD5D8\uC218\uB2F9",
    target: "contract",
    path: "allowances.hazard",
    format: "number",
    writable: true,
    group: G.pay
  },
  {
    refField: "specialAllowance",
    label: "\uD2B9\uBCC4\uC218\uB2F9",
    target: "contract",
    path: "allowances.special",
    format: "number",
    writable: true,
    group: G.pay
  },
  // ── certifications ───────────────────────────────────────────────────
  {
    refField: "cert1Name",
    label: "\uD544\uC218\uBA74\uD5C8",
    target: "cert1",
    path: "name",
    format: "text",
    writable: true,
    group: G.cert1
  },
  {
    refField: "cert1LicenseNumber",
    label: "\uBA74\uD5C8\uBC88\uD638",
    target: "cert1",
    path: "licenseNumber",
    format: "text",
    writable: true,
    group: G.cert1
  },
  {
    refField: "cert1IssueDate",
    label: "\uBC1C\uAE09\uC77C",
    target: "cert1",
    path: "issueDate",
    format: "date",
    writable: true,
    group: G.cert1
  },
  {
    refField: "cert1Issuer",
    label: "\uBC1C\uAE09\uAE30\uAD00",
    target: "cert1",
    path: "issuingAuthority",
    format: "text",
    writable: true,
    group: G.cert1
  },
  {
    refField: "cert2Name",
    label: "\uD544\uC218\uBA74\uD5C8(2)",
    target: "cert2",
    path: "name",
    format: "text",
    writable: true,
    group: G.cert2
  },
  {
    refField: "cert2LicenseNumber",
    label: "\uBA74\uD5C8\uBC88\uD638(2)",
    target: "cert2",
    path: "licenseNumber",
    format: "text",
    writable: true,
    group: G.cert2
  },
  {
    refField: "cert2IssueDate",
    label: "\uBC1C\uAE09\uC77C(2)",
    target: "cert2",
    path: "issueDate",
    format: "date",
    writable: true,
    group: G.cert2
  },
  {
    refField: "cert2Issuer",
    label: "\uBC1C\uAE09\uAE30\uAD00(2)",
    target: "cert2",
    path: "issuingAuthority",
    format: "text",
    writable: true,
    group: G.cert2
  }
];
var BY_REF_FIELD = new Map(EMPLOYEE_MASTER_FIELDS.map((f) => [
  f.refField,
  f
]));
function employeeMasterField(refField) {
  return refField && BY_REF_FIELD.get(refField) || null;
}
__name(employeeMasterField, "employeeMasterField");
var EMPLOYEE_MASTER_WRITABLE_REF_FIELDS = new Set(EMPLOYEE_MASTER_FIELDS.filter((f) => f.writable).map((f) => f.refField));
function resolveMasterOption(field, raw) {
  const k = raw.trim().toLowerCase();
  if (k === "") {
    return null;
  }
  for (const o of field.options ?? []) {
    if (o.value.toLowerCase() === k || o.label.toLowerCase() === k) {
      return o.value;
    }
  }
  return null;
}
__name(resolveMasterOption, "resolveMasterOption");
function maskResidentNumber(value) {
  if (!value) {
    return null;
  }
  const digits = value.replace(/[^0-9]/g, "");
  if (digits.length < 7) {
    return "*".repeat(value.length);
  }
  return `${digits.slice(0, 6)}-${digits.slice(6, 7)}******`;
}
__name(maskResidentNumber, "maskResidentNumber");
function maskAccountNumber(value) {
  if (!value) {
    return null;
  }
  const tail = value.slice(-4);
  return `${"*".repeat(Math.max(0, value.length - 4))}${tail}`;
}
__name(maskAccountNumber, "maskAccountNumber");
var MASTER_DATA_SHEET_SOURCES = /* @__PURE__ */ new Set([
  "salary_grade",
  "incentive_preset",
  "employee"
]);
function isMasterDataSheetSource(source) {
  return !!source && MASTER_DATA_SHEET_SOURCES.has(source);
}
__name(isMasterDataSheetSource, "isMasterDataSheetSource");

// src/constants/employee-number.ts
function normalizeEmployeeNumber(value) {
  return (value ?? "").trim().toUpperCase();
}
__name(normalizeEmployeeNumber, "normalizeEmployeeNumber");
function employeeNumbersEqual(a, b) {
  const na = normalizeEmployeeNumber(a);
  return na !== "" && na === normalizeEmployeeNumber(b);
}
__name(employeeNumbersEqual, "employeeNumbersEqual");

// src/enums/communication.enum.ts
var HrActionKind = /* @__PURE__ */ (function(HrActionKind2) {
  HrActionKind2["RESIGNATION"] = "resignation";
  HrActionKind2["LEAVE_OF_ABSENCE"] = "leave_of_absence";
  HrActionKind2["RETURN_FROM_LEAVE"] = "return_from_leave";
  HrActionKind2["HR_APPOINTMENT"] = "hr_appointment";
  HrActionKind2["SHIFT_CHANGE"] = "shift_change";
  return HrActionKind2;
})({});
var HrAppointmentAction = /* @__PURE__ */ (function(HrAppointmentAction2) {
  HrAppointmentAction2["TRANSFER"] = "transfer";
  HrAppointmentAction2["ADD_MEMBERSHIP"] = "add_membership";
  HrAppointmentAction2["END_MEMBERSHIP"] = "end_membership";
  HrAppointmentAction2["ROLE_CHANGE"] = "role_change";
  return HrAppointmentAction2;
})({});

// src/constants/hr-actions.ts
var LEAVE_OF_ABSENCE_REASONS = [
  "\uC721\uC544\uD734\uC9C1",
  "\uBCD1\uAC00",
  "\uAC00\uC871\uB3CC\uBD04\uD734\uC9C1",
  "\uD559\uC5C5\uD734\uC9C1",
  "\uBCD1\uC5ED\uD734\uC9C1",
  "\uAC1C\uC778\uC0AC\uC720",
  "\uAE30\uD0C0"
];
var HR_APPOINTMENT_ACTION_LABELS = {
  [HrAppointmentAction.TRANSFER]: "\uC804\uBCF4(\uD300 \uC774\uB3D9)",
  [HrAppointmentAction.ADD_MEMBERSHIP]: "\uACB8\uC9C1 \uCD94\uAC00",
  [HrAppointmentAction.END_MEMBERSHIP]: "\uC18C\uC18D \uC885\uB8CC",
  [HrAppointmentAction.ROLE_CHANGE]: "\uC5ED\uD560 \uBCC0\uACBD"
};
var HR_ACTION_CATALOG = {
  [HrActionKind.RESIGNATION]: {
    kind: HrActionKind.RESIGNATION,
    documentType: "\uC0AC\uC9C1\uC11C",
    submitter: "employee",
    title: "\uD1F4\uC9C1 \uC815\uBCF4",
    effectiveDateKey: "resignationDate",
    effectiveDateLabel: "\uD1F4\uC9C1 \uC608\uC815\uC77C",
    requiresFile: true,
    changesStatus: true,
    fields: [
      {
        key: "resignationDate",
        label: "\uD1F4\uC9C1 \uC608\uC815\uC77C",
        type: "date",
        required: true,
        hint: "\uB9C8\uC9C0\uB9C9 \uADFC\uBB34\uC77C\uC774\uC5D0\uC694. \uACB0\uC7AC\uAC00 \uC2B9\uC778\uB418\uBA74 \uC774 \uB0A0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uD1F4\uC0AC\u300D\uB85C \uBC14\uB00C\uC5B4\uC694."
      },
      {
        key: "reason",
        label: "\uC0AC\uC9C1 \uC0AC\uC720",
        type: "textarea",
        placeholder: "\uC608: \uAC1C\uC778 \uC0AC\uC815"
      }
    ],
    hints: {
      immediate: "\uC2B9\uC778\uD558\uBA74 \uC774 \uC9C1\uC6D0\uC740 \uC989\uC2DC \uD1F4\uC9C1 \uCC98\uB9AC\uB3FC\uC694 \u2014 \uD1F4\uC9C1 \uAE30\uB85D\uC774 \uB9CC\uB4E4\uC5B4\uC9C0\uACE0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uD1F4\uC0AC\u300D\uB85C \uBC14\uB00C\uC5B4\uC694.",
      scheduled: "\uC2B9\uC778\uD558\uBA74 \uD1F4\uC9C1 \uAE30\uB85D\uC774 \uB9CC\uB4E4\uC5B4\uC9C0\uACE0, \uD1F4\uC9C1 \uC608\uC815\uC77C({date})\uC5D0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uD1F4\uC0AC\u300D\uB85C \uC790\uB3D9\uC73C\uB85C \uBC14\uB00C\uC5B4\uC694.",
      applied: "\uD1F4\uC9C1 \uC778\uC0AC\uCC98\uB9AC\uAC00 \uB05D\uB0AC\uC5B4\uC694 ({at}). \uC9C1\uC6D0 \uC0C1\uD0DC\uAC00 \u300C\uD1F4\uC0AC\u300D\uB85C \uBC14\uB00C\uC5C8\uC5B4\uC694.",
      pendingDate: "\uD1F4\uC9C1 \uC608\uC815\uC77C({date})\uC5D0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uD1F4\uC0AC\u300D\uB85C \uC790\uB3D9\uC73C\uB85C \uBC14\uB00C\uC5B4\uC694."
    }
  },
  [HrActionKind.LEAVE_OF_ABSENCE]: {
    kind: HrActionKind.LEAVE_OF_ABSENCE,
    documentType: "\uD734\uC9C1\uC2E0\uCCAD\uC11C",
    submitter: "employee",
    title: "\uD734\uC9C1 \uC815\uBCF4",
    effectiveDateKey: "startDate",
    effectiveDateLabel: "\uD734\uC9C1 \uC2DC\uC791\uC77C",
    requiresFile: false,
    changesStatus: true,
    fields: [
      {
        key: "reason",
        label: "\uD734\uC9C1 \uC0AC\uC720",
        type: "select",
        required: true,
        options: [
          ...LEAVE_OF_ABSENCE_REASONS
        ]
      },
      {
        key: "startDate",
        label: "\uD734\uC9C1 \uC2DC\uC791\uC77C",
        type: "date",
        required: true,
        hint: "\uACB0\uC7AC\uAC00 \uC2B9\uC778\uB418\uBA74 \uC774 \uB0A0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uD734\uC9C1\u300D\uC73C\uB85C \uBC14\uB00C\uC5B4\uC694."
      },
      {
        key: "expectedReturnDate",
        label: "\uBCF5\uC9C1 \uC608\uC815\uC77C",
        type: "date"
      },
      {
        key: "notes",
        label: "\uBA54\uBAA8",
        type: "textarea",
        placeholder: "\uC608: \uC9C4\uB2E8\uC11C \uCCA8\uBD80"
      }
    ],
    hints: {
      immediate: "\uC2B9\uC778\uD558\uBA74 \uC774 \uC9C1\uC6D0\uC740 \uC989\uC2DC \uD734\uC9C1 \uCC98\uB9AC\uB3FC\uC694 \u2014 \uD734\uC9C1 \uAE30\uB85D\uC774 \uB9CC\uB4E4\uC5B4\uC9C0\uACE0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uD734\uC9C1\u300D\uC73C\uB85C \uBC14\uB00C\uC5B4\uC694. \uADFC\uD0DC\xB7\uAE09\uC5EC\uB300\uC7A5\uC5D0\uB294 \uD734\uC9C1\uC73C\uB85C \uD45C\uC2DC\uB3FC\uC694.",
      scheduled: "\uC2B9\uC778\uD558\uBA74 \uD734\uC9C1 \uAE30\uB85D\uC774 \uB9CC\uB4E4\uC5B4\uC9C0\uACE0, \uD734\uC9C1 \uC2DC\uC791\uC77C({date})\uC5D0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uD734\uC9C1\u300D\uC73C\uB85C \uC790\uB3D9\uC73C\uB85C \uBC14\uB00C\uC5B4\uC694.",
      applied: "\uD734\uC9C1 \uCC98\uB9AC\uAC00 \uB05D\uB0AC\uC5B4\uC694 ({at}). \uC9C1\uC6D0 \uC0C1\uD0DC\uAC00 \u300C\uD734\uC9C1\u300D\uC73C\uB85C \uBC14\uB00C\uC5C8\uC5B4\uC694.",
      pendingDate: "\uD734\uC9C1 \uC2DC\uC791\uC77C({date})\uC5D0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uD734\uC9C1\u300D\uC73C\uB85C \uC790\uB3D9\uC73C\uB85C \uBC14\uB00C\uC5B4\uC694."
    }
  },
  [HrActionKind.RETURN_FROM_LEAVE]: {
    kind: HrActionKind.RETURN_FROM_LEAVE,
    documentType: "\uBCF5\uC9C1\uC2E0\uCCAD\uC11C",
    submitter: "employee",
    title: "\uBCF5\uC9C1 \uC815\uBCF4",
    effectiveDateKey: "returnDate",
    effectiveDateLabel: "\uBCF5\uC9C1\uC77C",
    requiresFile: false,
    changesStatus: true,
    fields: [
      {
        key: "returnDate",
        label: "\uBCF5\uC9C1\uC77C",
        type: "date",
        required: true,
        hint: "\uACB0\uC7AC\uAC00 \uC2B9\uC778\uB418\uBA74 \uC774 \uB0A0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uC7AC\uC9C1\u300D\uC73C\uB85C \uB3CC\uC544\uC640\uC694."
      },
      {
        key: "notes",
        label: "\uBA54\uBAA8",
        type: "textarea"
      }
    ],
    hints: {
      immediate: "\uC2B9\uC778\uD558\uBA74 \uC774 \uC9C1\uC6D0\uC740 \uC989\uC2DC \uBCF5\uC9C1 \uCC98\uB9AC\uB3FC\uC694 \u2014 \uD734\uC9C1 \uAE30\uB85D\uC774 \uC885\uB8CC\uB418\uACE0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uC7AC\uC9C1\u300D\uC73C\uB85C \uB3CC\uC544\uC640\uC694.",
      scheduled: "\uC2B9\uC778\uD558\uBA74 \uD734\uC9C1 \uAE30\uB85D\uC774 \uC885\uB8CC \uC608\uC815\uC73C\uB85C \uBC14\uB00C\uACE0, \uBCF5\uC9C1\uC77C({date})\uC5D0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uC7AC\uC9C1\u300D\uC73C\uB85C \uB3CC\uC544\uC640\uC694.",
      applied: "\uBCF5\uC9C1 \uCC98\uB9AC\uAC00 \uB05D\uB0AC\uC5B4\uC694 ({at}). \uC9C1\uC6D0 \uC0C1\uD0DC\uAC00 \u300C\uC7AC\uC9C1\u300D\uC73C\uB85C \uB3CC\uC544\uC654\uC5B4\uC694.",
      pendingDate: "\uBCF5\uC9C1\uC77C({date})\uC5D0 \uC7AC\uC9C1 \uC0C1\uD0DC\uAC00 \u300C\uC7AC\uC9C1\u300D\uC73C\uB85C \uC790\uB3D9\uC73C\uB85C \uB3CC\uC544\uC640\uC694."
    }
  },
  [HrActionKind.HR_APPOINTMENT]: {
    kind: HrActionKind.HR_APPOINTMENT,
    documentType: "\uC778\uC0AC\uBC1C\uB839\uD488\uC758\uC11C",
    submitter: "admin",
    title: "\uBC1C\uB839 \uC815\uBCF4",
    effectiveDateKey: "effectiveDate",
    effectiveDateLabel: "\uC2DC\uD589\uC77C",
    requiresFile: false,
    changesStatus: false,
    fields: [
      {
        key: "effectiveDate",
        label: "\uC2DC\uD589\uC77C",
        type: "date",
        required: true
      },
      {
        key: "reason",
        label: "\uBC1C\uB839 \uC0AC\uC720",
        type: "textarea"
      }
    ],
    hints: {
      immediate: "\uC2B9\uC778\uD558\uBA74 \uC989\uC2DC \uC18C\uC18D\xB7\uC5ED\uD560\uC774 \uBC14\uB00C\uC5B4\uC694. \uBCD1\uB3D9 \uBC30\uC815\xB7\uADFC\uBB34 \uBC30\uC815\uB3C4 \uC0C8 \uC18C\uC18D\uC744 \uB530\uB77C\uAC00\uC694.",
      scheduled: "\uC2B9\uC778\uD558\uBA74 \uC2DC\uD589\uC77C({date})\uC5D0 \uC18C\uC18D\xB7\uC5ED\uD560\uC774 \uBC14\uB00C\uC5B4\uC694. \uBCD1\uB3D9 \uBC30\uC815\xB7\uADFC\uBB34 \uBC30\uC815\uB3C4 \uC0C8 \uC18C\uC18D\uC744 \uB530\uB77C\uAC00\uC694.",
      applied: "\uBC1C\uB839 \uCC98\uB9AC\uAC00 \uB05D\uB0AC\uC5B4\uC694 ({at}). \uC18C\uC18D\xB7\uC5ED\uD560\uC774 \uBC14\uB00C\uC5C8\uC5B4\uC694.",
      pendingDate: "\uC2DC\uD589\uC77C({date})\uC5D0 \uC18C\uC18D\xB7\uC5ED\uD560\uC774 \uC790\uB3D9\uC73C\uB85C \uBC14\uB00C\uC5B4\uC694."
    }
  },
  [HrActionKind.SHIFT_CHANGE]: {
    kind: HrActionKind.SHIFT_CHANGE,
    documentType: "\uADFC\uBB34\uD615\uD0DC \uBCC0\uACBD \uC2E0\uCCAD",
    submitter: "employee",
    title: "\uADFC\uBB34 \uBCC0\uACBD \uC815\uBCF4",
    effectiveDateKey: "effectiveDate",
    effectiveDateLabel: "\uC2DC\uD589\uC77C",
    requiresFile: false,
    changesStatus: false,
    fields: [
      {
        key: "shiftId",
        label: "\uD76C\uB9DD \uADFC\uBB34\uD615\uD0DC",
        type: "shift",
        required: true
      },
      {
        key: "effectiveDate",
        label: "\uC2DC\uD589\uC77C",
        type: "date",
        required: true,
        hint: "\uACB0\uC7AC\uAC00 \uC2B9\uC778\uB418\uBA74 \uC774 \uB0A0\uBD80\uD130 \uC774 \uADFC\uBB34\uD615\uD0DC\uB85C \uADFC\uD0DC\uB97C \uD310\uC815\uD574\uC694."
      },
      {
        key: "reason",
        label: "\uC0AC\uC720",
        type: "textarea",
        placeholder: "\uC608: \uC57C\uAC04 \uADFC\uBB34 \uC804\uD658 \uD76C\uB9DD"
      }
    ],
    hints: {
      immediate: "\uC2B9\uC778\uD558\uBA74 \uC989\uC2DC \uC774 \uADFC\uBB34\uD615\uD0DC\uB85C \uBC30\uC815\uB3FC\uC694. \uC9C1\uBB34 \uAE30\uBCF8 \uADFC\uBB34\uC640 \uB2E4\uB974\uBA74 \uC9C1\uC6D0 \uAD00\uB9AC\uC5D0 \u300C\uC9C1\uBB34 \uAE30\uBCF8\uACFC \uB2E4\uB984\u300D\uC73C\uB85C \uD45C\uC2DC\uB3FC\uC694.",
      scheduled: "\uC2B9\uC778\uD558\uBA74 \uC2DC\uD589\uC77C({date})\uBD80\uD130 \uC774 \uADFC\uBB34\uD615\uD0DC\uB85C \uADFC\uD0DC\uB97C \uD310\uC815\uD574\uC694.",
      applied: "\uADFC\uBB34\uD615\uD0DC \uBCC0\uACBD\uC774 \uBC18\uC601\uB410\uC5B4\uC694 ({at}).",
      pendingDate: "\uC2DC\uD589\uC77C({date})\uC5D0 \uADFC\uBB34\uD615\uD0DC\uAC00 \uC790\uB3D9\uC73C\uB85C \uBC14\uB00C\uC5B4\uC694."
    }
  }
};
var HR_ACTION_KINDS = Object.values(HrActionKind);
var EMPLOYEE_HR_ACTION_KINDS = HR_ACTION_KINDS.filter((k) => HR_ACTION_CATALOG[k].submitter === "employee");
function hrActionKindByDocumentType(documentType) {
  const label = (documentType ?? "").trim();
  if (!label) {
    return null;
  }
  return HR_ACTION_KINDS.find((k) => HR_ACTION_CATALOG[k].documentType === label) ?? null;
}
__name(hrActionKindByDocumentType, "hrActionKindByDocumentType");
var YMD = /^\d{4}-\d{2}-\d{2}$/;
var str = /* @__PURE__ */ __name((v) => typeof v === "string" && v.trim() ? v.trim() : void 0, "str");
var ymd = /* @__PURE__ */ __name((v) => {
  const s = str(v);
  return s && YMD.test(s) ? s : void 0;
}, "ymd");
function hrActionDetails(metadata) {
  const raw = metadata?.hrAction;
  if (raw && typeof raw === "object") {
    const r = raw;
    const kind = str(r.kind);
    if (!(kind && kind in HR_ACTION_CATALOG)) {
      return null;
    }
    const fields = r.fields && typeof r.fields === "object" ? r.fields : {};
    const key = HR_ACTION_CATALOG[kind].effectiveDateKey;
    return {
      kind,
      fields,
      effectiveDate: ymd(r.effectiveDate) ?? ymd(fields[key]),
      recordId: str(r.recordId),
      appliedAt: str(r.appliedAt),
      appliedBy: str(r.appliedBy)
    };
  }
  const legacy = metadata?.resignation;
  if (legacy && typeof legacy === "object") {
    const r = legacy;
    return {
      kind: HrActionKind.RESIGNATION,
      fields: {
        resignationDate: ymd(r.resignationDate),
        reason: str(r.reason)
      },
      effectiveDate: ymd(r.resignationDate),
      recordId: str(r.recordId),
      appliedAt: str(r.appliedAt)
    };
  }
  return null;
}
__name(hrActionDetails, "hrActionDetails");
function isHrActionDocument(doc) {
  return hrActionKindByDocumentType(doc.documentType) !== null || hrActionDetails(doc.metadata) !== null;
}
__name(isHrActionDocument, "isHrActionDocument");
function resolveHrActionKind(doc) {
  return hrActionDetails(doc.metadata)?.kind ?? hrActionKindByDocumentType(doc.documentType);
}
__name(resolveHrActionKind, "resolveHrActionKind");
function planHrActionApplication(details, today) {
  const effectiveDate = details?.effectiveDate ?? today;
  return {
    effectiveDate,
    immediate: effectiveDate <= today
  };
}
__name(planHrActionApplication, "planHrActionApplication");
function describeHrActionFields(details) {
  const entry = HR_ACTION_CATALOG[details.kind];
  const rows = entry.fields.map((f) => {
    const raw = details.fields[f.key];
    let value = typeof raw === "string" ? raw : raw == null ? "" : String(raw);
    if (f.type === "shift") {
      value = str(details.fields.shiftName) ?? value;
      const group = str(details.fields.shiftGroupName);
      value = group && value ? `${group} \xB7 ${value}` : value || group || "";
    }
    return {
      key: f.key,
      label: f.label,
      value: value || "-",
      isDate: f.type === "date" && !!value
    };
  });
  if (details.kind === HrActionKind.HR_APPOINTMENT) {
    const changes = Array.isArray(details.fields.changes) ? details.fields.changes : [];
    changes.forEach((c, i) => {
      const label = HR_APPOINTMENT_ACTION_LABELS[c.action] ?? c.action;
      const parts = [];
      if (c.action === HrAppointmentAction.TRANSFER) {
        parts.push(`${c.fromTeamName ?? "?"} \u2192 ${c.teamName ?? "?"}`);
      } else if (c.teamName) {
        parts.push(c.teamName);
      }
      if (c.roleName) {
        parts.push(`\uC5ED\uD560 ${c.roleName}`);
      }
      rows.push({
        key: `change-${i}`,
        label,
        value: parts.join(" \xB7 ") || "-"
      });
    });
  }
  return rows;
}
__name(describeHrActionFields, "describeHrActionFields");
function hrActionApprovalHint(details, status, today, formatDate = (d) => d) {
  const hints = HR_ACTION_CATALOG[details.kind].hints;
  if (details.appliedAt) {
    return hints.applied.replace("{at}", formatDate(details.appliedAt.slice(0, 10)));
  }
  const plan = planHrActionApplication(details, today);
  const date = formatDate(plan.effectiveDate);
  if (status === "approved") {
    return plan.immediate ? "\uC2B9\uC778\uB410\uC5B4\uC694. \uC778\uC0AC\uCC98\uB9AC\uB294 \uACE7 \uC790\uB3D9\uC73C\uB85C \uBC18\uC601\uB3FC\uC694." : hints.pendingDate.replace("{date}", date);
  }
  return plan.immediate ? hints.immediate : hints.scheduled.replace("{date}", date);
}
__name(hrActionApprovalHint, "hrActionApprovalHint");
var HR_ACTION_FORM_TEMPLATE_CODES = {
  [HrActionKind.RESIGNATION]: FORM_TEMPLATE_CODES.RESIGNATION,
  [HrActionKind.LEAVE_OF_ABSENCE]: FORM_TEMPLATE_CODES.LEAVE_OF_ABSENCE,
  [HrActionKind.HR_APPOINTMENT]: FORM_TEMPLATE_CODES.HR_APPOINTMENT
};
function hrActionKindByFormTemplateCode(code) {
  if (!code) {
    return null;
  }
  for (const kind of HR_ACTION_KINDS) {
    if (HR_ACTION_FORM_TEMPLATE_CODES[kind] === code) {
      return kind;
    }
  }
  return null;
}
__name(hrActionKindByFormTemplateCode, "hrActionKindByFormTemplateCode");
var DEFAULT_HR_ACTION_ATTACHMENT_POLICY = Object.fromEntries(HR_ACTION_KINDS.map((kind) => [
  kind,
  HR_ACTION_CATALOG[kind].requiresFile
]));
function resolveHrActionAttachmentPolicy(templates) {
  const policy = {
    ...DEFAULT_HR_ACTION_ATTACHMENT_POLICY
  };
  for (const t of templates) {
    if (t.isActive === false || typeof t.attachmentRequired !== "boolean") {
      continue;
    }
    const kind = hrActionKindByFormTemplateCode(t.code);
    if (kind) {
      policy[kind] = t.attachmentRequired;
    }
  }
  return policy;
}
__name(resolveHrActionAttachmentPolicy, "resolveHrActionAttachmentPolicy");
function hrActionRequiresFile(documentType, policy) {
  const kind = hrActionKindByDocumentType(documentType);
  if (!kind) {
    return true;
  }
  return policy?.[kind] ?? HR_ACTION_CATALOG[kind].requiresFile;
}
__name(hrActionRequiresFile, "hrActionRequiresFile");

// src/constants/impersonation.ts
var IMPERSONATION_TTL_OPTIONS = [
  30,
  60,
  120,
  240
];
var IMPERSONATION_DEFAULT_TTL_MINUTES = 60;
var IMPERSONATION_MAX_TTL_MINUTES = 240;

// src/constants/job-category.ts
var JOB_CATEGORY_LABELS = {
  [JobCategory.NURSE]: "\uAC04\uD638\uC0AC",
  [JobCategory.NURSE_AIDE]: "\uAC04\uD638\uC870\uBB34\uC0AC",
  [JobCategory.CARE_WORKER]: "\uC694\uC591\uBCF4\uD638\uC0AC",
  [JobCategory.WARD_SUPPORT]: "\uBCD1\uB3D9\uC9C0\uC6D0",
  [JobCategory.PHYSICIAN]: "\uC758\uC0AC",
  [JobCategory.THERAPIST]: "\uCE58\uB8CC\uC0AC",
  [JobCategory.MEDICAL_TECHNICIAN]: "\uC758\uB8CC\uAE30\uC0AC",
  [JobCategory.PHARMACIST]: "\uC57D\uC0AC",
  [JobCategory.NUTRITION]: "\uC601\uC591\xB7\uC870\uB9AC",
  [JobCategory.SOCIAL_WORKER]: "\uC0AC\uD68C\uBCF5\uC9C0\uC0AC",
  [JobCategory.ADMINISTRATION]: "\uD589\uC815",
  [JobCategory.FACILITY]: "\uC2DC\uC124\xB7\uD658\uACBD",
  [JobCategory.OTHER]: "\uAE30\uD0C0"
};

// src/constants/leave.ts
var DEFAULT_LEAVE_REASON_PRESETS = [
  "\uAC1C\uC778 \uC0AC\uC815",
  "\uBCD1\uC6D0 \uC9C4\uB8CC",
  "\uAC00\uC871 \uD589\uC0AC",
  "\uAC74\uAC15 \uD68C\uBCF5",
  "\uC5EC\uD589"
];
var LEAVE_REASON_PRESET_MAX = 10;
function leaveReasonUnit(reason) {
  if (!reason) {
    return "full";
  }
  if (reason.deductionKind === "hourly") {
    return "hourly";
  }
  const rate = reason.deductionRate ?? reason.deductionDays ?? (reason.usageMinutes != null ? reason.usageMinutes / 480 : null) ?? (reason.hours != null && reason.hours > 0 ? reason.hours / 8 : null);
  if (rate === 0.5) {
    return "half";
  }
  if (rate === 0) {
    return "none";
  }
  return "full";
}
__name(leaveReasonUnit, "leaveReasonUnit");
var HALF_DAY_PERIOD_LABELS = {
  morning: "\uC624\uC804",
  afternoon: "\uC624\uD6C4"
};
function halfDayPeriodLabel(period) {
  return period === "morning" || period === "afternoon" ? HALF_DAY_PERIOD_LABELS[period] : "";
}
__name(halfDayPeriodLabel, "halfDayPeriodLabel");
var LEAVE_OVERUSE_MODE_LABELS = {
  allow: "\uACBD\uACE0\uB9CC \uD558\uACE0 \uD5C8\uC6A9",
  block: "\uCC28\uB2E8",
  approver_confirm: "\uACB0\uC7AC\uC790\uAC00 \uD655\uC778\uD55C \uB4A4 \uD5C8\uC6A9"
};
function resolveLeaveOveruseMode(policy) {
  const m = policy.overuseMode;
  if (m === "allow" || m === "block" || m === "approver_confirm") {
    return m;
  }
  return policy.enforceBalanceLimit === true || policy.allowNegativeBalance === false ? "block" : "allow";
}
__name(resolveLeaveOveruseMode, "resolveLeaveOveruseMode");
var LEAVE_OVERUSE_CONFIRM_PREFIX = "\uC794\uC5EC \uC5F0\uCC28\uBCF4\uB2E4 \uB9CE\uC740 \uC2E0\uCCAD\uC774\uC5D0\uC694.";

// src/enums/notification.enum.ts
var NotificationType = /* @__PURE__ */ (function(NotificationType2) {
  NotificationType2["LEAVE_REQUEST"] = "leave_request";
  NotificationType2["ATTENDANCE_CORRECTION"] = "attendance_correction";
  NotificationType2["OVERTIME"] = "overtime";
  NotificationType2["OFFSITE_WORK"] = "offsite_work";
  NotificationType2["INCENTIVE"] = "incentive";
  NotificationType2["ALLOWANCE"] = "allowance";
  NotificationType2["DEDUCTION"] = "deduction";
  NotificationType2["DOCUMENT"] = "document";
  NotificationType2["EDUCATION"] = "education";
  NotificationType2["CERTIFICATE"] = "certificate";
  NotificationType2["PERMISSION_REQUEST"] = "permission_request";
  NotificationType2["GENERAL"] = "general";
  NotificationType2["SYSTEM"] = "system";
  NotificationType2["MEMO"] = "memo";
  NotificationType2["MESSAGE"] = "message";
  return NotificationType2;
})({});
var NotificationPushCategory = /* @__PURE__ */ (function(NotificationPushCategory2) {
  NotificationPushCategory2["MESSENGER"] = "messenger";
  NotificationPushCategory2["APPROVAL_REQUEST"] = "approval_request";
  NotificationPushCategory2["APPROVAL_RESULT"] = "approval_result";
  NotificationPushCategory2["NOTICE"] = "notice";
  NotificationPushCategory2["ATTENDANCE"] = "attendance";
  NotificationPushCategory2["PAYSLIP"] = "payslip";
  NotificationPushCategory2["OTHER"] = "other";
  return NotificationPushCategory2;
})({});

// src/constants/notification-navigation.ts
var APPROVAL_REFERENCE_TYPES = {
  leave_request: "leave",
  overtime_record: "overtime",
  offsite_work_record: "offsite_work",
  fixed_incentive: "incentive",
  treatment_session_request: "treatment_session",
  attendance_correction: "attendance_correction"
};
var TARGET_BY_TYPE = {
  [NotificationType.LEAVE_REQUEST]: {
    section: "approval",
    approvalTab: "leave"
  },
  [NotificationType.OVERTIME]: {
    section: "approval",
    approvalTab: "work"
  },
  // 출퇴근 정정 요청 — 직원 앱 결재 「내 신청·결재 현황」 근무 쪽(옛 탭 이름 work 는 router 가 옮긴다)
  [NotificationType.ATTENDANCE_CORRECTION]: {
    section: "approval",
    approvalTab: "work"
  },
  [NotificationType.OFFSITE_WORK]: {
    section: "approval",
    approvalTab: "work"
  },
  [NotificationType.INCENTIVE]: {
    section: "approval",
    approvalTab: "incentive"
  },
  [NotificationType.DOCUMENT]: {
    section: "approval",
    approvalTab: "documents"
  },
  [NotificationType.CERTIFICATE]: {
    section: "approval",
    approvalTab: "documents"
  }
};
function resolveNotificationTarget(notification) {
  const conversationId = notification.metadata?.conversationId ?? (notification.referenceType === "conversation" ? notification.referenceId ?? void 0 : void 0);
  if (conversationId) {
    return {
      section: "messenger",
      conversationId
    };
  }
  if (notification.referenceType === "csReport") {
    return {
      section: "csReport",
      csReportId: notification.referenceId ?? void 0
    };
  }
  const target = TARGET_BY_TYPE[notification.type];
  if (!target) {
    return null;
  }
  const out = {
    ...target
  };
  const requestType = notification.referenceType ? APPROVAL_REFERENCE_TYPES[notification.referenceType] : void 0;
  if (requestType && notification.referenceId) {
    out.requestType = requestType;
    out.requestId = notification.referenceId;
    const audience = notification.metadata?.audience;
    if (audience === "approver" || audience === "requester") {
      out.audience = audience;
    }
  }
  return out;
}
__name(resolveNotificationTarget, "resolveNotificationTarget");
var APP_LABEL_BY_REFERENCE_TYPE = {
  grade_promotion: "\uAE09\uC5EC\uAD00\uB9AC",
  work_type_change: "\uB0B4\uBD80 \uACB0\uC7AC"
};
var APP_LABEL_BY_TYPE = {
  // 메신저 답글·@멘션 — 목적지는 늘 대화방(referenceType=conversation)이라 여기까지 오지 않지만 표는 전 타입을 덮는다.
  [NotificationType.MESSAGE]: "\uBA54\uC2E0\uC800",
  // 급여 시트(hr-system)에서 다루는 것들 — 셀 메모·수당·공제·교육비·호봉.
  [NotificationType.MEMO]: "\uAE09\uC5EC\uAD00\uB9AC",
  [NotificationType.ALLOWANCE]: "\uAE09\uC5EC\uAD00\uB9AC",
  [NotificationType.DEDUCTION]: "\uAE09\uC5EC\uAD00\uB9AC",
  [NotificationType.EDUCATION]: "\uAE09\uC5EC\uAD00\uB9AC",
  // 관리자(admin) — 권한 요청, 주당 근무시간 초과 경고.
  [NotificationType.PERMISSION_REQUEST]: "\uAD00\uB9AC\uC790",
  [NotificationType.GENERAL]: "\uAD00\uB9AC\uC790",
  // 내부 결재(team-manager) — 승인 흐름 전부. 직원 앱에도 화면이 있지만(결재 탭)
  // 승인하는 쪽은 여기다. SYSTEM은 referenceType으로 갈리고, 위 표에서 못 찾은
  // SYSTEM(새 흐름이 붙었는데 표를 안 늘린 경우)도 승인 흐름이라 여기로 온다.
  [NotificationType.SYSTEM]: "\uB0B4\uBD80 \uACB0\uC7AC",
  [NotificationType.LEAVE_REQUEST]: "\uB0B4\uBD80 \uACB0\uC7AC",
  [NotificationType.OVERTIME]: "\uB0B4\uBD80 \uACB0\uC7AC",
  [NotificationType.ATTENDANCE_CORRECTION]: "\uB0B4\uBD80 \uACB0\uC7AC",
  [NotificationType.OFFSITE_WORK]: "\uB0B4\uBD80 \uACB0\uC7AC",
  [NotificationType.INCENTIVE]: "\uB0B4\uBD80 \uACB0\uC7AC",
  [NotificationType.DOCUMENT]: "\uB0B4\uBD80 \uACB0\uC7AC",
  [NotificationType.CERTIFICATE]: "\uB0B4\uBD80 \uACB0\uC7AC"
};
function resolveNotificationAppLabel(notification) {
  const byReference = notification.referenceType ? APP_LABEL_BY_REFERENCE_TYPE[notification.referenceType] : void 0;
  return byReference ?? APP_LABEL_BY_TYPE[notification.type] ?? null;
}
__name(resolveNotificationAppLabel, "resolveNotificationAppLabel");

// src/constants/notification-push-category.ts
var NOTIFICATION_PUSH_CATEGORIES = [
  {
    key: NotificationPushCategory.MESSENGER,
    label: "\uBA54\uC2E0\uC800",
    description: "\uC0C8 \uBA54\uC2DC\uC9C0\xB7\uB2F5\uAE00\xB7\uB098\uB97C \uBD80\uB978 \uBA58\uC158",
    available: true
  },
  {
    key: NotificationPushCategory.APPROVAL_REQUEST,
    label: "\uACB0\uC7AC \uC694\uCCAD",
    description: "\uB0B4\uAC00 \uACB0\uC7AC\uD560 \uC2E0\uCCAD\uC774 \uC62C\uB77C\uC624\uAC70\uB098 \uB2E4\uC2DC \uC54C\uB9B4 \uB54C",
    available: true
  },
  {
    key: NotificationPushCategory.APPROVAL_RESULT,
    label: "\uB0B4 \uC2E0\uCCAD \uACB0\uACFC",
    description: "\uB0B4\uAC00 \uC62C\uB9B0 \uC2E0\uCCAD\uC774 \uC2B9\uC778\xB7\uBC18\uB824\xB7\uCDE8\uC18C\uB420 \uB54C",
    available: true
  },
  {
    key: NotificationPushCategory.NOTICE,
    label: "\uACF5\uC9C0\xB7\uACF5\uC2DD \uC548\uB0B4",
    description: "\uC0C8 \uACF5\uC9C0\uC640 \uD68C\uC0AC \uACF5\uC2DD \uC548\uB0B4 \uBA54\uC2DC\uC9C0",
    available: true
  },
  {
    key: NotificationPushCategory.ATTENDANCE,
    label: "\uADFC\uD0DC",
    description: "\uC8FC\uB2F9 \uADFC\uBB34\uC2DC\uAC04 \uCD08\uACFC \uAC19\uC740 \uADFC\uD0DC \uC54C\uB9BC",
    available: true
  },
  {
    key: NotificationPushCategory.PAYSLIP,
    label: "\uAE09\uC5EC\uBA85\uC138\uC11C",
    description: "\uAE09\uC5EC\uBA85\uC138\uC11C\uAC00 \uB3C4\uCC29\uD588\uC744 \uB54C",
    available: false
  },
  {
    key: NotificationPushCategory.OTHER,
    label: "\uADF8 \uBC16\uC758 \uC54C\uB9BC",
    description: "\uC2DC\uD2B8 \uBA54\uBAA8\xB7\uBD88\uD3B8 \uC2E0\uACE0 \uB2F5\uBCC0\xB7\uC2DC\uC2A4\uD15C \uC548\uB0B4",
    available: true
  }
];
var CATEGORY_KEYS = new Set(Object.values(NotificationPushCategory));
var NOTIFICATION_PUSH_CATEGORY_PREFIX = "category:";
function notificationPushCategoryEventType(category) {
  return `${NOTIFICATION_PUSH_CATEGORY_PREFIX}${category}`;
}
__name(notificationPushCategoryEventType, "notificationPushCategoryEventType");
var APPROVAL_FLOW_TYPES = /* @__PURE__ */ new Set([
  NotificationType.LEAVE_REQUEST,
  NotificationType.ATTENDANCE_CORRECTION,
  NotificationType.OVERTIME,
  NotificationType.OFFSITE_WORK,
  NotificationType.INCENTIVE,
  NotificationType.ALLOWANCE,
  NotificationType.DEDUCTION,
  NotificationType.DOCUMENT,
  NotificationType.EDUCATION,
  NotificationType.CERTIFICATE,
  NotificationType.PERMISSION_REQUEST
]);
var APPROVAL_FLOW_SYSTEM_REFERENCES = /* @__PURE__ */ new Set([
  "grade_promotion",
  "work_type_change"
]);
function resolveNotificationPushCategory(input) {
  const explicit = input.metadata?.pushCategory;
  if (typeof explicit === "string" && CATEGORY_KEYS.has(explicit)) {
    return explicit;
  }
  if (input.type === NotificationType.MESSAGE || input.referenceType === "conversation" || typeof input.metadata?.conversationId === "string") {
    return NotificationPushCategory.MESSENGER;
  }
  const audience = input.metadata?.audience;
  if (audience === "approver") {
    return NotificationPushCategory.APPROVAL_REQUEST;
  }
  if (audience === "requester") {
    return NotificationPushCategory.APPROVAL_RESULT;
  }
  const isApprovalFlow = input.type != null && APPROVAL_FLOW_TYPES.has(input.type) || input.type === NotificationType.SYSTEM && input.referenceType != null && APPROVAL_FLOW_SYSTEM_REFERENCES.has(input.referenceType);
  if (isApprovalFlow) {
    return input.recipientIsSubject ? NotificationPushCategory.APPROVAL_RESULT : NotificationPushCategory.APPROVAL_REQUEST;
  }
  if (input.referenceType === "attendance_weekly") {
    return NotificationPushCategory.ATTENDANCE;
  }
  if (input.referenceType === "notice") {
    return NotificationPushCategory.NOTICE;
  }
  return NotificationPushCategory.OTHER;
}
__name(resolveNotificationPushCategory, "resolveNotificationPushCategory");
var HHMM = /^([01]\d|2[0-3]):([0-5]\d)$/;
function parseHHMM(value) {
  if (typeof value !== "string") {
    return null;
  }
  const m = HHMM.exec(value);
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}
__name(parseHHMM, "parseHHMM");
function isValidQuietHours(value) {
  if (!value || typeof value !== "object") {
    return false;
  }
  const v = value;
  const start = parseHHMM(v.start);
  const end = parseHHMM(v.end);
  return start !== null && end !== null && start !== end;
}
__name(isValidQuietHours, "isValidQuietHours");
function isWithinQuietHours(quiet, minuteOfDay) {
  if (!isValidQuietHours(quiet)) {
    return false;
  }
  const start = parseHHMM(quiet.start);
  const end = parseHHMM(quiet.end);
  if (start < end) {
    return minuteOfDay >= start && minuteOfDay < end;
  }
  return minuteOfDay >= start || minuteOfDay < end;
}
__name(isWithinQuietHours, "isWithinQuietHours");
function minuteOfDayInTimezone(now, timezone) {
  let parts;
  try {
    parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timezone || "UTC",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23"
    }).formatToParts(now);
  } catch {
    parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "UTC",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23"
    }).formatToParts(now);
  }
  const hour = Number(parts.find((p) => p.type === "hour")?.value ?? 0) % 24;
  const minute = Number(parts.find((p) => p.type === "minute")?.value ?? 0);
  return hour * 60 + minute;
}
__name(minuteOfDayInTimezone, "minuteOfDayInTimezone");
function isPushAllowed(input) {
  if (input.pushEnabled === false) {
    return {
      allowed: false,
      reason: "push_off"
    };
  }
  if (input.mutedAll) {
    return {
      allowed: false,
      reason: "muted_all"
    };
  }
  if (input.categoryEnabled === false) {
    return {
      allowed: false,
      reason: "category_off"
    };
  }
  if (input.quietHours && input.minuteOfDay !== void 0 && isWithinQuietHours(input.quietHours, input.minuteOfDay)) {
    return {
      allowed: false,
      reason: "quiet_hours"
    };
  }
  return {
    allowed: true
  };
}
__name(isPushAllowed, "isPushAllowed");
function quietHoursLabel(quiet) {
  if (!isValidQuietHours(quiet)) {
    return "";
  }
  const overnight = parseHHMM(quiet.end) < parseHHMM(quiet.start);
  return `${quiet.start} ~ ${overnight ? "\uB2E4\uC74C \uB0A0 " : ""}${quiet.end}`;
}
__name(quietHoursLabel, "quietHoursLabel");

// src/enums/nurse.enum.ts
var WardCareType = /* @__PURE__ */ (function(WardCareType2) {
  WardCareType2["GENERAL"] = "general";
  WardCareType2["REHAB"] = "rehab";
  return WardCareType2;
})({});

// src/constants/nurse-staffing.ts
var INTEGRATED_WARD_STAFFING = {
  [WardCareType.GENERAL]: {
    nurseRatioByOrgType: {
      [OrganizationType.TERTIARY_HOSPITAL]: {
        options: [
          5,
          6,
          7
        ]
      },
      [OrganizationType.GENERAL_HOSPITAL]: {
        options: [
          7,
          8,
          10,
          12
        ],
        standard: 10
      },
      [OrganizationType.HOSPITAL]: {
        options: [
          10,
          12,
          14
        ],
        standard: 12
      }
    },
    aidePatientRatioOptions: [
      12,
      20,
      25,
      30
    ],
    supportPatientRatioOptions: [
      7,
      8,
      10,
      14,
      20,
      40
    ]
  },
  [WardCareType.REHAB]: {
    nurseRatioByOrgType: {
      [OrganizationType.GENERAL_HOSPITAL]: {
        options: [
          10,
          12
        ]
      },
      [OrganizationType.HOSPITAL]: {
        options: [
          12,
          14,
          16
        ]
      }
    },
    aidePatientRatioOptions: [
      12,
      20,
      25,
      30
    ],
    supportPatientRatioOptions: [
      7,
      8,
      10,
      14,
      20,
      40
    ],
    rehabSupportPatientRatioOptions: [
      10,
      15,
      25
    ]
  }
};
var AIDE_PATIENT_RATIO_SUNSET = {
  ratio: 30,
  graceStartMonth: "2024-07",
  sunsetMonth: "2027-07"
};
var GENERAL_WARD_NURSING_GRADES = [
  {
    grade: "A",
    rank: 1,
    min: null,
    max: 2,
    tone: "good"
  },
  {
    grade: "1",
    rank: 2,
    min: 2,
    max: 2.5,
    tone: "good"
  },
  {
    grade: "2",
    rank: 3,
    min: 2.5,
    max: 3,
    tone: "good"
  },
  {
    grade: "3",
    rank: 4,
    min: 3,
    max: 3.5,
    tone: "warn"
  },
  {
    grade: "4",
    rank: 5,
    min: 3.5,
    max: 4,
    tone: "warn"
  },
  {
    grade: "5",
    rank: 6,
    min: 4,
    max: 6,
    tone: "bad"
  },
  {
    grade: "6",
    rank: 7,
    min: 6,
    max: null,
    tone: "bad"
  }
];
var LTC_HOSPITAL_NURSING_GRADES = [
  {
    grade: "1",
    rank: 1,
    min: null,
    max: 4.5,
    tone: "good"
  },
  {
    grade: "2",
    rank: 2,
    min: 4.5,
    max: 5,
    tone: "good"
  },
  {
    grade: "3",
    rank: 3,
    min: 5,
    max: 5.5,
    tone: "warn"
  },
  {
    grade: "4",
    rank: 4,
    min: 5.5,
    max: 6,
    tone: "warn"
  },
  {
    grade: "5",
    rank: 5,
    min: 6,
    max: 6.5,
    tone: "bad"
  },
  {
    grade: "6",
    rank: 6,
    min: 6.5,
    max: null,
    tone: "bad"
  }
];
var LTC_HOSPITAL_DOCTOR_GRADES = [
  {
    grade: "1",
    rank: 1,
    maxRatioInclusive: 35,
    specialistRatioMin: 0.5
  },
  {
    grade: "2",
    rank: 2,
    maxRatioInclusive: 35,
    specialistRatioBelow: 0.5
  },
  {
    grade: "3",
    rank: 3,
    minRatioExclusive: 35,
    maxRatioInclusive: 40
  },
  {
    grade: "4",
    rank: 4,
    minRatioExclusive: 40
  }
];
var GENERAL_TABLE_ORG_TYPES = /* @__PURE__ */ new Set([
  OrganizationType.HOSPITAL,
  OrganizationType.MENTAL_HOSPITAL,
  OrganizationType.DENTAL_HOSPITAL,
  OrganizationType.ORIENTAL_HOSPITAL
]);
function resolveNursingGrade(ratio, orgType) {
  if (!(Number.isFinite(ratio) && ratio > 0)) {
    return null;
  }
  const isLtc = orgType === OrganizationType.LONG_TERM_CARE_HOSPITAL;
  const kind = isLtc ? "ltc" : "general";
  const bands = isLtc ? LTC_HOSPITAL_NURSING_GRADES : GENERAL_WARD_NURSING_GRADES;
  const isFallback = !(isLtc || GENERAL_TABLE_ORG_TYPES.has(orgType));
  const band = bands.find((b) => (b.min === null || ratio >= b.min) && (b.max === null || ratio < b.max));
  if (!band) {
    return null;
  }
  return {
    grade: band.grade,
    rank: band.rank,
    kind,
    tone: band.tone,
    isFallback
  };
}
__name(resolveNursingGrade, "resolveNursingGrade");

// src/constants/permissions.ts
var Resource = {
  EMPLOYEE: "employee",
  TEAM: "team",
  ORGANIZATION: "organization",
  ROLE: "role",
  ATTENDANCE: "attendance",
  LEAVE: "leave",
  // 연차 촉진(사용 촉진 통지) 실행 — leave 와 분리된 HR 전용 조직 전체 권한.
  // 통지 발송·재발급·2차 지정 등 "실행"만 이 리소스로 가리고, 목록 조회는 leave:read.
  ANNUAL_LEAVE_PROMOTION: "annualLeavePromotion",
  OVERTIME: "overtime",
  OFFSITE_WORK: "offsiteWork",
  PAYROLL: "payroll",
  ALLOWANCE: "allowance",
  DEDUCTION: "deduction",
  SALARY_GRADE: "salaryGrade",
  INCENTIVE: "incentive",
  CERTIFICATION: "certification",
  EDUCATION: "education",
  RESIGNATION: "resignation",
  YEAR_END_SETTLEMENT: "yearEndSettlement",
  DOCUMENT: "document",
  SCHEDULE: "schedule",
  INVENTORY: "inventory",
  GENERAL_AFFAIRS: "generalAffairs",
  CONVERSATION: "conversation",
  MESSAGE: "message",
  NOTIFICATION: "notification",
  STORAGE: "storage",
  TEAM_DRIVE: "teamDrive",
  SETTING: "setting",
  SYSTEM: "system",
  AI: "ai",
  /** 직원 앱(hereby Works) 전용 AI 어시스턴트 — 관리직 AI(`ai`)와 별개로 역할에 붙인다(MED-800). */
  AI_APP: "aiApp",
  // CS 리포트 — 인앱 불편·버그 접수. 모든 역할이 self scope 로 접수·조회·취소한다.
  CS_REPORT: "csReport",
  // 병동 페이지 관리자(PM-01) — 병동 관리 화면 하나만 여는 권한.
  // 시스템 관리자가 아니어도 admin 에 들어와 「병동 관리」만 쓴다. 이 권한을 가진 사람은
  // 병동 운영에 꼭 필요한 범위에서만 다른 리소스(명부·후보 검색·연결 팀 합류)를 읽고 쓴다.
  WARD: "ward",
  /** 권한 미리보기(다른 직원으로 보기) — 예전엔 isSystemAdmin 전용이던 기능(2026-10-21) */
  IMPERSONATION: "impersonation",
  /** 메신저 대화 복구(복구 키 금고) — 예전엔 isSystemAdmin 전용 */
  CHAT_RECOVERY: "chatRecovery",
  /** 시트 관리자 — 남의 비공개 시트까지 보고 고치고 지운다(예전엔 isSystemAdmin 전용) */
  SHEET: "sheet",
  // Legacy resource names (used by older routers, kept for backwards compat)
  LEAVE_REQUEST: "leave-request",
  NURSE_SCHEDULER: "nurse-scheduler",
  FIXED_INCENTIVE: "fixedIncentive",
  EDUCATION_SUBSIDY: "educationSubsidy"
};
var Action = {
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
  APPROVE: "approve",
  MANAGE: "manage",
  EXECUTE: "execute"
};
var DbAction = {
  READ: "read",
  WRITE: "write",
  DELETE: "delete",
  EXECUTE: "execute",
  APPROVE: "approve",
  MANAGE: "manage"
};
var Scope = {
  SELF: "self",
  TEAM: "team",
  ALL: "all"
};
function perm(resource, action) {
  return `${resource}:${action}`;
}
__name(perm, "perm");
function scoped(resource, action, scope) {
  return `${resource}:${action}.${scope}`;
}
__name(scoped, "scoped");
var P = {
  // ── Employee ──
  EMPLOYEE_READ: perm(Resource.EMPLOYEE, Action.READ),
  EMPLOYEE_CREATE: perm(Resource.EMPLOYEE, Action.CREATE),
  EMPLOYEE_UPDATE: perm(Resource.EMPLOYEE, Action.UPDATE),
  EMPLOYEE_DELETE: perm(Resource.EMPLOYEE, Action.DELETE),
  EMPLOYEE_MANAGE: perm(Resource.EMPLOYEE, Action.MANAGE),
  EMPLOYEE_READ_SELF: scoped(Resource.EMPLOYEE, Action.READ, Scope.SELF),
  EMPLOYEE_WRITE_SELF: scoped(Resource.EMPLOYEE, Action.UPDATE, Scope.SELF),
  EMPLOYEE_READ_TEAM: scoped(Resource.EMPLOYEE, Action.READ, Scope.TEAM),
  // ── Attendance ──
  ATTENDANCE_READ: perm(Resource.ATTENDANCE, Action.READ),
  ATTENDANCE_CREATE: perm(Resource.ATTENDANCE, Action.CREATE),
  ATTENDANCE_UPDATE: perm(Resource.ATTENDANCE, Action.UPDATE),
  ATTENDANCE_DELETE: perm(Resource.ATTENDANCE, Action.DELETE),
  ATTENDANCE_APPROVE: perm(Resource.ATTENDANCE, Action.APPROVE),
  ATTENDANCE_MANAGE: perm(Resource.ATTENDANCE, Action.MANAGE),
  ATTENDANCE_READ_SELF: scoped(Resource.ATTENDANCE, Action.READ, Scope.SELF),
  ATTENDANCE_WRITE_SELF: scoped(Resource.ATTENDANCE, Action.CREATE, Scope.SELF),
  ATTENDANCE_READ_TEAM: scoped(Resource.ATTENDANCE, Action.READ, Scope.TEAM),
  ATTENDANCE_WRITE_TEAM: scoped(Resource.ATTENDANCE, Action.CREATE, Scope.TEAM),
  ATTENDANCE_APPROVE_TEAM: scoped(Resource.ATTENDANCE, Action.APPROVE, Scope.TEAM),
  // ── Leave ──
  LEAVE_READ: perm(Resource.LEAVE, Action.READ),
  LEAVE_CREATE: perm(Resource.LEAVE, Action.CREATE),
  LEAVE_UPDATE: perm(Resource.LEAVE, Action.UPDATE),
  LEAVE_APPROVE: perm(Resource.LEAVE, Action.APPROVE),
  LEAVE_READ_SELF: scoped(Resource.LEAVE, Action.READ, Scope.SELF),
  LEAVE_WRITE_SELF: scoped(Resource.LEAVE, Action.CREATE, Scope.SELF),
  LEAVE_READ_TEAM: scoped(Resource.LEAVE, Action.READ, Scope.TEAM),
  LEAVE_APPROVE_TEAM: scoped(Resource.LEAVE, Action.APPROVE, Scope.TEAM),
  ANNUAL_LEAVE_PROMOTION_EXECUTE: perm(Resource.ANNUAL_LEAVE_PROMOTION, Action.EXECUTE),
  // ── Overtime ──
  OVERTIME_READ: perm(Resource.OVERTIME, Action.READ),
  OVERTIME_CREATE: perm(Resource.OVERTIME, Action.CREATE),
  OVERTIME_UPDATE: perm(Resource.OVERTIME, Action.UPDATE),
  OVERTIME_DELETE: perm(Resource.OVERTIME, Action.DELETE),
  OVERTIME_APPROVE: perm(Resource.OVERTIME, Action.APPROVE),
  OVERTIME_READ_SELF: scoped(Resource.OVERTIME, Action.READ, Scope.SELF),
  OVERTIME_WRITE_SELF: scoped(Resource.OVERTIME, Action.CREATE, Scope.SELF),
  OVERTIME_READ_TEAM: scoped(Resource.OVERTIME, Action.READ, Scope.TEAM),
  OVERTIME_APPROVE_TEAM: scoped(Resource.OVERTIME, Action.APPROVE, Scope.TEAM),
  // ── Offsite Work (외근) ──
  OFFSITE_WORK_READ: perm(Resource.OFFSITE_WORK, Action.READ),
  OFFSITE_WORK_CREATE: perm(Resource.OFFSITE_WORK, Action.CREATE),
  OFFSITE_WORK_UPDATE: perm(Resource.OFFSITE_WORK, Action.UPDATE),
  OFFSITE_WORK_DELETE: perm(Resource.OFFSITE_WORK, Action.DELETE),
  OFFSITE_WORK_APPROVE: perm(Resource.OFFSITE_WORK, Action.APPROVE),
  OFFSITE_WORK_MANAGE: perm(Resource.OFFSITE_WORK, Action.MANAGE),
  OFFSITE_WORK_READ_SELF: scoped(Resource.OFFSITE_WORK, Action.READ, Scope.SELF),
  OFFSITE_WORK_WRITE_SELF: scoped(Resource.OFFSITE_WORK, Action.CREATE, Scope.SELF),
  OFFSITE_WORK_READ_TEAM: scoped(Resource.OFFSITE_WORK, Action.READ, Scope.TEAM),
  OFFSITE_WORK_APPROVE_TEAM: scoped(Resource.OFFSITE_WORK, Action.APPROVE, Scope.TEAM),
  // ── Payroll ──
  PAYROLL_READ: perm(Resource.PAYROLL, Action.READ),
  PAYROLL_CREATE: perm(Resource.PAYROLL, Action.CREATE),
  PAYROLL_UPDATE: perm(Resource.PAYROLL, Action.UPDATE),
  PAYROLL_APPROVE: perm(Resource.PAYROLL, Action.APPROVE),
  PAYROLL_EXECUTE: perm(Resource.PAYROLL, Action.EXECUTE),
  PAYROLL_MANAGE: perm(Resource.PAYROLL, Action.MANAGE),
  PAYROLL_READ_SELF: scoped(Resource.PAYROLL, Action.READ, Scope.SELF),
  // ── Incentive ──
  INCENTIVE_READ: perm(Resource.INCENTIVE, Action.READ),
  INCENTIVE_CREATE: perm(Resource.INCENTIVE, Action.CREATE),
  INCENTIVE_UPDATE: perm(Resource.INCENTIVE, Action.UPDATE),
  INCENTIVE_DELETE: perm(Resource.INCENTIVE, Action.DELETE),
  INCENTIVE_APPROVE: perm(Resource.INCENTIVE, Action.APPROVE),
  INCENTIVE_READ_SELF: scoped(Resource.INCENTIVE, Action.READ, Scope.SELF),
  INCENTIVE_WRITE_SELF: scoped(Resource.INCENTIVE, Action.CREATE, Scope.SELF),
  INCENTIVE_READ_TEAM: scoped(Resource.INCENTIVE, Action.READ, Scope.TEAM),
  INCENTIVE_APPROVE_TEAM: scoped(Resource.INCENTIVE, Action.APPROVE, Scope.TEAM),
  // ── Certification ──
  CERTIFICATION_READ: perm(Resource.CERTIFICATION, Action.READ),
  CERTIFICATION_CREATE: perm(Resource.CERTIFICATION, Action.CREATE),
  CERTIFICATION_MANAGE: perm(Resource.CERTIFICATION, Action.MANAGE),
  CERTIFICATION_READ_SELF: scoped(Resource.CERTIFICATION, Action.READ, Scope.SELF),
  CERTIFICATION_WRITE_SELF: scoped(Resource.CERTIFICATION, Action.CREATE, Scope.SELF),
  CERTIFICATION_READ_TEAM: scoped(Resource.CERTIFICATION, Action.READ, Scope.TEAM),
  // ── Education ──
  EDUCATION_READ: perm(Resource.EDUCATION, Action.READ),
  EDUCATION_CREATE: perm(Resource.EDUCATION, Action.CREATE),
  EDUCATION_MANAGE: perm(Resource.EDUCATION, Action.MANAGE),
  EDUCATION_READ_SELF: scoped(Resource.EDUCATION, Action.READ, Scope.SELF),
  EDUCATION_WRITE_SELF: scoped(Resource.EDUCATION, Action.CREATE, Scope.SELF),
  EDUCATION_READ_TEAM: scoped(Resource.EDUCATION, Action.READ, Scope.TEAM),
  // ── Document ──
  DOCUMENT_READ: perm(Resource.DOCUMENT, Action.READ),
  DOCUMENT_CREATE: perm(Resource.DOCUMENT, Action.CREATE),
  DOCUMENT_UPDATE: perm(Resource.DOCUMENT, Action.UPDATE),
  DOCUMENT_DELETE: perm(Resource.DOCUMENT, Action.DELETE),
  DOCUMENT_APPROVE: perm(Resource.DOCUMENT, Action.APPROVE),
  DOCUMENT_READ_SELF: scoped(Resource.DOCUMENT, Action.READ, Scope.SELF),
  DOCUMENT_WRITE_SELF: scoped(Resource.DOCUMENT, Action.CREATE, Scope.SELF),
  DOCUMENT_READ_TEAM: scoped(Resource.DOCUMENT, Action.READ, Scope.TEAM),
  // ── Schedule (Nurse) ──
  SCHEDULE_READ_SELF: scoped(Resource.SCHEDULE, Action.READ, Scope.SELF),
  SCHEDULE_WRITE_SELF: scoped(Resource.SCHEDULE, Action.CREATE, Scope.SELF),
  // ── Notification ──
  NOTIFICATION_READ: perm(Resource.NOTIFICATION, Action.READ),
  NOTIFICATION_UPDATE: perm(Resource.NOTIFICATION, Action.UPDATE),
  NOTIFICATION_READ_SELF: scoped(Resource.NOTIFICATION, Action.READ, Scope.SELF),
  NOTIFICATION_WRITE_SELF: scoped(Resource.NOTIFICATION, Action.UPDATE, Scope.SELF),
  // ── Team / Role / Org (admin-only, no scope) ──
  TEAM_READ: perm(Resource.TEAM, Action.READ),
  TEAM_CREATE: perm(Resource.TEAM, Action.CREATE),
  TEAM_UPDATE: perm(Resource.TEAM, Action.UPDATE),
  TEAM_DELETE: perm(Resource.TEAM, Action.DELETE),
  TEAM_MANAGE: perm(Resource.TEAM, Action.MANAGE),
  ROLE_READ: perm(Resource.ROLE, Action.READ),
  ROLE_CREATE: perm(Resource.ROLE, Action.CREATE),
  ROLE_UPDATE: perm(Resource.ROLE, Action.UPDATE),
  ROLE_DELETE: perm(Resource.ROLE, Action.DELETE),
  ORGANIZATION_READ: perm(Resource.ORGANIZATION, Action.READ),
  ORGANIZATION_UPDATE: perm(Resource.ORGANIZATION, Action.UPDATE),
  SETTING_UPDATE: perm(Resource.SETTING, Action.UPDATE),
  // ── Salary Grade ──
  SALARY_GRADE_READ: perm(Resource.SALARY_GRADE, Action.READ),
  SALARY_GRADE_CREATE: perm(Resource.SALARY_GRADE, Action.CREATE),
  SALARY_GRADE_UPDATE: perm(Resource.SALARY_GRADE, Action.UPDATE),
  SALARY_GRADE_DELETE: perm(Resource.SALARY_GRADE, Action.DELETE),
  // ── Allowance / Deduction ──
  ALLOWANCE_READ: perm(Resource.ALLOWANCE, Action.READ),
  ALLOWANCE_CREATE: perm(Resource.ALLOWANCE, Action.CREATE),
  ALLOWANCE_MANAGE: perm(Resource.ALLOWANCE, Action.MANAGE),
  DEDUCTION_READ: perm(Resource.DEDUCTION, Action.READ),
  DEDUCTION_CREATE: perm(Resource.DEDUCTION, Action.CREATE),
  DEDUCTION_MANAGE: perm(Resource.DEDUCTION, Action.MANAGE),
  // 범위 표준화(MED-910) — 수당·공제·퇴사·연말정산 기록도 본인·팀 범위로 읽을 수 있다
  ALLOWANCE_READ_TEAM: scoped(Resource.ALLOWANCE, Action.READ, Scope.TEAM),
  ALLOWANCE_READ_SELF: scoped(Resource.ALLOWANCE, Action.READ, Scope.SELF),
  DEDUCTION_READ_TEAM: scoped(Resource.DEDUCTION, Action.READ, Scope.TEAM),
  DEDUCTION_READ_SELF: scoped(Resource.DEDUCTION, Action.READ, Scope.SELF),
  // ── Resignation / Year-End Settlement ──
  RESIGNATION_READ: perm(Resource.RESIGNATION, Action.READ),
  RESIGNATION_CREATE: perm(Resource.RESIGNATION, Action.CREATE),
  YEAR_END_SETTLEMENT_READ: perm(Resource.YEAR_END_SETTLEMENT, Action.READ),
  YEAR_END_SETTLEMENT_CREATE: perm(Resource.YEAR_END_SETTLEMENT, Action.CREATE),
  RESIGNATION_READ_TEAM: scoped(Resource.RESIGNATION, Action.READ, Scope.TEAM),
  RESIGNATION_READ_SELF: scoped(Resource.RESIGNATION, Action.READ, Scope.SELF),
  YEAR_END_SETTLEMENT_READ_TEAM: scoped(Resource.YEAR_END_SETTLEMENT, Action.READ, Scope.TEAM),
  YEAR_END_SETTLEMENT_READ_SELF: scoped(Resource.YEAR_END_SETTLEMENT, Action.READ, Scope.SELF),
  // ── Inventory ──
  INVENTORY_READ: perm(Resource.INVENTORY, Action.READ),
  INVENTORY_MANAGE: perm(Resource.INVENTORY, Action.MANAGE),
  // ── General Affairs ──
  GENERAL_AFFAIRS_READ: perm(Resource.GENERAL_AFFAIRS, Action.READ),
  GENERAL_AFFAIRS_CREATE: perm(Resource.GENERAL_AFFAIRS, Action.CREATE),
  GENERAL_AFFAIRS_UPDATE: perm(Resource.GENERAL_AFFAIRS, Action.UPDATE),
  GENERAL_AFFAIRS_DELETE: perm(Resource.GENERAL_AFFAIRS, Action.DELETE),
  GENERAL_AFFAIRS_MANAGE: perm(Resource.GENERAL_AFFAIRS, Action.MANAGE),
  // ── Conversation / Message ──
  CONVERSATION_READ: perm(Resource.CONVERSATION, Action.READ),
  CONVERSATION_CREATE: perm(Resource.CONVERSATION, Action.CREATE),
  CONVERSATION_UPDATE: perm(Resource.CONVERSATION, Action.UPDATE),
  MESSAGE_READ: perm(Resource.MESSAGE, Action.READ),
  MESSAGE_CREATE: perm(Resource.MESSAGE, Action.CREATE),
  MESSAGE_UPDATE: perm(Resource.MESSAGE, Action.UPDATE),
  // ── Storage ──
  STORAGE_READ: perm(Resource.STORAGE, Action.READ),
  STORAGE_CREATE: perm(Resource.STORAGE, Action.CREATE),
  // ── Team Drive (드라이브) ──
  TEAM_DRIVE_READ: perm(Resource.TEAM_DRIVE, Action.READ),
  TEAM_DRIVE_CREATE: perm(Resource.TEAM_DRIVE, Action.CREATE),
  TEAM_DRIVE_UPDATE: perm(Resource.TEAM_DRIVE, Action.UPDATE),
  TEAM_DRIVE_MANAGE: perm(Resource.TEAM_DRIVE, Action.MANAGE),
  // ── System ──
  SYSTEM_ADMIN: perm(Resource.SYSTEM, Action.MANAGE),
  /** 권한 미리보기 실행 */
  IMPERSONATION_EXECUTE: perm(Resource.IMPERSONATION, Action.EXECUTE),
  /** 대화 복구 관리 */
  CHAT_RECOVERY_MANAGE: perm(Resource.CHAT_RECOVERY, Action.MANAGE),
  /** 모든 시트 관리(비공개 포함) */
  SHEET_MANAGE: perm(Resource.SHEET, Action.MANAGE),
  /** 내 시트 만들기·편집 — 본인 행만 (급여 권한 없이 개인 시트) */
  SHEET_WRITE_SELF: scoped(Resource.SHEET, Action.UPDATE, Scope.SELF),
  /** 내 시트 만들기·편집 — 팀원 행까지 */
  SHEET_WRITE_TEAM: scoped(Resource.SHEET, Action.UPDATE, Scope.TEAM),
  // ── AI ──
  AI_EXECUTE: perm(Resource.AI, Action.EXECUTE),
  AI_EXECUTE_SELF: scoped(Resource.AI, Action.EXECUTE, Scope.SELF),
  AI_MANAGE: perm(Resource.AI, Action.MANAGE),
  /** 직원 앱 AI 어시스턴트 사용 — 본인 데이터만 다루므로 self 범위 하나뿐 */
  AI_APP_EXECUTE: perm(Resource.AI_APP, Action.EXECUTE),
  AI_APP_EXECUTE_SELF: scoped(Resource.AI_APP, Action.EXECUTE, Scope.SELF)
};
var TEAM_LEADER_GRANTS = [
  {
    resource: Resource.EMPLOYEE,
    action: Action.READ
  },
  {
    resource: Resource.ATTENDANCE,
    action: Action.READ
  },
  {
    resource: Resource.ATTENDANCE,
    action: Action.APPROVE
  },
  {
    resource: Resource.LEAVE,
    action: Action.READ
  },
  {
    resource: Resource.LEAVE,
    action: Action.APPROVE
  },
  {
    resource: Resource.OVERTIME,
    action: Action.READ
  },
  {
    resource: Resource.OVERTIME,
    action: Action.APPROVE
  },
  {
    resource: Resource.OFFSITE_WORK,
    action: Action.READ
  },
  {
    resource: Resource.OFFSITE_WORK,
    action: Action.APPROVE
  },
  {
    resource: Resource.INCENTIVE,
    action: Action.READ
  },
  {
    resource: Resource.INCENTIVE,
    action: Action.APPROVE
  },
  {
    resource: Resource.SCHEDULE,
    action: Action.READ
  },
  {
    resource: Resource.PAYROLL,
    action: Action.READ
  },
  {
    resource: Resource.DOCUMENT,
    action: Action.READ
  },
  {
    resource: Resource.CERTIFICATION,
    action: Action.READ
  },
  {
    resource: Resource.EDUCATION,
    action: Action.READ
  }
];
var TEAM_LEADER_GRANT_CODES = TEAM_LEADER_GRANTS.map((g) => `${g.resource}:${g.action}.${Scope.TEAM}`);
function teamLeaderGrantCovers(resource, action) {
  return TEAM_LEADER_GRANTS.some((g) => g.resource === resource && g.action === action);
}
__name(teamLeaderGrantCovers, "teamLeaderGrantCovers");
var RESOURCE_LABELS_KO = {
  employee: "\uC9C1\uC6D0",
  team: "\uD300",
  organization: "\uC870\uC9C1",
  role: "\uC9C1\uCC45",
  attendance: "\uADFC\uD0DC",
  leave: "\uD734\uAC00",
  annualLeavePromotion: "\uC5F0\uCC28 \uCD09\uC9C4",
  overtime: "\uCD08\uACFC\uADFC\uBB34",
  offsiteWork: "\uC678\uADFC",
  csReport: "CS \uB9AC\uD3EC\uD2B8",
  payroll: "\uAE09\uC5EC",
  allowance: "\uC218\uB2F9",
  deduction: "\uACF5\uC81C",
  salaryGrade: "\uD638\uBD09",
  incentive: "\uC778\uC13C\uD2F0\uBE0C",
  certification: "\uC790\uACA9\uC99D",
  education: "\uAD50\uC721",
  resignation: "\uD1F4\uC0AC",
  yearEndSettlement: "\uC5F0\uB9D0\uC815\uC0B0",
  document: "\uBB38\uC11C",
  schedule: "\uADFC\uBB34\uD45C",
  inventory: "\uC7AC\uACE0",
  generalAffairs: "\uCD1D\uBB34",
  conversation: "\uBA54\uC2E0\uC800 \uB300\uD654\uBC29",
  message: "\uBA54\uC2E0\uC800 \uBA54\uC2DC\uC9C0",
  notification: "\uC54C\uB9BC",
  storage: "\uD30C\uC77C",
  teamDrive: "\uB4DC\uB77C\uC774\uBE0C",
  setting: "\uC124\uC815",
  system: "\uC2DC\uC2A4\uD15C",
  ai: "AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
  aiApp: "\uC9C1\uC6D0 \uC571 AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
  "leave-request": "\uC5F0\uCC28 \uC124\uC815",
  "nurse-scheduler": "\uC2A4\uCF00\uC904\uB7EC \uAD00\uB9AC",
  ward: "\uBCD1\uB3D9",
  impersonation: "\uAD8C\uD55C \uBBF8\uB9AC\uBCF4\uAE30",
  chatRecovery: "\uB300\uD654 \uBCF5\uAD6C",
  sheet: "\uC2DC\uD2B8 \uAD00\uB9AC",
  fixedIncentive: "\uACE0\uC815 \uC778\uC13C\uD2F0\uBE0C",
  educationSubsidy: "\uAD50\uC721\uBE44"
};
var ACTION_LABELS_KO = {
  create: "\uC0DD\uC131",
  read: "\uC870\uD68C",
  update: "\uC218\uC815",
  delete: "\uC0AD\uC81C",
  approve: "\uC2B9\uC778",
  manage: "\uAD00\uB9AC",
  execute: "\uC2E4\uD589"
};
function formatPermissionLabelKo(resource, action) {
  const resourceLabel = RESOURCE_LABELS_KO[resource] || resource;
  const actionLabel = ACTION_LABELS_KO[action] || action;
  return `${resourceLabel} ${actionLabel}`;
}
__name(formatPermissionLabelKo, "formatPermissionLabelKo");
function hasOrgWidePermission(permissions, resource, action) {
  return (permissions ?? []).includes(`${resource}:${action}.${Scope.ALL}`);
}
__name(hasOrgWidePermission, "hasOrgWidePermission");
var ADMIN_FULL_ENTRY_PERMISSIONS = [
  {
    resource: Resource.EMPLOYEE,
    action: Action.MANAGE
  },
  {
    resource: Resource.TEAM,
    action: Action.MANAGE
  },
  {
    resource: Resource.ROLE,
    action: Action.MANAGE
  },
  {
    resource: Resource.SETTING,
    action: Action.UPDATE
  },
  {
    resource: Resource.ORGANIZATION,
    action: Action.UPDATE
  },
  {
    resource: Resource.PAYROLL,
    action: Action.MANAGE
  }
];
function canEnterAdminFull(permissions) {
  return ADMIN_FULL_ENTRY_PERMISSIONS.some((p) => hasOrgWidePermission(permissions, p.resource, p.action));
}
__name(canEnterAdminFull, "canEnterAdminFull");

// src/constants/resignation-document.ts
var RESIGNATION_DOCUMENT_TYPE = "\uC0AC\uC9C1\uC11C";
var YMD2 = /^\d{4}-\d{2}-\d{2}$/;
function resignationDocumentDetails(metadata) {
  const raw = metadata?.resignation;
  if (!raw || typeof raw !== "object") {
    return null;
  }
  const r = raw;
  const str2 = /* @__PURE__ */ __name((v) => typeof v === "string" && v.trim() ? v.trim() : void 0, "str");
  const date = str2(r.resignationDate);
  return {
    resignationDate: date && YMD2.test(date) ? date : void 0,
    reason: str2(r.reason),
    recordId: str2(r.recordId),
    appliedAt: str2(r.appliedAt)
  };
}
__name(resignationDocumentDetails, "resignationDocumentDetails");
function isResignationDocument(doc) {
  return (doc.documentType ?? "").trim() === RESIGNATION_DOCUMENT_TYPE || resignationDocumentDetails(doc.metadata) !== null;
}
__name(isResignationDocument, "isResignationDocument");
function planResignationApplication(details, today) {
  const resignationDate = details?.resignationDate ?? today;
  return {
    resignationDate,
    immediate: resignationDate <= today
  };
}
__name(planResignationApplication, "planResignationApplication");

// src/constants/role-org-scope.ts
var ROLE_SCOPE_UNSET = "__none";
function indexById(teams) {
  return new Map(teams.map((team) => [
    team.id,
    team
  ]));
}
__name(indexById, "indexById");
function byName(a, b) {
  return (a.name ?? "").localeCompare(b.name ?? "", "ko");
}
__name(byName, "byName");
function rootIn(index, teamId) {
  const seen = /* @__PURE__ */ new Set();
  let current = index.get(teamId);
  while (current) {
    if (seen.has(current.id)) {
      return null;
    }
    seen.add(current.id);
    if (!current.parentTeamId) {
      return current.id;
    }
    current = index.get(current.parentTeamId);
  }
  return null;
}
__name(rootIn, "rootIn");
function isSelfOrDescendant(index, teamId, ancestorId) {
  const seen = /* @__PURE__ */ new Set();
  let current = index.get(teamId);
  while (current && !seen.has(current.id)) {
    if (current.id === ancestorId) {
      return true;
    }
    seen.add(current.id);
    current = current.parentTeamId ? index.get(current.parentTeamId) : void 0;
  }
  return false;
}
__name(isSelfOrDescendant, "isSelfOrDescendant");
function rootTeamIdOf(teams, teamId) {
  return rootIn(indexById(teams), teamId);
}
__name(rootTeamIdOf, "rootTeamIdOf");
function roleDepartmentOptions(teams) {
  return teams.filter((team) => !team.parentTeamId).sort(byName).map((team) => ({
    id: team.id,
    label: team.name ?? ""
  }));
}
__name(roleDepartmentOptions, "roleDepartmentOptions");
function roleTeamOptionGroups(teams, departmentIds = []) {
  const children = /* @__PURE__ */ new Map();
  for (const team of teams) {
    if (team.parentTeamId) {
      const siblings = children.get(team.parentTeamId) ?? [];
      siblings.push(team);
      children.set(team.parentTeamId, siblings);
    }
  }
  for (const siblings of children.values()) {
    siblings.sort(byName);
  }
  const wanted = new Set(departmentIds);
  return roleDepartmentOptions(teams).filter((department) => wanted.size === 0 || wanted.has(department.id)).map((department) => {
    const options = [];
    const walk = /* @__PURE__ */ __name((parentId, depth) => {
      for (const kid of children.get(parentId) ?? []) {
        options.push({
          id: kid.id,
          label: "\u2014 ".repeat(depth) + (kid.name ?? "")
        });
        walk(kid.id, depth + 1);
      }
    }, "walk");
    walk(department.id, 0);
    return {
      ...department,
      options
    };
  }).filter((group) => group.options.length > 0);
}
__name(roleTeamOptionGroups, "roleTeamOptionGroups");
function roleScopeTeamLabel(teams, teamId) {
  const index = indexById(teams);
  const team = index.get(teamId);
  if (!team) {
    return "";
  }
  const name = team.name ?? "";
  const duplicated = teams.some((other) => other.id !== teamId && (other.name ?? "") === name);
  const parent = team.parentTeamId ? index.get(team.parentTeamId) : void 0;
  return duplicated && parent ? `${parent.name ?? ""} > ${name}` : name;
}
__name(roleScopeTeamLabel, "roleScopeTeamLabel");
function normalizeRoleOrgScope(teams, scope) {
  const index = indexById(teams);
  const departments = [
    ...new Set(scope.departmentTeamIds ?? [])
  ].filter((id) => {
    const team = index.get(id);
    return !!team && !team.parentTeamId;
  });
  const chosen = new Set(departments);
  const teamIds = [
    ...new Set(scope.teamIds ?? [])
  ].filter((id) => {
    const team = index.get(id);
    if (!team?.parentTeamId) {
      return false;
    }
    const root = rootIn(index, id);
    return !!root && (chosen.size === 0 || chosen.has(root));
  });
  return {
    departmentTeamIds: departments.length > 0 ? departments : null,
    teamIds: teamIds.length > 0 ? teamIds : null
  };
}
__name(normalizeRoleOrgScope, "normalizeRoleOrgScope");
function pickRoleScopeId(ids, id, multi) {
  if (!id) {
    return multi ? [
      ...ids
    ] : [];
  }
  if (multi) {
    return ids.includes(id) ? [
      ...ids
    ] : [
      ...ids,
      id
    ];
  }
  return [
    id
  ];
}
__name(pickRoleScopeId, "pickRoleScopeId");
function roleMatchesOrgFilter(teams, role, departmentFilter, teamFilter) {
  const index = indexById(teams);
  const scope = normalizeRoleOrgScope(teams, role);
  const departments = scope.departmentTeamIds ?? [];
  const picked = scope.teamIds ?? [];
  if (departmentFilter === ROLE_SCOPE_UNSET) {
    if (departments.length > 0 || picked.length > 0) {
      return false;
    }
  } else if (departmentFilter && !departments.includes(departmentFilter) && !picked.some((id) => rootIn(index, id) === departmentFilter)) {
    return false;
  }
  if (teamFilter === ROLE_SCOPE_UNSET) {
    return picked.length === 0;
  }
  if (teamFilter) {
    return picked.some((id) => isSelfOrDescendant(index, id, teamFilter));
  }
  return true;
}
__name(roleMatchesOrgFilter, "roleMatchesOrgFilter");

// src/utils/shift-day.ts
var SHIFT_DAY_KEYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday"
];
function shiftDayKeyOf(date) {
  if (typeof date === "string") {
    const [y, m, d] = date.slice(0, 10).split("-").map(Number);
    return SHIFT_DAY_KEYS[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
  }
  return SHIFT_DAY_KEYS[date.getDay()];
}
__name(shiftDayKeyOf, "shiftDayKeyOf");
function num(value, fallback) {
  if (value === null || value === void 0 || value === "") {
    return fallback;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}
__name(num, "num");
function minutesOfDay(time) {
  if (!time) {
    return null;
  }
  const [h, m] = time.split(":").map(Number);
  if (!(Number.isFinite(h) && Number.isFinite(m))) {
    return null;
  }
  return h * 60 + m;
}
__name(minutesOfDay, "minutesOfDay");
function resolveShiftDay(shift, date) {
  const override = shift.dayOverrides?.[shiftDayKeyOf(date)] ?? null;
  const pick = /* @__PURE__ */ __name((key) => {
    const value = override?.[key];
    return value === null || value === void 0 || value === "" ? void 0 : value;
  }, "pick");
  const startTime = pick("startTime") ?? shift.startTime ?? "";
  const endTime = pick("endTime") ?? shift.endTime ?? "";
  const startMinutes = minutesOfDay(startTime);
  const endMinutes = minutesOfDay(endTime);
  return {
    startTime,
    endTime,
    workHours: num(pick("workHours") ?? shift.workHours, 0),
    breakHours: num(pick("breakHours") ?? shift.breakHours, 0),
    overtimeBreakHours: num(pick("overtimeBreakHours") ?? shift.overtimeBreakHours, 0),
    isOvernight: startMinutes !== null && endMinutes !== null && endMinutes < startMinutes,
    hasOverride: Boolean(override && Object.keys(override).length > 0)
  };
}
__name(resolveShiftDay, "resolveShiftDay");

// src/constants/shift-schedule-text.ts
var SHIFT_DAY_SHORT_LABELS = {
  monday: "\uC6D4",
  tuesday: "\uD654",
  wednesday: "\uC218",
  thursday: "\uBAA9",
  friday: "\uAE08",
  saturday: "\uD1A0",
  sunday: "\uC77C"
};
var WEEK_ORDER = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
];
var EMPTY = {
  workDays: null,
  workHours: null,
  breakTime: null
};
var hhmm = /* @__PURE__ */ __name((t) => t ? t.slice(0, 5) : "", "hhmm");
function formatHoursKo(hours) {
  const total = Math.round((Number(hours) || 0) * 60);
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h > 0 && m > 0) {
    return `${h}\uC2DC\uAC04 ${m}\uBD84`;
  }
  if (h > 0) {
    return `${h}\uC2DC\uAC04`;
  }
  return `${m}\uBD84`;
}
__name(formatHoursKo, "formatHoursKo");
function applicableDayKeys(shift) {
  const days = shift.applicableDays;
  if (!days || Object.keys(days).length === 0) {
    return WEEK_ORDER.slice(0, 5);
  }
  return WEEK_ORDER.filter((k) => days[k] === true);
}
__name(applicableDayKeys, "applicableDayKeys");
function formatDayRange(keys) {
  const idx = keys.map((k) => WEEK_ORDER.indexOf(k)).filter((i) => i >= 0).sort((a, b) => a - b);
  const runs = [];
  for (const i of idx) {
    const last = runs[runs.length - 1];
    if (last && last[last.length - 1] === i - 1) {
      last.push(i);
    } else {
      runs.push([
        i
      ]);
    }
  }
  return runs.map((run) => run.length >= 3 ? `${SHIFT_DAY_SHORT_LABELS[WEEK_ORDER[run[0]]]}\u2013${SHIFT_DAY_SHORT_LABELS[WEEK_ORDER[run[run.length - 1]]]}` : run.map((i) => SHIFT_DAY_SHORT_LABELS[WEEK_ORDER[i]]).join("\xB7")).join("\xB7");
}
__name(formatDayRange, "formatDayRange");
var dateForDay = /* @__PURE__ */ __name((key) => {
  const d = new Date(Date.UTC(2024, 0, 7 + SHIFT_DAY_KEYS.indexOf(key)));
  return d;
}, "dateForDay");
var timeRange = /* @__PURE__ */ __name((start, end, overnight) => `${hhmm(start)}\u2013${hhmm(end)}${overnight ? "(\uC775\uC77C)" : ""}`, "timeRange");
function describeShiftHours(shift) {
  if (!(shift.startTime && shift.endTime)) {
    return null;
  }
  const days = applicableDayKeys(shift);
  const groups = /* @__PURE__ */ new Map();
  for (const day of days) {
    const t = resolveShiftDay(shift, dateForDay(day));
    const label = timeRange(t.startTime, t.endTime, t.isOvernight);
    groups.set(label, [
      ...groups.get(label) ?? [],
      day
    ]);
  }
  if (groups.size <= 1) {
    const only = groups.keys().next().value;
    return only ?? timeRange(shift.startTime, shift.endTime, hhmm(shift.endTime) <= hhmm(shift.startTime));
  }
  return [
    ...groups.entries()
  ].map(([label, ds]) => `${formatDayRange(ds)} ${label}`).join(" \xB7 ");
}
__name(describeShiftHours, "describeShiftHours");
function describeShiftBreak(shift) {
  if (shift.breakHours === null || shift.breakHours === void 0) {
    return null;
  }
  const days = applicableDayKeys(shift);
  const groups = /* @__PURE__ */ new Map();
  for (const day of days) {
    const t = resolveShiftDay(shift, dateForDay(day));
    const label = formatHoursKo(t.breakHours);
    groups.set(label, [
      ...groups.get(label) ?? [],
      day
    ]);
  }
  if (groups.size <= 1) {
    return formatHoursKo(shift.breakHours);
  }
  const [main, ...rest] = [
    ...groups.entries()
  ].sort((a, b) => b[1].length - a[1].length);
  const exceptions = rest.map(([label, ds]) => `${formatDayRange(ds)} ${label === "0\uBD84" ? "\uC5C6\uC74C" : label}`).join(" \xB7 ");
  return `${main[0]}(${exceptions})`;
}
__name(describeShiftBreak, "describeShiftBreak");
function describeShiftSchedule(input) {
  const active = input.shifts.filter((s) => s.isActive !== false);
  const single = input.shiftId ? input.shifts.find((s) => s.id === input.shiftId) ?? null : active.length === 1 ? active[0] : null;
  if (single) {
    const days = applicableDayKeys(single);
    return {
      workDays: `\uC8FC${days.length}\uC77C(${formatDayRange(days)})`,
      workHours: describeShiftHours(single),
      breakTime: describeShiftBreak(single)
    };
  }
  if (active.length === 0) {
    return EMPTY;
  }
  const union = WEEK_ORDER.filter((k) => active.some((s) => applicableDayKeys(s).includes(k)));
  const hours = active.map((s) => {
    const h = describeShiftHours(s);
    if (s.name && s.startTime && s.name.includes(hhmm(s.startTime))) {
      return s.name;
    }
    return h ? `${s.name ? `${s.name} ` : ""}${h}` : null;
  }).filter((v) => !!v);
  const breaks = /* @__PURE__ */ new Map();
  for (const s of active) {
    const b = describeShiftBreak(s) ?? "-";
    breaks.set(b, [
      ...breaks.get(b) ?? [],
      s
    ]);
  }
  const breakText = breaks.size === 1 ? breaks.keys().next().value ?? null : [
    ...breaks.entries()
  ].map(([b, ss]) => `${ss.map((s) => s.name ?? "").filter(Boolean).join("\xB7")} ${b}`).join(" \xB7 ");
  const shiftCount = active.length;
  return {
    workDays: `\uC8FC${union.length}\uC77C ${shiftCount}\uAD50\uB300(${formatDayRange(union)})`,
    workHours: hours.length ? hours.join(" / ") : null,
    breakTime: breakText === "-" ? null : breakText
  };
}
__name(describeShiftSchedule, "describeShiftSchedule");
function deriveMonthlyStandardHours(input) {
  const active = input.shifts.filter((s) => s.isActive !== false);
  const single = input.shiftId ? input.shifts.find((s) => s.id === input.shiftId) ?? null : active.length === 1 ? active[0] : null;
  const pool = single ? [
    single
  ] : active;
  if (pool.length === 0) {
    return null;
  }
  const weekly = pool.map((s) => {
    const days = applicableDayKeys(s);
    const hours = days.reduce((sum, d) => sum + resolveShiftDay(s, dateForDay(d)).workHours, 0);
    const paidRest = hours >= 15 && days.length > 0 ? hours / days.length : 0;
    return {
      hours,
      paidRest
    };
  });
  const avg = weekly.reduce((a, w) => a + w.hours + w.paidRest, 0) / weekly.length;
  const monthly = avg * 4.345;
  const withPaidRest = weekly.some((w) => w.paidRest > 0);
  return withPaidRest ? Math.round(monthly) : Math.round(monthly * 100) / 100;
}
__name(deriveMonthlyStandardHours, "deriveMonthlyStandardHours");

// src/constants/team-approval-lines.ts
var APPROVAL_LINE_TYPES = [
  "leave",
  "overtime",
  "offsite_work",
  "incentive",
  "treatment_session",
  "attendance_correction"
];
var APPROVAL_LINE_TYPE_LABEL = {
  leave: "\uD734\uAC00",
  overtime: "\uC5F0\uC7A5\uADFC\uBB34",
  offsite_work: "\uC678\uADFC",
  incentive: "\uC778\uC13C\uD2F0\uBE0C",
  treatment_session: "\uCE58\uB8CC \uC138\uC158",
  attendance_correction: "\uCD9C\uD1F4\uADFC \uC815\uC815"
};
function allowModeOf(team) {
  if (!team || team.approvalAllowCustom === null || team.approvalAllowCustom === void 0) {
    return "inherit";
  }
  return team.approvalAllowCustom ? "on" : "off";
}
__name(allowModeOf, "allowModeOf");
function allowValueOf(mode) {
  return mode === "inherit" ? null : mode === "on";
}
__name(allowValueOf, "allowValueOf");
function inheritHint(ctx) {
  if (!ctx) {
    return "";
  }
  if (!ctx.orgPolicy.allowCustom) {
    return "\uC9C0\uAE08\uC740 \uB9C9\uC74C \xB7 \uBCD1\uC6D0 \uC124\uC815";
  }
  const up = ctx.inheritedAllowCustom;
  if (up.teamId) {
    return `\uC9C0\uAE08\uC740 ${up.allowCustom ? "\uD5C8\uC6A9" : "\uB9C9\uC74C"} \xB7 ${up.teamName ?? "\uC0C1\uC704 \uD300"} \uC124\uC815`;
  }
  return "\uC9C0\uAE08\uC740 \uD5C8\uC6A9 \xB7 \uBCD1\uC6D0 \uC124\uC815";
}
__name(inheritHint, "inheritHint");
function allowOnDisabledReason(ctx) {
  return ctx && !ctx.orgPolicy.allowCustom ? "\uBCD1\uC6D0 \uC124\uC815\uC774 \uAEBC\uC838 \uC788\uC5B4 \uD300\uC5D0\uC11C \uCF24 \uC218 \uC5C6\uC5B4\uC694." : "";
}
__name(allowOnDisabledReason, "allowOnDisabledReason");
function effectiveLine(ctx) {
  if (!ctx) {
    return "";
  }
  if (ctx.effective.allowCustom) {
    return "\uC774 \uD300 \uC9C1\uC6D0\uC740 \uC2E0\uCCAD\uC11C\uC5D0\uC11C \uACB0\uC7AC\uC790\uB97C \uC9C1\uC811 \uACE0\uB974\uACE0 \uB0B4 \uACB0\uC7AC\uC120\uC744 \uC4F8 \uC218 \uC788\uC5B4\uC694.";
  }
  const who = ctx.effective.customBlockedBy === "team" ? `${ctx.effective.blockingTeamName ?? "\uD300"} \uC124\uC815` : "\uBCD1\uC6D0 \uC124\uC815";
  return `${who}\uC73C\uB85C \uACB0\uC7AC\uC120\uC774 \uACE0\uC815\uB3FC \uC788\uC5B4\uC694. \uC9C1\uC6D0\uC740 \uC801\uC6A9\uB41C \uACB0\uC7AC\uC120\uC744 \uBCF4\uAE30\uB9CC \uD574\uC694.`;
}
__name(effectiveLine, "effectiveLine");
function approverLabel(approvers) {
  return approvers.map((a) => a.title ? `${a.name} ${a.title}` : a.name).join(" \u2192 ");
}
__name(approverLabel, "approverLabel");
function templateRows(ctx) {
  return APPROVAL_LINE_TYPES.map((type) => {
    const label = APPROVAL_LINE_TYPE_LABEL[type];
    const own = ctx?.templates[type] ?? null;
    if (own && own.approvers.length > 0) {
      return {
        type,
        label,
        own: true,
        approvers: own.approvers,
        hasInvalid: own.approvers.some((a) => a.valid === false),
        fallback: ""
      };
    }
    const up = ctx?.inherited[type] ?? null;
    let fallback = "\uC790\uB3D9(\uD300\uC7A5 \u2192 \uC778\uC0AC \uAD00\uB9AC\uC790)";
    if (up && up.approvers.length > 0) {
      fallback = up.teamId ? `${up.teamName ?? "\uC0C1\uC704 \uD300"} \uD300 \uAE30\uBCF8: ${approverLabel(up.approvers)}` : `\uBCD1\uC6D0 \uAE30\uBCF8: ${approverLabel(up.approvers)}`;
    }
    return {
      type,
      label,
      own: false,
      approvers: [],
      hasInvalid: false,
      fallback
    };
  });
}
__name(templateRows, "templateRows");
function candidatesToPickerEmployees(ctx, type) {
  return (ctx?.candidates[type] ?? []).map((c) => ({
    id: c.employeeId,
    name: c.name,
    employeeNumber: null,
    teamIds: [],
    teamNames: c.teams,
    jobDuty: c.title ?? c.position
  }));
}
__name(candidatesToPickerEmployees, "candidatesToPickerEmployees");
function pickerSelectionOf(ctx, type) {
  return (ctx?.templates[type]?.approvers ?? []).filter((a) => a.valid !== false).map((a) => ({
    kind: "employee",
    id: a.employeeId,
    name: a.name
  }));
}
__name(pickerSelectionOf, "pickerSelectionOf");
function approverIdsFromSelection(selection) {
  return [
    ...new Set(selection.filter((s) => s.kind === "employee").map((s) => s.id))
  ];
}
__name(approverIdsFromSelection, "approverIdsFromSelection");
var CHANGE_EVENT_LABEL = {
  team_policy_changed: "\uC9C1\uC6D0 \uC9C1\uC811 \uC9C0\uC815",
  team_template_saved: "\uD300 \uACB0\uC7AC\uC120 \uC800\uC7A5",
  team_template_cleared: "\uD300 \uACB0\uC7AC\uC120 \uC9C0\uC6C0",
  org_template_saved: "\uBCD1\uC6D0 \uAE30\uBCF8 \uACB0\uC7AC\uC120 \uC800\uC7A5",
  org_template_cleared: "\uBCD1\uC6D0 \uAE30\uBCF8 \uACB0\uC7AC\uC120 \uC9C0\uC6C0",
  org_policy_changed: "\uBCD1\uC6D0 \uC815\uCC45",
  my_line_saved: "\uB0B4 \uACB0\uC7AC\uC120 \uC800\uC7A5",
  my_line_deleted: "\uB0B4 \uACB0\uC7AC\uC120 \uC0AD\uC81C",
  approver_replaced: "\uACB0\uC7AC\uC790 \uBC14\uAFB8\uAE30"
};
function changeLogLine(log, names, formatDateTime) {
  const typeLabel = log.requestType ? APPROVAL_LINE_TYPE_LABEL[log.requestType] ?? log.requestType : "";
  const what = `${typeLabel ? `${typeLabel} ` : ""}${CHANGE_EVENT_LABEL[log.event] ?? log.event}`;
  let detail = "";
  if (log.event === "team_policy_changed") {
    const v = log.after?.allowCustom;
    detail = v === null || v === void 0 ? "\uC0C1\uC704 \uC124\uC815\uB300\uB85C" : v ? "\uC9C1\uC811 \uC9C0\uC815 \uD5C8\uC6A9" : "\uC9C1\uC811 \uC9C0\uC815 \uBD88\uAC00";
  } else {
    const ids = log.after?.approverIds;
    if (Array.isArray(ids)) {
      detail = ids.map((id) => names.get(id) ?? "\uACB0\uC7AC\uC790").join(" \u2192 ");
    }
  }
  return {
    when: formatDateTime(log.createdAt),
    who: log.actorName ?? "\uC2DC\uC2A4\uD15C",
    what,
    detail
  };
}
__name(changeLogLine, "changeLogLine");
function overviewTypes(overview) {
  const ids = overview?.types ?? APPROVAL_LINE_TYPES;
  return ids.map((id) => ({
    id,
    label: APPROVAL_LINE_TYPE_LABEL[id]
  }));
}
__name(overviewTypes, "overviewTypes");
function overviewCellText(cell, names) {
  if (!cell || cell.source === "auto" || cell.approverIds.length === 0) {
    return {
      line: "\uD300\uC7A5 \u2192 \uC778\uC0AC \uAD00\uB9AC\uC790",
      source: "\uC790\uB3D9",
      inherited: true,
      steps: 0
    };
  }
  const line = cell.approverIds.map((id) => names[id] ?? "\uACB0\uC7AC\uC790").join(" \u2192 ");
  const steps = cell.approverIds.length;
  if (cell.source === "own") {
    return {
      line,
      source: `${steps}\uB2E8\uACC4 \xB7 \uC774 \uD300`,
      inherited: false,
      steps
    };
  }
  if (cell.source === "parent") {
    return {
      line,
      source: `${cell.teamName ?? "\uC0C1\uC704 \uD300"} \uACB0\uC7AC\uC120 \uC801\uC6A9`,
      inherited: true,
      steps
    };
  }
  return {
    line,
    source: "\uBCD1\uC6D0 \uAE30\uBCF8 \uC801\uC6A9",
    inherited: true,
    steps
  };
}
__name(overviewCellText, "overviewCellText");
function overviewAllowOptions(row) {
  const inherit = row?.effectiveAllow;
  const now = inherit && row?.allowCustom === null ? `(${inherit.allowCustom ? "\uD5C8\uC6A9" : "\uB9C9\uC74C"})` : "";
  return [
    {
      value: "inherit",
      label: `\uC0C1\uC704 \uC124\uC815\uB300\uB85C${now}`
    },
    {
      value: "on",
      label: "\uC9C1\uC811 \uC9C0\uC815 \uD5C8\uC6A9"
    },
    {
      value: "off",
      label: "\uC9C1\uC811 \uC9C0\uC815 \uBD88\uAC00"
    }
  ];
}
__name(overviewAllowOptions, "overviewAllowOptions");
function overviewAllowTip(row) {
  const head = "\uC9C1\uC6D0\uC774 \uC2E0\uCCAD\uC11C\uC5D0\uC11C \uACB0\uC7AC\uC790\uB97C \uC9C1\uC811 \uACE0\uB974\uACE0 \uB0B4 \uACB0\uC7AC\uC120\uC744 \uC4F8 \uC218 \uC788\uAC8C \uD560\uC9C0 \uC815\uD574\uC694.";
  if (!row) {
    return head;
  }
  const e = row.effectiveAllow;
  const by = e.by === "org" ? "\uBCD1\uC6D0 \uC124\uC815" : e.by === "parent" ? `${e.teamName ?? "\uC0C1\uC704 \uD300"} \uC124\uC815` : "\uC774 \uD300 \uC124\uC815";
  return `${head}
\uC9C0\uAE08: ${e.allowCustom ? "\uD5C8\uC6A9" : "\uB9C9\uC74C"} (${by})`;
}
__name(overviewAllowTip, "overviewAllowTip");
function filterOverviewRows(rows, query, filter) {
  const q = query.trim().toLowerCase();
  return rows.filter((r) => {
    if (q && !`${r.name} ${r.parentName ?? ""}`.toLowerCase().includes(q)) {
      return false;
    }
    const hasOwn = APPROVAL_LINE_TYPES.some((t) => r.cells[t]?.source === "own");
    if (filter === "own") {
      return hasOwn;
    }
    if (filter === "inherit") {
      return !hasOwn;
    }
    return true;
  });
}
__name(filterOverviewRows, "filterOverviewRows");
function applyTargets(input) {
  const types = [
    input.type,
    ...input.alsoTypes.filter((t) => t !== input.type)
  ];
  const teams = [
    input.teamId,
    ...input.alsoTeamIds.filter((id) => id !== input.teamId)
  ];
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  for (const teamId of teams) {
    for (const type of types) {
      const key = `${teamId}:${type}`;
      if (!seen.has(key)) {
        seen.add(key);
        out.push({
          teamId,
          type
        });
      }
    }
  }
  return out;
}
__name(applyTargets, "applyTargets");
function applySummary(okCount, failCount, cleared) {
  const verb = cleared ? "\uBE44\uC6E0\uC5B4\uC694" : "\uC800\uC7A5\uD588\uC5B4\uC694";
  if (failCount === 0) {
    return okCount <= 1 ? `\uACB0\uC7AC\uC120\uC744 ${verb}.` : `${okCount}\uACF3\uC758 \uACB0\uC7AC\uC120\uC744 ${verb}.`;
  }
  if (okCount === 0) {
    return "\uACB0\uC7AC\uC120\uC744 \uC800\uC7A5\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694.";
  }
  return `${okCount}\uACF3\uC740 ${verb} \xB7 ${failCount}\uACF3\uC740 \uC800\uC7A5\uD558\uC9C0 \uBABB\uD588\uC5B4\uC694.`;
}
__name(applySummary, "applySummary");

// src/constants/team-structure.ts
function isDepartmentTeam(teams, teamId) {
  const team = teams.find((t) => t.id === teamId);
  if (!team || team.parentTeamId) {
    return false;
  }
  return teams.some((t) => t.parentTeamId === teamId);
}
__name(isDepartmentTeam, "isDepartmentTeam");

// src/constants/temporary-password.ts
var FORMAT_PATTERN = {
  numbers: /^[0-9]+$/,
  lower_numbers: /^[a-z0-9]+$/,
  mixed: /^[A-Za-z0-9]+$/
};
function temporaryPasswordLength(policy) {
  const raw = Number(policy?.length ?? 8);
  return Math.max(4, Math.min(20, Number.isFinite(raw) ? raw : 8));
}
__name(temporaryPasswordLength, "temporaryPasswordLength");
function matchesTemporaryPasswordPolicy(password, policy) {
  if (!password) {
    return false;
  }
  const format = policy?.format || "mixed";
  if (format === "fixed") {
    const fixed = (policy?.fixedValue ?? "").trim();
    return fixed.length >= 4 && fixed.length <= 20 && password === fixed;
  }
  const pattern = FORMAT_PATTERN[format] ?? FORMAT_PATTERN.mixed;
  return password.length === temporaryPasswordLength(policy) && pattern.test(password);
}
__name(matchesTemporaryPasswordPolicy, "matchesTemporaryPasswordPolicy");
function describeTemporaryPasswordPolicy(policy) {
  const format = policy?.format || "mixed";
  if (format === "fixed") {
    const fixed = (policy?.fixedValue ?? "").trim();
    return fixed ? `\uACE0\uC815\uAC12 ${fixed}` : "";
  }
  const length = temporaryPasswordLength(policy);
  const kind = format === "numbers" ? "\uC22B\uC790" : format === "lower_numbers" ? "\uC601\uBB38 \uC18C\uBB38\uC790\xB7\uC22B\uC790" : "\uC601\uBB38\xB7\uC22B\uC790";
  return `${kind} ${length}\uC790`;
}
__name(describeTemporaryPasswordPolicy, "describeTemporaryPasswordPolicy");
var TEMPORARY_PASSWORD_VALIDITY_DAYS_MIN = 1;
var TEMPORARY_PASSWORD_VALIDITY_DAYS_MAX = 90;
function resolveTemporaryPasswordValidityDays(policy) {
  const raw = policy?.temporaryValidityDays;
  if (typeof raw !== "number" || !Number.isFinite(raw)) {
    return null;
  }
  const days = Math.trunc(raw);
  return days >= TEMPORARY_PASSWORD_VALIDITY_DAYS_MIN && days <= TEMPORARY_PASSWORD_VALIDITY_DAYS_MAX ? days : null;
}
__name(resolveTemporaryPasswordValidityDays, "resolveTemporaryPasswordValidityDays");
function isTemporaryPasswordExpired(state, validityDays, now = /* @__PURE__ */ new Date()) {
  if (!(state.mustChangePassword && validityDays && state.passwordChangedAt)) {
    return false;
  }
  const issued = new Date(state.passwordChangedAt).getTime();
  if (!Number.isFinite(issued)) {
    return false;
  }
  return now.getTime() - issued > validityDays * 864e5;
}
__name(isTemporaryPasswordExpired, "isTemporaryPasswordExpired");

// src/constants/terminology.ts
var TERM_KEYS = [
  "role"
];
var TERM_MAX_LENGTH = 20;
var DEFAULT_TERMS = {
  ko: {
    role: "\uC5ED\uD560"
  },
  en: {
    role: "Role"
  }
};
var TERM_LABELS = {
  role: {
    label: "\uC5ED\uD560",
    hint: "\uD300 \uC548\uC5D0\uC11C \uB9E1\uB294 \uC790\uB9AC(\uAD8C\uD55C \uBB36\uC74C)\uC758 \uC774\uB984. \uC608: \uC9C1\uCC45"
  }
};
function normalizeTerm(value) {
  if (typeof value !== "string") {
    return void 0;
  }
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > TERM_MAX_LENGTH) {
    return void 0;
  }
  return trimmed;
}
__name(normalizeTerm, "normalizeTerm");
function resolveTerminology(config, locale = "ko") {
  const defaults = DEFAULT_TERMS[locale.slice(0, 2)] ?? DEFAULT_TERMS.ko;
  const resolved = {
    ...defaults
  };
  for (const key of TERM_KEYS) {
    const custom = normalizeTerm(config?.[key]);
    if (custom) {
      resolved[key] = custom;
    }
  }
  return resolved;
}
__name(resolveTerminology, "resolveTerminology");
function compactTerminology(config) {
  const out = {};
  for (const key of TERM_KEYS) {
    const custom = normalizeTerm(config?.[key]);
    if (custom) {
      out[key] = custom;
    }
  }
  return Object.keys(out).length > 0 ? out : void 0;
}
__name(compactTerminology, "compactTerminology");
var HANGUL_BASE = 44032;
var HANGUL_LAST = 55203;
var JONG_RIEUL = 8;
function josa(word, pair) {
  const [withBatchim, withoutBatchim] = pair.split("/");
  if (withoutBatchim === void 0) {
    return pair;
  }
  const last = word.charCodeAt(word.length - 1);
  if (!word || Number.isNaN(last) || last < HANGUL_BASE || last > HANGUL_LAST) {
    return withoutBatchim;
  }
  const jong = (last - HANGUL_BASE) % 28;
  if (jong === 0) {
    return withoutBatchim;
  }
  if (jong === JONG_RIEUL && withBatchim === "\uC73C\uB85C") {
    return withoutBatchim;
  }
  return withBatchim;
}
__name(josa, "josa");
function attachJosa(word, pair) {
  return `${word}${josa(word, pair)}`;
}
__name(attachJosa, "attachJosa");

// src/constants/terms.ts
var CURRENT_TERMS_VERSION = "2026-07-16.1";
var TERMS_VERSION_PATTERN = /^\d{4}-\d{2}-\d{2}\.\d+$/;

// src/constants/user-password-policy.ts
var DEFAULT_USER_PASSWORD_MIN_LENGTH = 8;
function resolveUserPasswordPolicy(policy) {
  const raw = Number(policy?.minLength ?? DEFAULT_USER_PASSWORD_MIN_LENGTH);
  const minLength = Math.max(4, Math.min(20, Number.isFinite(raw) ? Math.round(raw) : DEFAULT_USER_PASSWORD_MIN_LENGTH));
  return {
    minLength,
    requireUppercase: policy?.requireUppercase !== false,
    requireLowercase: policy?.requireLowercase !== false,
    requireNumber: policy?.requireNumber !== false,
    requireSpecial: policy?.requireSpecial !== false
  };
}
__name(resolveUserPasswordPolicy, "resolveUserPasswordPolicy");
function requiredKinds(p) {
  const kinds = [];
  if (p.requireUppercase) {
    kinds.push("\uB300\uBB38\uC790");
  }
  if (p.requireLowercase) {
    kinds.push("\uC18C\uBB38\uC790");
  }
  if (p.requireNumber) {
    kinds.push("\uC22B\uC790");
  }
  if (p.requireSpecial) {
    kinds.push("\uD2B9\uC218\uBB38\uC790");
  }
  return kinds;
}
__name(requiredKinds, "requiredKinds");
function describeUserPasswordPolicy(policy) {
  const p = resolveUserPasswordPolicy(policy);
  const kinds = requiredKinds(p);
  return kinds.length > 0 ? `${p.minLength}\uC790 \uC774\uC0C1, ${kinds.join("\xB7")} \uD3EC\uD568` : `${p.minLength}\uC790 \uC774\uC0C1`;
}
__name(describeUserPasswordPolicy, "describeUserPasswordPolicy");
function userPasswordPolicyError(password, policy) {
  const p = resolveUserPasswordPolicy(policy);
  if (password.length < p.minLength) {
    return `\uBE44\uBC00\uBC88\uD638\uB294 ${p.minLength}\uC790 \uC774\uC0C1\uC774\uC5B4\uC57C \uD574\uC694.`;
  }
  const missing = [];
  if (p.requireUppercase && !/[A-Z]/.test(password)) {
    missing.push("\uB300\uBB38\uC790");
  }
  if (p.requireLowercase && !/[a-z]/.test(password)) {
    missing.push("\uC18C\uBB38\uC790");
  }
  if (p.requireNumber && !/\d/.test(password)) {
    missing.push("\uC22B\uC790");
  }
  if (p.requireSpecial && !/[^A-Za-z0-9]/.test(password)) {
    missing.push("\uD2B9\uC218\uBB38\uC790");
  }
  return missing.length > 0 ? `\uBE44\uBC00\uBC88\uD638\uC5D0 ${missing.join("\xB7")}\uB97C \uD3EC\uD568\uD574\uC57C \uD574\uC694.` : null;
}
__name(userPasswordPolicyError, "userPasswordPolicyError");

// src/constants/work-pattern.ts
var DEFAULT_WORK_PATTERN_MULTIPLIERS = {
  overtime: 1.5,
  night: 0.5,
  holiday: 1.5
};
var WEEKS_PER_MONTH = 4.345;
function positiveOr(value, fallback) {
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : fallback;
}
__name(positiveOr, "positiveOr");
function resolveWorkPatternMultipliers(config) {
  return {
    overtime: positiveOr(config?.overtimeMultiplier, DEFAULT_WORK_PATTERN_MULTIPLIERS.overtime),
    night: positiveOr(config?.nightMultiplier, DEFAULT_WORK_PATTERN_MULTIPLIERS.night),
    holiday: positiveOr(config?.holidayMultiplier, DEFAULT_WORK_PATTERN_MULTIPLIERS.holiday)
  };
}
__name(resolveWorkPatternMultipliers, "resolveWorkPatternMultipliers");
var num2 = /* @__PURE__ */ __name((v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}, "num");
function roundHours(value) {
  return Math.round(value * 100) / 100;
}
__name(roundHours, "roundHours");
function computeWageHours(hours, multipliers = DEFAULT_WORK_PATTERN_MULTIPLIERS) {
  return roundHours(num2(hours.monthlyStandardHours) + num2(hours.monthlyOvertimeHours) * multipliers.overtime + num2(hours.monthlyNightHours) * multipliers.night + num2(hours.monthlyHolidayHours) * multipliers.holiday);
}
__name(computeWageHours, "computeWageHours");
function monthlyHoursFromDaily(dailyHours, monthlyWorkingDays) {
  return roundHours(num2(dailyHours) * num2(monthlyWorkingDays));
}
__name(monthlyHoursFromDaily, "monthlyHoursFromDaily");
function monthlyWorkingDaysFromWeekly(daysPerWeek) {
  return roundHours(num2(daysPerWeek) * WEEKS_PER_MONTH);
}
__name(monthlyWorkingDaysFromWeekly, "monthlyWorkingDaysFromWeekly");
function computeHourlyRate(input, wageHours) {
  const pay = input.monthlyPay === null || input.monthlyPay === void 0 ? null : num2(input.monthlyPay);
  if (pay === null || !(wageHours > 0)) {
    return null;
  }
  const total = pay + num2(input.hobongAmount) + num2(input.longevityAmount);
  return Math.ceil(total / wageHours / 10) * 10;
}
__name(computeHourlyRate, "computeHourlyRate");
var WORK_PATTERN_DERIVED_FIELDS = [
  "monthlyHours",
  "overtimeHours",
  "nightHours",
  "inclusiveHours",
  "hourlyRate",
  "workPattern",
  "workHours",
  "breakTime"
];
var WORK_PATTERN_DERIVED_FIELD_LABELS = {
  monthlyHours: "\uC6D4 \uADFC\uB85C\uC2DC\uAC04",
  overtimeHours: "\uC5F0\uC7A5\uC2DC\uAC04",
  nightHours: "\uC57C\uAC04\uC2DC\uAC04",
  inclusiveHours: "\uD3EC\uAD04\uC2DC\uAC04",
  hourlyRate: "\uD1B5\uC0C1\uC2DC\uAE09",
  workPattern: "\uADFC\uBB34\uC77C \uD615\uD0DC",
  workHours: "\uADFC\uBB34\uC2DC\uAC04",
  breakTime: "\uD734\uAC8C\uC2DC\uAC04"
};
function isWorkPatternDerivedField(key) {
  return WORK_PATTERN_DERIVED_FIELDS.includes(key);
}
__name(isWorkPatternDerivedField, "isWorkPatternDerivedField");
function deriveFromWorkPattern(pattern, multipliers, contract) {
  const inclusiveHours = computeWageHours(pattern, multipliers);
  return {
    monthlyHours: roundHours(num2(pattern.monthlyStandardHours)),
    overtimeHours: roundHours(num2(pattern.monthlyOvertimeHours)),
    nightHours: roundHours(num2(pattern.monthlyNightHours)),
    inclusiveHours,
    hourlyRate: computeHourlyRate(contract, inclusiveHours),
    workPattern: pattern.scheduleText?.workDays || pattern.workDaysText?.trim() || null,
    workHours: pattern.scheduleText?.workHours || pattern.workHoursText?.trim() || null,
    breakTime: pattern.scheduleText?.breakTime || pattern.breakTimeText?.trim() || null
  };
}
__name(deriveFromWorkPattern, "deriveFromWorkPattern");
var sameValue = /* @__PURE__ */ __name((a, b) => {
  const na = a === null || a === void 0 || a === "" ? null : a;
  const nb = b === null || b === void 0 || b === "" ? null : b;
  if (na === null || nb === null) {
    return na === nb;
  }
  if (typeof na === "number" || typeof nb === "number") {
    return Math.abs(num2(na) - num2(nb)) < 5e-3;
  }
  return String(na).trim() === String(nb).trim();
}, "sameValue");
function diffDerivedValues(derived, current, overrides = []) {
  const changes = [];
  for (const field of WORK_PATTERN_DERIVED_FIELDS) {
    if (overrides.includes(field)) {
      continue;
    }
    const after = derived[field];
    if (after === null) {
      continue;
    }
    const before = current?.[field];
    if (sameValue(before, after)) {
      continue;
    }
    changes.push({
      field,
      label: WORK_PATTERN_DERIVED_FIELD_LABELS[field],
      before: before === void 0 || before === "" ? null : before,
      after
    });
  }
  return changes;
}
__name(diffDerivedValues, "diffDerivedValues");

// src/constants/data-retention.ts
var ORGANIZATION_DATA_RETENTION_MONTHS = 12;
function organizationPurgeCutoff(now, months = ORGANIZATION_DATA_RETENTION_MONTHS) {
  const d = new Date(now.getTime());
  d.setUTCMonth(d.getUTCMonth() - months);
  return d;
}
__name(organizationPurgeCutoff, "organizationPurgeCutoff");
function organizationPurgeDate(deletedAt, months = ORGANIZATION_DATA_RETENTION_MONTHS) {
  const d = new Date(deletedAt.getTime());
  d.setUTCMonth(d.getUTCMonth() + months);
  return d;
}
__name(organizationPurgeDate, "organizationPurgeDate");

// src/constants/team-order.ts
function compareTeamName(a, b) {
  return String(a.name ?? "").localeCompare(String(b.name ?? ""), "ko", {
    numeric: true
  });
}
__name(compareTeamName, "compareTeamName");
function compareTeamOrder(a, b, fallback = compareTeamName) {
  const ao = typeof a.sortOrder === "number" ? a.sortOrder : null;
  const bo = typeof b.sortOrder === "number" ? b.sortOrder : null;
  if (ao !== null && bo !== null && ao !== bo) {
    return ao - bo;
  }
  if (ao !== null && bo === null) {
    return -1;
  }
  if (ao === null && bo !== null) {
    return 1;
  }
  return fallback(a, b);
}
__name(compareTeamOrder, "compareTeamOrder");
function moveSibling(orderedIds, movedId, targetId, position) {
  if (movedId === targetId || !orderedIds.includes(movedId) || !orderedIds.includes(targetId)) {
    return [
      ...orderedIds
    ];
  }
  const rest = orderedIds.filter((id) => id !== movedId);
  const at = rest.indexOf(targetId) + (position === "after" ? 1 : 0);
  rest.splice(at, 0, movedId);
  return rest;
}
__name(moveSibling, "moveSibling");

// src/constants/entity-picker.ts
function entityPickerQuery(raw) {
  return String(raw ?? "").trim().toLowerCase();
}
__name(entityPickerQuery, "entityPickerQuery");
function buildTeamTreeRows(teams) {
  const byId = new Map(teams.map((t) => [
    t.id,
    t
  ]));
  const children = /* @__PURE__ */ new Map();
  for (const t of teams) {
    const parent = t.parentTeamId && byId.has(t.parentTeamId) ? t.parentTeamId : null;
    const list = children.get(parent) ?? [];
    list.push(t);
    children.set(parent, list);
  }
  const sortByName = /* @__PURE__ */ __name((a, b) => compareTeamOrder(a, b), "sortByName");
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  const walk = /* @__PURE__ */ __name((parent, depth) => {
    for (const t of [
      ...children.get(parent) ?? []
    ].sort(sortByName)) {
      if (seen.has(t.id)) {
        continue;
      }
      seen.add(t.id);
      const kids = children.get(t.id) ?? [];
      out.push({
        ...t,
        depth,
        hasChildren: kids.length > 0
      });
      walk(t.id, depth + 1);
    }
  }, "walk");
  walk(null, 0);
  return out;
}
__name(buildTeamTreeRows, "buildTeamTreeRows");
function teamDescendantIds(teams, teamId) {
  const children = /* @__PURE__ */ new Map();
  for (const t of teams) {
    if (t.parentTeamId) {
      const list = children.get(t.parentTeamId) ?? [];
      list.push(t.id);
      children.set(t.parentTeamId, list);
    }
  }
  const out = [];
  const seen = /* @__PURE__ */ new Set([
    teamId
  ]);
  const stack = [
    ...children.get(teamId) ?? []
  ];
  while (stack.length > 0) {
    const id = stack.pop();
    if (seen.has(id)) {
      continue;
    }
    seen.add(id);
    out.push(id);
    stack.push(...children.get(id) ?? []);
  }
  return out;
}
__name(teamDescendantIds, "teamDescendantIds");
function teamMatchesQuery(team, query) {
  const q = entityPickerQuery(query);
  return !q || team.name.toLowerCase().includes(q);
}
__name(teamMatchesQuery, "teamMatchesQuery");
function employeeMatchesQuery(employee, query) {
  const q = entityPickerQuery(query);
  if (!q) {
    return true;
  }
  const hay = [
    employee.name,
    employee.employeeNumber ?? "",
    ...employee.teamNames ?? [],
    employee.jobDuty ?? ""
  ];
  return hay.some((h) => h.toLowerCase().includes(q));
}
__name(employeeMatchesQuery, "employeeMatchesQuery");
function filterTeamTreeRows(rows, query) {
  const q = entityPickerQuery(query);
  if (!q) {
    return rows;
  }
  const byId = new Map(rows.map((r) => [
    r.id,
    r
  ]));
  const keep = /* @__PURE__ */ new Set();
  for (const r of rows) {
    if (!r.name.toLowerCase().includes(q)) {
      continue;
    }
    let cur = r;
    while (cur && !keep.has(cur.id)) {
      keep.add(cur.id);
      cur = cur.parentTeamId ? byId.get(cur.parentTeamId) : void 0;
    }
  }
  return rows.filter((r) => keep.has(r.id));
}
__name(filterTeamTreeRows, "filterTeamTreeRows");
function filterEmployees(employees, query, excludeIds = [], limit = 50) {
  const excluded = excludeIds instanceof Set ? excludeIds : new Set(excludeIds);
  return employees.filter((e) => !excluded.has(e.id) && employeeMatchesQuery(e, query)).slice(0, limit);
}
__name(filterEmployees, "filterEmployees");
function expandEntitySelection(selection, teams) {
  const byId = new Map(teams.map((t) => [
    t.id,
    t
  ]));
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  const push = /* @__PURE__ */ __name((kind, id, name) => {
    const key = `${kind}:${id}`;
    if (seen.has(key)) {
      return;
    }
    seen.add(key);
    out.push({
      kind,
      id,
      name
    });
  }, "push");
  for (const s of selection) {
    push(s.kind, s.id, s.name);
    if (s.kind === "team" && s.includeSubTeams) {
      for (const id of teamDescendantIds(teams, s.id)) {
        const t = byId.get(id);
        if (t) {
          push("team", t.id, t.name);
        }
      }
    }
  }
  return out;
}
__name(expandEntitySelection, "expandEntitySelection");
function flattenEntitySelection(selection) {
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  const push = /* @__PURE__ */ __name((kind, id, name) => {
    const key = `${kind}:${id}`;
    if (!seen.has(key)) {
      seen.add(key);
      out.push({
        kind,
        id,
        name
      });
    }
  }, "push");
  for (const s of selection) {
    push(s.kind, s.id, s.name);
    if (s.kind === "team" && s.includeSubTeams) {
      for (const t of s.subTeams ?? []) {
        push("team", t.id, t.name);
      }
    }
  }
  return out;
}
__name(flattenEntitySelection, "flattenEntitySelection");
function entityPickerRecentContext(context, kind) {
  return `picker.${context}.${kind}`;
}
__name(entityPickerRecentContext, "entityPickerRecentContext");

// src/constants/leave-cancel.ts
var DAY_MS2 = 24 * 60 * 60 * 1e3;
function toUtc(date) {
  return Date.parse(`${date.slice(0, 10)}T00:00:00Z`);
}
__name(toUtc, "toUtc");
function fromUtc(ms) {
  return new Date(ms).toISOString().slice(0, 10);
}
__name(fromUtc, "fromUtc");
function leaveCalendarDays(from, to) {
  return Math.round((toUtc(to) - toUtc(from)) / DAY_MS2) + 1;
}
__name(leaveCalendarDays, "leaveCalendarDays");
function planLeaveCancellation(input) {
  const start = input.startDate.slice(0, 10);
  const end = input.endDate.slice(0, 10);
  const earliest = input.earliestFrom ? input.earliestFrom.slice(0, 10) : null;
  const today = earliest && earliest > input.today ? earliest : input.today;
  if (end < input.today) {
    return {
      kind: "not_allowed",
      reason: "\uC774\uBBF8 \uB05D\uB09C \uD734\uAC00\uB294 \uCDE8\uC18C\uD560 \uC218 \uC5C6\uC5B4\uC694."
    };
  }
  if (start >= today || input.singleUnit || start === end) {
    return {
      kind: "full",
      cancelFrom: start
    };
  }
  const cancelFrom = today;
  return {
    kind: "partial",
    cancelFrom,
    keepUntil: fromUtc(toUtc(cancelFrom) - DAY_MS2),
    cancelDays: leaveCalendarDays(cancelFrom, end)
  };
}
__name(planLeaveCancellation, "planLeaveCancellation");
function leaveCancelPlanLabel(plan) {
  if (plan.kind === "not_allowed") {
    return plan.reason;
  }
  if (plan.kind === "full") {
    return "\uC804\uCCB4 \uCDE8\uC18C";
  }
  const [, m, d] = plan.cancelFrom.split("-").map(Number);
  return `${m}\uC6D4 ${d}\uC77C\uBD80\uD130 \uB0A8\uC740 ${plan.cancelDays}\uC77C \uCDE8\uC18C`;
}
__name(leaveCancelPlanLabel, "leaveCancelPlanLabel");

// src/constants/message-reactions.ts
var MESSAGE_REACTION_EMOJIS = [
  "\u{1F44D}",
  "\u2705",
  "\u2764\uFE0F",
  "\u{1F602}",
  "\u{1F62E}",
  "\u{1F622}",
  "\u{1F64F}"
];
var DEFAULT_MESSAGE_REACTION = "\u{1F44D}";
function isMessageReactionEmoji(value) {
  return MESSAGE_REACTION_EMOJIS.includes(value);
}
__name(isMessageReactionEmoji, "isMessageReactionEmoji");
function groupReactionChips(entries, currentEmployeeId) {
  const byEmoji = /* @__PURE__ */ new Map();
  for (const entry of entries) {
    const chip = byEmoji.get(entry.emoji) ?? {
      emoji: entry.emoji,
      count: 0,
      mine: false,
      names: []
    };
    chip.count += 1;
    chip.mine = chip.mine || entry.employeeId === currentEmployeeId;
    chip.names.push(entry.employeeName);
    byEmoji.set(entry.emoji, chip);
  }
  const order = /* @__PURE__ */ __name((emoji) => {
    const index = MESSAGE_REACTION_EMOJIS.indexOf(emoji);
    return index === -1 ? MESSAGE_REACTION_EMOJIS.length : index;
  }, "order");
  return [
    ...byEmoji.values()
  ].sort((a, b) => order(a.emoji) - order(b.emoji));
}
__name(groupReactionChips, "groupReactionChips");
function applyReactionChange(entries, change) {
  const rest = entries.filter((e) => !(e.messageId === change.messageId && e.employeeId === change.employeeId && e.emoji === change.emoji));
  if (!change.active) {
    return rest;
  }
  const { active: _active, ...entry } = change;
  return [
    ...rest,
    entry
  ];
}
__name(applyReactionChange, "applyReactionChange");

// src/constants/permission-bundles.ts
var FEATURE_BUNDLE_GROUP_LABELS = {
  works: "\uC9C1\uC6D0 \uC571",
  manager: "\uD300\uC7A5 \uC571",
  payroll: "\uAE09\uC5EC \uC2DC\uD2B8",
  admin: "\uAD00\uB9AC"
};
var req = /* @__PURE__ */ __name((resource, action, scope) => ({
  resource,
  action,
  scope
}), "req");
var teamLeaderRequirements = /* @__PURE__ */ __name(() => TEAM_LEADER_GRANTS.map((g) => req(g.resource, g.action === "approve" ? "approve" : "read", "team")), "teamLeaderRequirements");
var FEATURE_PERMISSION_BUNDLES = [
  {
    id: "works-basic",
    label: "\uC9C1\uC6D0 \uC571 \uAE30\uBCF8",
    description: "\uB85C\uADF8\uC778 \xB7 \uB0B4 \uC815\uBCF4 \xB7 \uCD9C\uD1F4\uADFC \xB7 \uADFC\uBB34\uD45C \xB7 \uC54C\uB9BC \xB7 \uBD88\uD3B8 \uC2E0\uACE0. \uC9C1\uC6D0 \uC571\uC744 \uC4F0\uB294 \uBAA8\uB4E0 \uC5ED\uD560\uC758 \uBC14\uD0D5\uC774\uC5D0\uC694.",
    group: "works",
    requires: [
      req(Resource.EMPLOYEE, "read", "self"),
      req(Resource.EMPLOYEE, "write", "self"),
      req(Resource.ATTENDANCE, "read", "self"),
      req(Resource.ATTENDANCE, "write", "self"),
      req(Resource.SCHEDULE, "read", "self"),
      req(Resource.NOTIFICATION, "read", "self"),
      req(Resource.NOTIFICATION, "write", "self"),
      req(Resource.TEAM, "read", "all"),
      req(Resource.CS_REPORT, "read", "self"),
      req(Resource.CS_REPORT, "write", "self")
    ]
  },
  {
    id: "works-messenger",
    label: "\uBA54\uC2E0\uC800",
    description: "\uB300\uD654\uBC29 \uBAA9\uB85D \xB7 \uBA54\uC2DC\uC9C0 \uC77D\uAE30/\uBCF4\uB0B4\uAE30 \xB7 \uCCA8\uBD80 \uC62C\uB9AC\uAE30. \uB300\uD654\uBC29 \uAD8C\uD55C\uC774 \uC5C6\uC73C\uBA74 \uD0ED \uC790\uCCB4\uAC00 \uC228\uC5B4\uC694.",
    group: "works",
    requires: [
      req(Resource.CONVERSATION, "read", "all"),
      req(Resource.CONVERSATION, "write", "all"),
      req(Resource.MESSAGE, "read", "all"),
      req(Resource.MESSAGE, "write", "all"),
      req(Resource.STORAGE, "read", "all"),
      req(Resource.STORAGE, "write", "all"),
      req(Resource.TEAM, "read", "all")
    ]
  },
  {
    id: "works-approval-request",
    label: "\uC571 \uACB0\uC7AC \u2014 \uC2E0\uCCAD",
    description: "\uD734\uAC00 \xB7 \uC5F0\uC7A5/\uD734\uC77C \uADFC\uBB34 \xB7 \uC678\uADFC \xB7 \uC11C\uB958 \xB7 \uC778\uC13C\uD2F0\uBE0C\uB97C \uBCF8\uC778\uC774 \uC2E0\uCCAD\uD558\uACE0 \uC9C4\uD589\uC744 \uBD10\uC694.",
    group: "works",
    requires: [
      req(Resource.LEAVE, "read", "self"),
      req(Resource.LEAVE, "write", "self"),
      req(Resource.OVERTIME, "read", "self"),
      req(Resource.OVERTIME, "write", "self"),
      req(Resource.OFFSITE_WORK, "read", "self"),
      req(Resource.OFFSITE_WORK, "write", "self"),
      req(Resource.DOCUMENT, "read", "self"),
      req(Resource.DOCUMENT, "write", "self"),
      req(Resource.INCENTIVE, "read", "self"),
      req(Resource.INCENTIVE, "write", "self")
    ]
  },
  {
    id: "works-approval-approve",
    label: "\uC571 \uACB0\uC7AC \u2014 \uC2B9\uC778(\uD300)",
    description: "\uD300\uC6D0\uC758 \uD734\uAC00 \xB7 \uADFC\uBB34 \xB7 \uC678\uADFC \xB7 \uC778\uC13C\uD2F0\uBE0C \xB7 \uC11C\uB958\uB97C \uD300 \uBC94\uC704\uB85C \uBCF4\uACE0 \uACB0\uC7AC\uD574\uC694. \uD300\uC7A5\uC73C\uB85C \uC9C0\uC815\uB418\uBA74 \uC5ED\uD560 \uC5C6\uC774\uB3C4 \uAC19\uC740 \uBC94\uC704\uB97C \uBC1B\uC544\uC694.",
    group: "works",
    requires: [
      req(Resource.EMPLOYEE, "read", "team"),
      req(Resource.ATTENDANCE, "read", "team"),
      req(Resource.LEAVE, "read", "team"),
      req(Resource.LEAVE, "approve", "team"),
      req(Resource.OVERTIME, "read", "team"),
      req(Resource.OVERTIME, "approve", "team"),
      req(Resource.OFFSITE_WORK, "read", "team"),
      req(Resource.OFFSITE_WORK, "approve", "team"),
      req(Resource.INCENTIVE, "read", "team"),
      req(Resource.INCENTIVE, "approve", "team"),
      // 서류 결재는 카탈로그에 approve 범위 행이 없어(document.manage 전체뿐) 읽기만 둔다 — 행이 생기면 approve 를 더한다
      req(Resource.DOCUMENT, "read", "team")
    ]
  },
  {
    id: "works-certification",
    label: "\uC790\uACA9\uC99D \xB7 \uAD50\uC721(\uBCF8\uC778)",
    description: "\uBCF8\uC778 \uC790\uACA9\uC99D\uACFC \uAD50\uC721 \uC774\uC218\uB97C \uB4F1\uB85D\uD558\uACE0 \uBD10\uC694.",
    group: "works",
    requires: [
      req(Resource.CERTIFICATION, "read", "self"),
      req(Resource.CERTIFICATION, "write", "self"),
      req(Resource.EDUCATION, "read", "self"),
      req(Resource.EDUCATION, "write", "self")
    ]
  },
  {
    id: "works-payslip",
    label: "\uAE09\uC5EC\uBA85\uC138\uC11C",
    description: "\uB354\uBCF4\uAE30\uC758 \uBCF8\uC778 \uAE09\uC5EC\uBA85\uC138\uC11C.",
    group: "works",
    requires: [
      req(Resource.PAYROLL, "read", "self")
    ]
  },
  {
    id: "works-drive",
    label: "\uB4DC\uB77C\uC774\uBE0C",
    description: "\uC870\uC9C1 \uACF5\uC6A9 \uD3F4\uB354 \uBCF4\uAE30\uC640 \uD30C\uC77C \uC62C\uB9AC\uAE30.",
    group: "works",
    requires: [
      req(Resource.TEAM_DRIVE, "read", "all"),
      req(Resource.TEAM_DRIVE, "write", "all"),
      req(Resource.STORAGE, "read", "all"),
      req(Resource.STORAGE, "write", "all")
    ]
  },
  {
    id: "works-notices",
    label: "\uACF5\uC9C0 \xB7 \uAD50\uC721 \uBCF4\uAE30",
    description: "\uD648 \uC18C\uC2DD\uACFC \uCD1D\uBB34 \uACF5\uC9C0 \xB7 \uD544\uC218 \uAD50\uC721 \xB7 \uBC18\uBCF5 \uC5C5\uBB34\uB97C \uBD10\uC694(\uAD00\uB9AC\uB294 \u300C\uCD1D\uBB34 \uAD00\uB9AC\u300D).",
    group: "works",
    requires: [
      req(Resource.GENERAL_AFFAIRS, "read", "all")
    ]
  },
  {
    id: "works-ai",
    label: "\uC9C1\uC6D0 \uC571 AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8",
    description: "\uB354\uBCF4\uAE30\uC758 AI \uC5B4\uC2DC\uC2A4\uD134\uD2B8(\uBCF8\uC778 \uBC94\uC704 \uB3C4\uAD6C).",
    group: "works",
    requires: [
      req(Resource.AI_APP, "execute", "self")
    ]
  },
  {
    id: "team-manager",
    label: "\uD300\uC7A5 \uC571",
    description: "\uD300\uC7A5 \uC571\uC758 \uB0B4 \uD300 \xB7 \uADFC\uD0DC \xB7 \uACB0\uC7AC. \uD300\uC7A5\uC73C\uB85C \uC9C0\uC815\uB41C \uC0AC\uB78C\uC740 \uC5ED\uD560\uACFC \uBB34\uAD00\uD558\uAC8C \uC774 \uBB36\uC74C\uC744 \uD300 \uBC94\uC704\uB85C \uBC1B\uC544\uC694(MED-945).",
    group: "manager",
    requires: [
      ...teamLeaderRequirements(),
      req(Resource.TEAM, "read", "all")
    ]
  },
  {
    id: "sheets-view",
    label: "\uAE09\uC5EC \uC2DC\uD2B8 \uBCF4\uAE30(\uD300)",
    description: "\uAE09\uC5EC \uC2DC\uD2B8\uB97C \uD300 \uBC94\uC704\uB85C \uC77D\uAE30 \uC804\uC6A9\uC73C\uB85C \uC5F4\uC5B4\uC694. \uD300\uC6D0 \uD589\uB9CC \uBCF4\uC5EC\uC694.",
    group: "payroll",
    requires: [
      req(Resource.PAYROLL, "read", "team"),
      req(Resource.ALLOWANCE, "read", "team"),
      req(Resource.DEDUCTION, "read", "team"),
      req(Resource.EMPLOYEE, "read", "team"),
      req(Resource.TEAM, "read", "all")
    ]
  },
  {
    id: "sheets-own",
    label: "\uB0B4 \uC2DC\uD2B8(\uBCF8\uC778 \uD589)",
    description: "\uAE09\uC5EC \uAD8C\uD55C \uC5C6\uC774 \uAC1C\uC778 \uC2DC\uD2B8\uB97C \uB9CC\uB4E4\uACE0 \uACE0\uCCD0\uC694. \uB9CC\uB4E0 \uC2DC\uD2B8\uB294 \uBE44\uACF5\uAC1C\uC774\uACE0 \uD589\uC740 \uBCF8\uC778\uB9CC \uB123\uC744 \uC218 \uC788\uC5B4\uC694. \uD2B9\uC815 \uD300\xB7\uAC1C\uC778\uC5D0\uAC8C \uACF5\uC720\uD560 \uC218 \uC788\uACE0, \uACF5\uC720\uBC1B\uB294 \uC0AC\uB78C\uB3C4 \uC2DC\uD2B8 \uAD8C\uD55C\uC774 \uC788\uC5B4\uC57C \uC5F4\uB824\uC694.",
    group: "payroll",
    requires: [
      req(Resource.SHEET, "write", "self"),
      req(Resource.EMPLOYEE, "read", "self")
    ]
  },
  {
    id: "sheets-own-team",
    label: "\uB0B4 \uC2DC\uD2B8(\uD300\uC6D0 \uD589\uAE4C\uC9C0)",
    description: "\uAC1C\uC778 \uC2DC\uD2B8\uC5D0 \uD300\uC6D0(\uD558\uC704 \uD300 \uD3EC\uD568) \uD589\uAE4C\uC9C0 \uB123\uC744 \uC218 \uC788\uC5B4\uC694. \uACF5\uC720\uBC1B\uC740 \uC2DC\uD2B8\uC5D0\uC11C\uB3C4 \uD300\uC6D0 \uD589\uB9CC \uBCF4\uC5EC\uC694.",
    group: "payroll",
    requires: [
      req(Resource.SHEET, "write", "team"),
      req(Resource.EMPLOYEE, "read", "team"),
      req(Resource.TEAM, "read", "all")
    ]
  },
  {
    id: "sheets-edit",
    label: "\uAE09\uC5EC \uC2DC\uD2B8 \uD3B8\uC9D1(\uC804\uCCB4)",
    description: "\uC2DC\uD2B8 \uB9CC\uB4E4\uAE30 \xB7 \uD3B8\uC9D1 \xB7 \uD655\uC815 \xB7 \uC774\uCE74\uC6B4\uD2B8 \uB0B4\uBCF4\uB0B4\uAE30. \uAE09\uC5EC \uAD00\uB9AC\uC790 \uAE30\uBCF8 \uC5ED\uD560\uACFC \uAC19\uC740 \uBC14\uD0D5\uC774\uC5D0\uC694.",
    group: "payroll",
    requires: [
      req(Resource.PAYROLL, "read", "all"),
      req(Resource.PAYROLL, "manage", "all"),
      req(Resource.ALLOWANCE, "read", "all"),
      req(Resource.DEDUCTION, "read", "all"),
      req(Resource.EMPLOYEE, "read", "all"),
      req(Resource.ATTENDANCE, "read", "all"),
      req(Resource.OVERTIME, "read", "all"),
      req(Resource.INCENTIVE, "read", "all"),
      req(Resource.SCHEDULE, "read", "all"),
      req(Resource.TEAM, "read", "all"),
      req(Resource.AI, "execute", "self")
    ]
  },
  {
    id: "admin-employees",
    label: "\uC9C1\uC6D0 \uAD00\uB9AC",
    description: "\uAD00\uB9AC\uC790 \uC9C1\uC6D0 \uAD00\uB9AC \u2014 \uB4F1\uB85D \xB7 \uC218\uC815 \xB7 \uD1F4\uC0AC \uCC98\uB9AC \xB7 \uC18C\uC18D \uBCC0\uACBD.",
    group: "admin",
    requires: [
      req(Resource.EMPLOYEE, "read", "all"),
      req(Resource.EMPLOYEE, "manage", "all"),
      req(Resource.TEAM, "read", "all"),
      req(Resource.ROLE, "read", "all")
    ]
  },
  {
    id: "admin-teams",
    label: "\uD300 \uAD00\uB9AC",
    description: "\uAD00\uB9AC\uC790 \uD300 \uAD00\uB9AC \u2014 \uD300 \uCD94\uAC00 \xB7 \uD300\uC7A5 \uC9C0\uC815 \xB7 \uD300\uC6D0 \uBC30\uC815.",
    group: "admin",
    requires: [
      req(Resource.TEAM, "read", "all"),
      req(Resource.TEAM, "manage", "all"),
      req(Resource.EMPLOYEE, "read", "all")
    ]
  },
  {
    id: "admin-roles",
    label: "\uC5ED\uD560 \uAD00\uB9AC",
    description: "\uC5ED\uD560 \uCD94\uAC00\uC640 \uAD8C\uD55C \uD3B8\uC9D1.",
    group: "admin",
    requires: [
      req(Resource.ROLE, "read", "all"),
      req(Resource.ROLE, "manage", "all")
    ]
  },
  {
    id: "admin-system",
    label: "\uC2DC\uC2A4\uD15C \uAD00\uB9AC(\uAD00\uB9AC\uC790 \uC804\uCCB4)",
    description: "\uAD8C\uD55C \uBBF8\uB9AC\uBCF4\uAE30 \xB7 \uB300\uD654 \uBCF5\uAD6C \xB7 \uBAA8\uB4E0 \uC2DC\uD2B8 \uAD00\uB9AC \xB7 \uC870\uC9C1 \uC124\uC815 \xB7 \uC5ED\uD560 \uAD00\uB9AC. \uC608\uC804\uC5D4 isSystemAdmin \uD50C\uB798\uADF8\uB9CC \uD560 \uC218 \uC788\uB358 \uC77C\uC774\uC5D0\uC694 \u2014 \uC774 \uBB36\uC74C\uAE4C\uC9C0 \uAC00\uC9C0\uBA74 \uC2DC\uC2A4\uD15C \uAD00\uB9AC\uC790\uC640 \uAC19\uC544\uC694.",
    group: "admin",
    requires: [
      req(Resource.IMPERSONATION, "execute", "all"),
      req(Resource.CHAT_RECOVERY, "manage", "all"),
      req(Resource.SHEET, "manage", "all"),
      req(Resource.ORGANIZATION, "write", "all"),
      req(Resource.SETTING, "write", "all"),
      req(Resource.ROLE, "manage", "all"),
      req(Resource.EMPLOYEE, "manage", "all"),
      req(Resource.TEAM, "manage", "all")
    ]
  },
  {
    id: "general-affairs-admin",
    label: "\uCD1D\uBB34 \uAD00\uB9AC",
    description: "\uCD1D\uBB34 \uC571 \u2014 \uACF5\uC9C0 \uAC8C\uC2DC \xB7 \uD544\uC218 \uAD50\uC721 \xB7 \uBC18\uBCF5 \uC5C5\uBB34 \uAD00\uB9AC.",
    group: "admin",
    requires: [
      req(Resource.GENERAL_AFFAIRS, "read", "all"),
      req(Resource.GENERAL_AFFAIRS, "write", "all"),
      req(Resource.GENERAL_AFFAIRS, "manage", "all"),
      req(Resource.EMPLOYEE, "read", "all")
    ]
  }
];
function featureBundleById(id) {
  return FEATURE_PERMISSION_BUNDLES.find((b) => b.id === id);
}
__name(featureBundleById, "featureBundleById");

// src/constants/request-time-step.ts
var REQUEST_TIME_STEP_OPTIONS = [
  15,
  30,
  60
];
var DEFAULT_REQUEST_TIME_STEP_MINUTES = 30;
var REQUEST_TIME_STEP_LABELS = {
  15: "15\uBD84",
  30: "30\uBD84",
  60: "1\uC2DC\uAC04"
};
function isRequestTimeStep(value) {
  return REQUEST_TIME_STEP_OPTIONS.includes(value);
}
__name(isRequestTimeStep, "isRequestTimeStep");
function resolveRequestTimeStepMinutes(settings) {
  const requests = settings?.requests;
  const value = requests?.timeStepMinutes;
  return isRequestTimeStep(value) ? value : DEFAULT_REQUEST_TIME_STEP_MINUTES;
}
__name(resolveRequestTimeStepMinutes, "resolveRequestTimeStepMinutes");
function parseTimeToMinutes(value) {
  const m = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec((value ?? "").trim());
  if (!m) {
    return null;
  }
  const h = Number(m[1]);
  const mm = Number(m[2]);
  if (h > 23 || mm > 59) {
    return null;
  }
  return h * 60 + mm;
}
__name(parseTimeToMinutes, "parseTimeToMinutes");
function formatMinutesToTime(minutes) {
  const m = (minutes % 1440 + 1440) % 1440;
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
}
__name(formatMinutesToTime, "formatMinutesToTime");
function isOnTimeStep(value, step) {
  const min = parseTimeToMinutes(value);
  return min !== null && step > 0 && min % step === 0;
}
__name(isOnTimeStep, "isOnTimeStep");
function timeSlotOptions(step, current) {
  const safeStep = step > 0 ? Math.trunc(step) : DEFAULT_REQUEST_TIME_STEP_MINUTES;
  const out = [];
  for (let m = 0; m < 1440; m += safeStep) {
    out.push(formatMinutesToTime(m));
  }
  const cur = parseTimeToMinutes(current);
  if (cur !== null && !out.includes(formatMinutesToTime(cur))) {
    out.push(formatMinutesToTime(cur));
    out.sort();
  }
  return out;
}
__name(timeSlotOptions, "timeSlotOptions");
function minuteStepOptions(step, capMinutes) {
  const safeStep = step > 0 ? Math.trunc(step) : DEFAULT_REQUEST_TIME_STEP_MINUTES;
  const cap = Math.max(safeStep, Math.floor(capMinutes / safeStep) * safeStep);
  const out = [];
  for (let m = safeStep; m <= cap; m += safeStep) {
    out.push(m);
  }
  return out;
}
__name(minuteStepOptions, "minuteStepOptions");
function resolveSimplifiedOvertimeType(settings) {
  const requests = settings?.requests;
  return requests?.simplifiedOvertimeType === true;
}
__name(resolveSimplifiedOvertimeType, "resolveSimplifiedOvertimeType");

// src/constants/screen-capture.ts
function resolveScreenCaptureProtection(settings) {
  const value = settings?.screenCaptureProtection;
  return value !== false;
}
__name(resolveScreenCaptureProtection, "resolveScreenCaptureProtection");

// src/constants/search-history.ts
var SEARCH_HISTORY_RECENT_LIMIT = 10;
var SEARCH_HISTORY_FREQUENT_LIMIT = 5;
var SEARCH_HISTORY_FREQUENT_MIN_COUNT = 2;
var SEARCH_HISTORY_KEEP_LIMIT = 50;
var SEARCH_HISTORY_TERM_MIN_LENGTH = 2;
var SEARCH_HISTORY_TERM_MAX_LENGTH = 120;
var SEARCH_HISTORY_CONTEXT_MAX_LENGTH = 80;
var SEARCH_HISTORY_CONTEXT_PATTERN = /^[a-z][a-z0-9-]*(\.[a-z0-9-]+)+$/;
var SEARCH_SUGGESTION_LIMIT = 8;
function normalizeSearchTerm(raw) {
  return String(raw ?? "").replace(/\s+/g, " ").trim();
}
__name(normalizeSearchTerm, "normalizeSearchTerm");
var SENSITIVE_TERM_PATTERNS = [
  /\d{6}\s?-?\s?[1-8]\d{6}/,
  /(?:\d[\s-]?){11,}/,
  /0\d{1,2}[\s-]?\d{3,4}[\s-]?\d{4}/
];
function isSensitiveSearchTerm(term) {
  const t = normalizeSearchTerm(term);
  return SENSITIVE_TERM_PATTERNS.some((re) => re.test(t));
}
__name(isSensitiveSearchTerm, "isSensitiveSearchTerm");
function shouldRecordSearchTerm(term) {
  const t = normalizeSearchTerm(term);
  if (t.length < SEARCH_HISTORY_TERM_MIN_LENGTH || t.length > SEARCH_HISTORY_TERM_MAX_LENGTH) {
    return false;
  }
  return !isSensitiveSearchTerm(t);
}
__name(shouldRecordSearchTerm, "shouldRecordSearchTerm");
function isPickerHistoryContext(context) {
  return context.startsWith("picker.");
}
__name(isPickerHistoryContext, "isPickerHistoryContext");
function shouldRecordSearchTermFor(context, term) {
  const t = normalizeSearchTerm(term);
  if (isPickerHistoryContext(context)) {
    return t.length > 0 && t.length <= SEARCH_HISTORY_TERM_MAX_LENGTH;
  }
  return shouldRecordSearchTerm(t);
}
__name(shouldRecordSearchTermFor, "shouldRecordSearchTermFor");
function isValidSearchHistoryContext(context) {
  return typeof context === "string" && context.length <= SEARCH_HISTORY_CONTEXT_MAX_LENGTH && SEARCH_HISTORY_CONTEXT_PATTERN.test(context);
}
__name(isValidSearchHistoryContext, "isValidSearchHistoryContext");
function toTime(v) {
  const n = v instanceof Date ? v.getTime() : Date.parse(v);
  return Number.isNaN(n) ? 0 : n;
}
__name(toTime, "toTime");
function splitSearchHistory(entries) {
  const list = (entries ?? []).filter((e) => normalizeSearchTerm(e.term).length > 0);
  const byUse = /* @__PURE__ */ __name((a, b) => b.useCount - a.useCount || toTime(b.lastUsedAt) - toTime(a.lastUsedAt), "byUse");
  const pinned = list.filter((e) => e.pinned === true).sort(byUse);
  const frequent = [
    ...pinned,
    ...list.filter((e) => e.pinned !== true && e.useCount >= SEARCH_HISTORY_FREQUENT_MIN_COUNT).sort(byUse).slice(0, Math.max(0, SEARCH_HISTORY_FREQUENT_LIMIT - pinned.length))
  ];
  const taken = new Set(frequent.map((e) => e.term));
  const recent = [
    ...list
  ].filter((e) => !taken.has(e.term)).sort((a, b) => toTime(b.lastUsedAt) - toTime(a.lastUsedAt)).slice(0, SEARCH_HISTORY_RECENT_LIMIT);
  return {
    frequent,
    recent
  };
}
__name(splitSearchHistory, "splitSearchHistory");
function mergeSearchSuggestions(history, dataCandidates, query, limit = SEARCH_SUGGESTION_LIMIT) {
  const q = normalizeSearchTerm(query).toLowerCase();
  if (!q) {
    return [];
  }
  const out = [];
  const seen = /* @__PURE__ */ new Set([
    q
  ]);
  const push = /* @__PURE__ */ __name((term) => {
    const t = normalizeSearchTerm(term);
    const key = t.toLowerCase();
    if (!t || seen.has(key) || out.length >= limit) {
      return;
    }
    seen.add(key);
    out.push(t);
  }, "push");
  const hist = (history ?? []).map((e) => normalizeSearchTerm(e.term));
  for (const t of hist) {
    if (t.toLowerCase().startsWith(q)) {
      push(t);
    }
  }
  for (const t of hist) {
    if (t.toLowerCase().includes(q)) {
      push(t);
    }
  }
  for (const c of dataCandidates ?? []) {
    const t = normalizeSearchTerm(c);
    if (t.toLowerCase().includes(q)) {
      push(t);
    }
  }
  return out;
}
__name(mergeSearchSuggestions, "mergeSearchSuggestions");

// src/constants/sheet-ref-catalog.ts
var SHEET_REF_FIELD_CATALOG = {
  allowance_record: [
    {
      value: "amount",
      label: "\uAE08\uC561 (amount)"
    },
    {
      value: "reason",
      label: "\uC0AC\uC720 (reason)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    },
    {
      value: "notes",
      label: "\uBA54\uBAA8 (notes)"
    },
    {
      value: "createdAt",
      label: "\uC0DD\uC131\uC77C\uC2DC (createdAt)"
    }
  ],
  deduction_record: [
    {
      value: "amount",
      label: "\uAE08\uC561 (amount)"
    },
    {
      value: "reason",
      label: "\uC0AC\uC720 (reason)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    },
    {
      value: "notes",
      label: "\uBA54\uBAA8 (notes)"
    },
    {
      value: "createdAt",
      label: "\uC0DD\uC131\uC77C\uC2DC (createdAt)"
    }
  ],
  overtime_record: [
    {
      value: "workDate",
      label: "\uADFC\uBB34\uC77C (workDate)"
    },
    {
      value: "startTime",
      label: "\uC2DC\uC791\uC2DC\uAC04 (startTime)"
    },
    {
      value: "endTime",
      label: "\uC885\uB8CC\uC2DC\uAC04 (endTime)"
    },
    {
      value: "overtimeHours",
      label: "\uCD08\uACFC\uC2DC\uAC04 (overtimeHours)"
    },
    {
      value: "mealBreakHours",
      label: "\uC2DD\uC0AC\uC2DC\uAC04 (mealBreakHours)"
    },
    {
      value: "overtimeCategory",
      label: "\uCE74\uD14C\uACE0\uB9AC (overtimeCategory)"
    },
    {
      value: "amount",
      label: "\uAE08\uC561 (amount)"
    },
    {
      value: "reason",
      label: "\uC0AC\uC720 (reason)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    },
    {
      value: "createdAt",
      label: "\uC0DD\uC131\uC77C\uC2DC (createdAt)"
    }
  ],
  fixed_incentive: [
    {
      value: "incentiveType",
      label: "\uC778\uC13C\uD2F0\uBE0C \uC885\uB958 (incentiveType)"
    },
    {
      value: "incentiveCategory",
      label: "\uCE74\uD14C\uACE0\uB9AC (incentiveCategory)"
    },
    {
      value: "unitCount",
      label: "\uAC74\uC218 (unitCount)"
    },
    {
      value: "unitPrice",
      label: "\uB2E8\uAC00 (unitPrice)"
    },
    {
      value: "totalAmount",
      label: "\uCD1D\uC561 (totalAmount)"
    },
    {
      value: "splitRatio",
      label: "\uBD84\uBC30\uC728 (splitRatio)"
    },
    {
      value: "position",
      label: "\uD3EC\uC9C0\uC158 (position)"
    },
    // 직원 정보의 직무 — 직무 마스터에 등록된 이름만 쓸 수 있다(미등록은 커밋 issue). 근로계약의 직무(jobDuty)와 별개
    {
      value: "employeeJobDutyName",
      label: "\uC9C1\uBB34 \xB7 \uC9C1\uC6D0 \uC815\uBCF4 (employeeJobDutyName)"
    },
    // 근로형태(포괄임금 시간 기준) — 설정 › 근로형태에 등록된 이름만(미등록은 커밋 issue)
    {
      value: "workPatternName",
      label: "\uADFC\uB85C\uD615\uD0DC \xB7 \uC9C1\uC6D0 \uC815\uBCF4 (workPatternName)"
    },
    {
      value: "amount",
      label: "\uAE08\uC561 (amount)"
    },
    {
      value: "reason",
      label: "\uC0AC\uC720 (reason)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    },
    {
      value: "createdAt",
      label: "\uC0DD\uC131\uC77C\uC2DC (createdAt)"
    }
  ],
  // 반복 고정 수당 정의(MED-824) — 그 달에 유효한 정의. 여러 건이면 amount 는 합산.
  recurring_allowance: [
    {
      value: "amount",
      label: "\uAE08\uC561 (amount)"
    },
    {
      value: "code",
      label: "\uCF54\uB4DC (code)"
    },
    {
      value: "label",
      label: "\uC218\uB2F9 \uC774\uB984 (label)"
    },
    {
      value: "validFrom",
      label: "\uC2DC\uC791\uC77C (validFrom)"
    },
    {
      value: "validUntil",
      label: "\uC885\uB8CC\uC77C (validUntil)"
    },
    {
      value: "note",
      label: "\uBA54\uBAA8 (note)"
    }
  ],
  leave_of_absence_record: [
    {
      value: "startDate",
      label: "\uC2DC\uC791\uC77C (startDate)"
    },
    {
      value: "expectedReturnDate",
      label: "\uBCF5\uADC0\uC608\uC815 (expectedReturnDate)"
    },
    {
      value: "actualReturnDate",
      label: "\uC2E4\uC81C\uBCF5\uADC0 (actualReturnDate)"
    },
    {
      value: "reason",
      label: "\uC0AC\uC720 (reason)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    },
    {
      value: "createdAt",
      label: "\uC0DD\uC131\uC77C\uC2DC (createdAt)"
    }
  ],
  resignation_record: [
    {
      value: "resignationDate",
      label: "\uD1F4\uC0AC\uC77C (resignationDate)"
    },
    {
      value: "processedBy",
      label: "\uCC98\uB9AC\uC790 (processedBy)"
    },
    {
      value: "processedAt",
      label: "\uCC98\uB9AC\uC77C (processedAt)"
    },
    {
      value: "reason",
      label: "\uC0AC\uC720 (reason)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    },
    {
      value: "createdAt",
      label: "\uC0DD\uC131\uC77C\uC2DC (createdAt)"
    }
  ],
  e_sign_record: [
    {
      value: "templateName",
      label: "\uBB38\uC11C\uBA85 (templateName)"
    },
    {
      value: "sentAt",
      label: "\uBC1C\uC1A1\uC77C\uC2DC (sentAt)"
    },
    {
      value: "signedAt",
      label: "\uC11C\uBA85\uC77C\uC2DC (signedAt)"
    },
    {
      value: "recipientName",
      label: "\uC218\uC2E0\uC790 (recipientName)"
    },
    {
      value: "recipientEmail",
      label: "\uC218\uC2E0 \uC774\uBA54\uC77C (recipientEmail)"
    },
    {
      value: "recipientPhone",
      label: "\uC218\uC2E0 \uD734\uB300\uC804\uD654 (recipientPhone)"
    },
    {
      value: "errorMessage",
      label: "\uC624\uB958\uBA54\uC2DC\uC9C0 (errorMessage)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    },
    {
      value: "createdAt",
      label: "\uC0DD\uC131\uC77C\uC2DC (createdAt)"
    }
  ],
  attendance: [
    {
      value: "date",
      label: "\uC77C\uC790 (date)"
    },
    {
      value: "type",
      label: "\uC720\uD615 (type)"
    },
    {
      value: "actualCheckIn",
      label: "\uCD9C\uADFC\uC2DC\uAC01 (actualCheckIn)"
    },
    {
      value: "actualCheckOut",
      label: "\uD1F4\uADFC\uC2DC\uAC01 (actualCheckOut)"
    },
    {
      value: "scheduledCheckIn",
      label: "\uC608\uC815 \uCD9C\uADFC (scheduledCheckIn)"
    },
    {
      value: "scheduledCheckOut",
      label: "\uC608\uC815 \uD1F4\uADFC (scheduledCheckOut)"
    },
    // 2026-06 근태 시간 구분 개편: 소정 시간 내 버킷은 일반·야간·휴일일반·휴일야간 4개.
    // 연장·주말·휴일(통합)은 레거시 컬럼 — 개편 이후 신규 계산에서는 항상 0 이고 과거 데이터 호환용.
    {
      value: "regularHours",
      label: "\uC77C\uBC18\uC2DC\uAC04 (regularHours)"
    },
    {
      value: "nightHours",
      label: "\uC57C\uAC04\uC2DC\uAC04 (nightHours)"
    },
    {
      value: "holidayRegularHours",
      label: "\uD734\uC77C\uC77C\uBC18\uC2DC\uAC04 (holidayRegularHours)"
    },
    {
      value: "holidayNightHours",
      label: "\uD734\uC77C\uC57C\uAC04\uC2DC\uAC04 (holidayNightHours)"
    },
    {
      value: "overtimeHours",
      label: "\uC5F0\uC7A5\uC2DC\uAC04 (overtimeHours) \xB7 \uB808\uAC70\uC2DC"
    },
    {
      value: "weekendHours",
      label: "\uC8FC\uB9D0\uC2DC\uAC04 (weekendHours) \xB7 \uB808\uAC70\uC2DC"
    },
    {
      value: "holidayHours",
      label: "\uD734\uC77C\uC2DC\uAC04 (holidayHours) \xB7 \uB808\uAC70\uC2DC"
    },
    {
      value: "breakHours",
      label: "\uD734\uC2DD\uC2DC\uAC04 (breakHours)"
    },
    {
      value: "totalHours",
      label: "\uCD1D\uC2DC\uAC04 (totalHours)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    }
  ],
  offsite_work_record: [
    {
      value: "workDate",
      label: "\uC678\uADFC\uC77C (workDate)"
    },
    {
      value: "startTime",
      label: "\uC2DC\uC791\uC2DC\uAC04 (startTime)"
    },
    {
      value: "endTime",
      label: "\uC885\uB8CC\uC2DC\uAC04 (endTime)"
    },
    {
      value: "workHours",
      label: "\uC678\uADFC\uC2DC\uAC04 (workHours)"
    },
    {
      value: "location",
      label: "\uC7A5\uC18C (location)"
    },
    {
      value: "typeName",
      label: "\uC720\uD615 (typeName)"
    },
    {
      value: "reason",
      label: "\uC0AC\uC720 (reason)"
    },
    {
      value: "status",
      label: "\uC0C1\uD0DC (status)"
    },
    {
      value: "createdAt",
      label: "\uC0DD\uC131\uC77C\uC2DC (createdAt)"
    }
  ],
  ward_daily_record: [
    {
      value: "date",
      label: "\uC77C\uC790 (date)"
    },
    {
      value: "patientCount",
      label: "\uD658\uC790\uC218 (patientCount)"
    },
    {
      value: "wardId",
      label: "\uBCD1\uB3D9 ID (wardId)"
    },
    {
      value: "wardName",
      label: "\uBCD1\uB3D9\uBA85 (wardName)"
    },
    {
      value: "updatedById",
      label: "\uC218\uC815\uC790 (updatedById)"
    }
  ],
  salary_grade: [
    {
      value: "grade",
      label: "\uD638\uBD09 (grade)"
    },
    {
      value: "baseSalary",
      label: "\uAE30\uBCF8\uAE09 (baseSalary)"
    },
    {
      value: "hobongAmount",
      label: "\uD638\uBD09\uC218\uB2F9 (hobongAmount)"
    },
    {
      value: "longevityAmount",
      label: "\uADFC\uC18D\uC218\uB2F9 (longevityAmount)"
    },
    {
      value: "effectiveYear",
      label: "\uC801\uC6A9\uC5F0\uB3C4 (effectiveYear)"
    },
    {
      value: "categoryId",
      label: "\uCE74\uD14C\uACE0\uB9AC ID (categoryId)"
    },
    {
      value: "categoryName",
      label: "\uCE74\uD14C\uACE0\uB9AC\uBA85 (categoryName)"
    }
  ],
  grade_promotion_request: [
    {
      value: "currentGrade",
      label: "\uD604\uC7AC \uD638\uBD09 (currentGrade)"
    },
    {
      value: "promotedGrade",
      label: "\uC2E0\uCCAD \uD638\uBD09 (promotedGrade)"
    },
    {
      value: "promotionDate",
      label: "\uC2B9\uAE09\uC77C (promotionDate)"
    },
    {
      value: "promotionType",
      label: "\uC720\uD615 (promotionType)"
    },
    {
      value: "approvedBy",
      label: "\uC2B9\uC778\uC790 (approvedBy)"
    },
    {
      value: "approvedAt",
      label: "\uC2B9\uC778\uC77C\uC2DC (approvedAt)"
    }
  ],
  incentive_preset: [
    {
      value: "name",
      label: "\uC774\uB984 (name)"
    },
    {
      value: "code",
      label: "\uCF54\uB4DC (code)"
    },
    {
      value: "description",
      label: "\uC124\uBA85 (description)"
    },
    {
      value: "unitPrice",
      label: "\uB2E8\uAC00 (unitPrice)"
    },
    {
      value: "isActive",
      label: "\uD65C\uC131 (isActive)"
    },
    {
      value: "sortOrder",
      label: "\uC815\uB82C (sortOrder)"
    },
    {
      value: "categoryId",
      label: "\uCE74\uD14C\uACE0\uB9AC ID (categoryId)"
    }
  ],
  employment_contract: [
    {
      value: "contractNumber",
      label: "\uACC4\uC57D\uBC88\uD638 (contractNumber)"
    },
    {
      value: "contractType",
      label: "\uACC4\uC57D\uC720\uD615 (contractType)"
    },
    {
      value: "wageType",
      label: "\uC784\uAE08\uC720\uD615 (wageType)"
    },
    {
      value: "baseSalary",
      label: "\uAE30\uBCF8\uAE09 (baseSalary)"
    },
    {
      value: "hobongAmount",
      label: "\uD638\uBD09\uAC00\uC0B0 (hobongAmount)"
    },
    {
      value: "longevityAmount",
      label: "\uC7A5\uAE30\uADFC\uC18D\uC218\uB2F9 (longevityAmount)"
    },
    {
      value: "hourlyRate",
      label: "\uC2DC\uAE09 (hourlyRate)"
    },
    {
      value: "salaryGrade",
      label: "\uD638\uBD09 (salaryGrade)"
    },
    {
      value: "startDate",
      label: "\uACC4\uC57D\uC2DC\uC791 (startDate)"
    },
    {
      value: "endDate",
      label: "\uACC4\uC57D\uC885\uB8CC (endDate)"
    },
    {
      value: "standardWeeklyHours",
      label: "\uC8FC\uD45C\uC900\uC2DC\uAC04 (standardWeeklyHours)"
    },
    {
      value: "maxWeeklyHours",
      label: "\uC8FC\uCD5C\uB300\uC2DC\uAC04 (maxWeeklyHours)"
    },
    {
      value: "monthlyHours",
      label: "\uC6D4\uD45C\uC900\uC2DC\uAC04 (monthlyHours)"
    },
    // 근로계약서의 직무 — 직원 정보의 직무(식별 필드 「직무 · 직원 정보」)와 구분
    {
      value: "jobDuty",
      label: "\uC9C1\uBB34 \xB7 \uADFC\uB85C\uACC4\uC57D (jobDuty)"
    },
    {
      value: "isActive",
      label: "\uD65C\uC131 (isActive)"
    }
  ]
};
var SHEET_IDENTITY_FIELD_GROUPS = [
  "\uAE30\uBCF8",
  "\uD504\uB85C\uD544",
  "\uADFC\uB85C\uACC4\uC57D (\uC2DC\uD2B8 \uB144\uC6D4 \uAE30\uC900)",
  "\uAE09\uC5EC \uC0B0\uC815 \uAD6C\uAC04 (\uC2DC\uD2B8 \uB144\uC6D4 \uAE30\uC900)"
];
var CONTRACT_GROUP = "\uADFC\uB85C\uACC4\uC57D (\uC2DC\uD2B8 \uB144\uC6D4 \uAE30\uC900)";
var CONTRACT_NOTE = " \uC2DC\uD2B8\uC758 \uB144\uC6D4\uC5D0 \uC720\uD6A8\uD588\uB358 \uADFC\uB85C\uACC4\uC57D \uAC12\uC774\uC5D0\uC694. \uD55C \uB2EC\uC5D0 \uACC4\uC57D\uC774 \uB458\uC774\uBA74 \uC870\uC9C1 \uC124\uC815 \u300C\uADFC\uB85C\uACC4\uC57D \uAE30\uC900\u300D\uC5D0 \uB530\uB77C \uAE08\uC561(\uAE30\uBCF8\uAE09\xB7\uD638\uBD09 \uAE08\uC561\xB7\uADFC\uC18D \uC218\uB2F9)\uC740 \uC18C\uC815\uADFC\uB85C\uC77C \uBE44\uC728\uB85C \uD569\uC0B0\uD558\uACE0 \uB098\uBA38\uC9C0\uB294 \uC6D4\uB9D0\uC758 \uCD5C\uC885 \uACC4\uC57D\uC744 \uBCF4\uAC70\uB098, \uC804\uBD80 \uC6D4\uB9D0 \uCD5C\uC885 \uACC4\uC57D\uC744 \uBD10\uC694. \uC0C1\uC2DC \uC2DC\uD2B8\uB294 \uC9C0\uAE08 \uD65C\uC131 \uACC4\uC57D\uC744 \uBD10\uC694. \uACC4\uC57D \uAE30\uB85D\uB9C8\uB2E4 \uD55C \uC904\uC774 \uD544\uC694\uD558\uBA74 \u300C\uC2DC\uC2A4\uD15C \uAE30\uB85D \u203A \uADFC\uB85C\uACC4\uC57D\u300D\uC744 \uC4F0\uC138\uC694.";
var SHEET_IDENTITY_FIELDS = [
  {
    refField: "employeeNumber",
    label: "\uC0AC\uBC88",
    format: "text",
    group: "\uAE30\uBCF8",
    description: "\uC9C1\uC6D0 \uC815\uBCF4\uC758 \uC0AC\uBC88\uC774\uC5D0\uC694. \uAE00\uC790\uB85C \uB2E4\uB904\uC11C \uC55E\uC790\uB9AC 0 \uC774 \uC9C0\uC6CC\uC9C0\uC9C0 \uC54A\uC544\uC694."
  },
  {
    refField: "employeeName",
    label: "\uC131\uBA85",
    format: "text",
    group: "\uAE30\uBCF8",
    description: "\uC9C1\uC6D0 \uC815\uBCF4\uC758 \uC131\uACFC \uC774\uB984\uC744 \uBD99\uC778 \uAC12\uC774\uC5D0\uC694."
  },
  {
    refField: "teamPath",
    label: "\uC18C\uC18D \uACBD\uB85C",
    format: "text",
    group: "\uAE30\uBCF8",
    description: "\uB300\uD45C \uC18C\uC18D\uC758 \uC0C1\uC704 \uC870\uC9C1\uAE4C\uC9C0 \uC774\uC5B4 \uC4F4 \uACBD\uB85C\uC608\uC694. \uAC04\uD638\uBD80 \u203A 3\uBCD1\uB3D9\uCC98\uB7FC \uBCF4\uC5EC\uC694."
  },
  {
    refField: "team",
    label: "\uD300",
    format: "text",
    group: "\uAE30\uBCF8",
    description: "\uB300\uD45C \uC18C\uC18D\uC758 \uB9D0\uB2E8 \uD300 \uC774\uB984\uC774\uC5D0\uC694. \uC5EC\uB7EC \uC18C\uC18D\uC774 \uC788\uC73C\uBA74 \uB300\uD45C \uC18C\uC18D \uD558\uB098\uB9CC \uBCF4\uC5EC\uC694."
  },
  {
    // 기본 제공 시트 「계약급여내역」의 역할 열이 쓰던 값 — 서버는 있었는데 목록에 없었다(온보딩 10/15).
    refField: "roleName",
    label: "\uC5ED\uD560",
    format: "text",
    group: "\uAE30\uBCF8",
    description: "\uB300\uD45C \uC18C\uC18D(\uD300 \uAD6C\uC131\uC6D0)\uC5D0 \uC9C0\uC815\uB41C \uC5ED\uD560 \uC774\uB984\uC774\uC5D0\uC694. \uC5ED\uD560\uC774 \uC5C6\uB294 \uC18C\uC18D\uC774\uBA74 \uBE44\uC5B4\uC694."
  },
  {
    refField: "wardName",
    label: "\uBCD1\uB3D9",
    format: "text",
    group: "\uAE30\uBCF8",
    description: "\uC9C1\uC6D0\uC774 \uBC30\uC815\uB41C \uBCD1\uB3D9 \uC774\uB984\uC774\uC5D0\uC694. \uBCD1\uB3D9 \uBC30\uC815\uC774 \uC5C6\uC73C\uBA74 \uBE44\uC5B4\uC694."
  },
  {
    refField: "email",
    label: "\uC774\uBA54\uC77C",
    format: "text",
    group: "\uD504\uB85C\uD544",
    description: "\uC9C1\uC6D0 \uC815\uBCF4\uC758 \uC774\uBA54\uC77C\uC774\uC5D0\uC694."
  },
  {
    refField: "phone",
    label: "\uD734\uB300\uD3F0",
    format: "text",
    group: "\uD504\uB85C\uD544",
    description: "\uC9C1\uC6D0 \uC815\uBCF4\uC758 \uD734\uB300\uD3F0 \uBC88\uD638\uC608\uC694."
  },
  {
    refField: "birthDate",
    label: "\uC0DD\uB144\uC6D4\uC77C",
    format: "date",
    group: "\uD504\uB85C\uD544",
    description: "\uC9C1\uC6D0 \uC815\uBCF4\uC758 \uC0DD\uB144\uC6D4\uC77C\uC774\uC5D0\uC694."
  },
  {
    refField: "hireDate",
    label: "\uC785\uC0AC\uC77C",
    format: "date",
    group: "\uD504\uB85C\uD544",
    description: "\uC9C1\uC6D0 \uC815\uBCF4\uC758 \uC785\uC0AC\uC77C\uC774\uC5D0\uC694. \uC7AC\uC785\uC0AC\uD55C \uC9C1\uC6D0\uC740 \uCD5C\uADFC \uC7AC\uC9C1\uAE30\uC758 \uC785\uC0AC\uC77C\uC774\uC5D0\uC694."
  },
  {
    refField: "resignationDate",
    label: "\uCD5C\uC885 \uADFC\uBB34\uC77C(\uD1F4\uC0AC\uC77C)",
    format: "date",
    group: "\uD504\uB85C\uD544",
    description: "\uD1F4\uC0AC \uAE30\uB85D\uC758 \uCD5C\uC885 \uADFC\uBB34\uC77C\uC774\uC5D0\uC694. \uC7AC\uC9C1 \uC911\uC774\uBA74 \uBE44\uC5B4\uC694."
  },
  {
    refField: "employeeStatus",
    label: "\uC7AC\uC9C1 \uC0C1\uD0DC",
    format: "text",
    group: "\uD504\uB85C\uD544",
    description: "\uC9C1\uC6D0 \uC815\uBCF4\uC758 \uC7AC\uC9C1 \uC0C1\uD0DC\uC608\uC694. \uC7AC\uC9C1\xB7\uD734\uC9C1\xB7\uD1F4\uC9C1 \uB4F1\uC73C\uB85C \uBCF4\uC5EC\uC694."
  },
  {
    refField: "employeeJobDuty",
    label: "\uC9C1\uBB34",
    format: "text",
    group: "\uD504\uB85C\uD544",
    description: "\uC9C1\uC6D0 \uC815\uBCF4(\uBA85\uBD80)\uC758 \uC9C1\uBB34\uC608\uC694. \uADFC\uB85C\uACC4\uC57D\uC11C\uC5D0 \uC801\uD78C \uC9C1\uBB34\uC640 \uB2E4\uB97C \uC218 \uC788\uC5B4\uC694 \u2014 \uADF8\uCABD\uC740 \u300C\uC2DC\uC2A4\uD15C \uAE30\uB85D \u203A \uADFC\uB85C\uACC4\uC57D \u203A \uC9C1\uBB34\u300D\uC608\uC694."
  },
  {
    // 근로형태(work_patterns, 포괄임금 시간 기준) — 직원 정보의 workPatternId 가 가리키는 이름.
    // 읽기 전용. 직원 마스터 시트에서 이름으로 고쳐 쓰는 칸은 「시스템 기록 › 근로자 정보 › 근무 · 근로형태」.
    refField: "workPatternName",
    label: "\uADFC\uB85C\uD615\uD0DC",
    format: "text",
    group: "\uD504\uB85C\uD544",
    description: "\uC9C1\uC6D0 \uC815\uBCF4\uC5D0 \uC9C0\uC815\uB41C \uADFC\uB85C\uD615\uD0DC(\uADFC\uBB34\uC124\uC815 \u203A \uADFC\uB85C\uD615\uD0DC)\uC758 \uC774\uB984\uC774\uC5D0\uC694. \uC77D\uAE30 \uC804\uC6A9\uC774\uB77C \uBC14\uAFB8\uB824\uBA74 \uC9C1\uC6D0 \uAD00\uB9AC\uC5D0\uC11C \uC9C0\uC815\uD558\uAC70\uB098, \uC9C1\uC6D0 \uB9C8\uC2A4\uD130 \uC2DC\uD2B8\uC758 \u300C\uC2DC\uC2A4\uD15C \uAE30\uB85D \u203A \uADFC\uB85C\uC790 \uC815\uBCF4 \u203A \uADFC\uB85C\uD615\uD0DC\u300D \uC5F4\uC5D0 \uC801\uACE0 \uB9C8\uC2A4\uD130\uC5D0 \uC801\uC6A9\uD558\uC138\uC694. \uC815\uADDC\uC9C1\xB7\uACC4\uC57D\uC9C1 \uAD6C\uBD84\uC740 \uC544\uB798 \u300C\uACC4\uC57D \uD615\uD0DC\u300D\uC608\uC694."
  },
  {
    refField: "contractType",
    label: "\uACC4\uC57D \uD615\uD0DC",
    format: "text",
    group: CONTRACT_GROUP,
    description: `\uC815\uADDC\uC9C1\xB7\uACC4\uC57D\uC9C1 \uAC19\uC740 \uACC4\uC57D \uD615\uD0DC\uC608\uC694.${CONTRACT_NOTE}`
  },
  {
    refField: "wageType",
    label: "\uC784\uAE08 \uD615\uD0DC",
    format: "text",
    group: CONTRACT_GROUP,
    description: `\uC6D4\uAE09\xB7\uC2DC\uAE09\xB7\uC77C\uAE09\xB7\uC5F0\uBD09 \uC911 \uD558\uB098\uC608\uC694.${CONTRACT_NOTE}`
  },
  {
    refField: "baseSalary",
    label: "\uAE30\uBCF8\uAE09",
    format: "number",
    group: CONTRACT_GROUP,
    description: `\uADFC\uB85C\uACC4\uC57D\uC758 \uAE30\uBCF8\uAE09\uC774\uC5D0\uC694.${CONTRACT_NOTE}`
  },
  {
    refField: "hobongAmount",
    label: "\uD638\uBD09 \uAE08\uC561",
    format: "number",
    group: CONTRACT_GROUP,
    description: `\uADFC\uB85C\uACC4\uC57D\uC758 \uD638\uBD09 \uAC00\uC0B0 \uAE08\uC561\uC774\uC5D0\uC694.${CONTRACT_NOTE}`
  },
  {
    refField: "longevityAmount",
    label: "\uADFC\uC18D \uC218\uB2F9",
    format: "number",
    group: CONTRACT_GROUP,
    description: `\uADFC\uB85C\uACC4\uC57D\uC758 \uC7A5\uAE30\uADFC\uC18D \uC218\uB2F9\uC774\uC5D0\uC694.${CONTRACT_NOTE}`
  },
  {
    refField: "hourlyRate",
    label: "\uC2DC\uAE09",
    format: "number",
    group: CONTRACT_GROUP,
    description: `\uADFC\uB85C\uACC4\uC57D\uC758 \uC2DC\uAE09\uC774\uC5D0\uC694. \uC6D4\uAE09\uC81C \uACC4\uC57D\uC740 \uBE44\uC5B4 \uC788\uC744 \uC218 \uC788\uC5B4\uC694.${CONTRACT_NOTE}`
  },
  {
    refField: "standardWeeklyHours",
    label: "\uC18C\uC815\uADFC\uB85C\uC2DC\uAC04(\uC8FC)",
    format: "number",
    group: CONTRACT_GROUP,
    description: `\uADFC\uB85C\uACC4\uC57D\uC758 \uC8FC \uC18C\uC815\uADFC\uB85C\uC2DC\uAC04\uC774\uC5D0\uC694.${CONTRACT_NOTE}`
  },
  {
    refField: "salaryGradeName",
    label: "\uD638\uBD09\uBA85",
    format: "text",
    group: CONTRACT_GROUP,
    description: `\uACC4\uC57D\uC5D0 \uC5F0\uACB0\uB41C \uD638\uBD09\uC774\uC5D0\uC694. \uC0AC\uBB34\uC9C1 3\uD638\uBD09\uCC98\uB7FC \uBCF4\uC5EC\uC694.${CONTRACT_NOTE}`
  },
  {
    refField: "contractStartDate",
    label: "\uACC4\uC57D \uC2DC\uC791\uC77C",
    format: "date",
    group: CONTRACT_GROUP,
    description: `\uADFC\uB85C\uACC4\uC57D\uC758 \uC2DC\uC791\uC77C\uC774\uC5D0\uC694.${CONTRACT_NOTE}`
  },
  // ── 급여 산정 구간 — 기본 제공 급여대장이 쓰던 값(시드 템플릿). 서버는 있었는데 목록에 없어
  //    열 설정에서 「현재 설정: payStartDate (목록에 없는 값)」으로만 보였다(MED-837 · 온보딩 10/15).
  {
    refField: "payStartDate",
    label: "\uAE09\uC5EC \uAC00\uC0B0\uC77C",
    format: "date",
    group: "\uAE09\uC5EC \uC0B0\uC815 \uAD6C\uAC04 (\uC2DC\uD2B8 \uB144\uC6D4 \uAE30\uC900)",
    description: "\uC2DC\uD2B8 \uB144\uC6D4\uC758 \uAE09\uC5EC \uC0B0\uC815 \uC2DC\uC791\uC77C\uC774\uC5D0\uC694. \uC785\uC0AC\uC77C\uC774 \uC774 \uB2EC \uC548\uC774\uBA74 \uC785\uC0AC\uC77C, \uC544\uB2C8\uBA74 \uC774 \uB2EC 1\uC77C\uC774\uC5D0\uC694. \uC0C1\uC2DC \uC2DC\uD2B8\uC5D0\uC11C\uB294 \uBE44\uC5B4\uC694."
  },
  {
    refField: "payEndDate",
    label: "\uAE09\uC5EC \uB9C8\uAC10\uC77C",
    format: "date",
    group: "\uAE09\uC5EC \uC0B0\uC815 \uAD6C\uAC04 (\uC2DC\uD2B8 \uB144\uC6D4 \uAE30\uC900)",
    description: "\uC2DC\uD2B8 \uB144\uC6D4\uC758 \uAE09\uC5EC \uC0B0\uC815 \uC885\uB8CC\uC77C\uC774\uC5D0\uC694. \uC774 \uB2EC \uB9D0\uC77C\uACFC \uADF8\uB2EC \uD1F4\uC0AC\uC77C\xB7\uD734\uC9C1 \uC2DC\uC791\uC77C \uC911 \uAC00\uC7A5 \uC774\uB978 \uB0A0\uC774\uC5D0\uC694. \uC0C1\uC2DC \uC2DC\uD2B8\uC5D0\uC11C\uB294 \uBE44\uC5B4\uC694."
  }
];
var SHEET_IDENTITY_FIELD_ALIASES = {
  name: "employeeName",
  team: "teamName",
  role: "roleName"
};
var IDENTITY_VALUE_KEYS = /* @__PURE__ */ new Set([
  ...SHEET_IDENTITY_FIELDS.map((f) => f.refField).filter((f) => !(f in SHEET_IDENTITY_FIELD_ALIASES)),
  ...Object.values(SHEET_IDENTITY_FIELD_ALIASES)
]);
function sheetIdentityValueKey(field) {
  if (!field) {
    return null;
  }
  const aliased = SHEET_IDENTITY_FIELD_ALIASES[field] ?? field;
  return IDENTITY_VALUE_KEYS.has(aliased) ? aliased : null;
}
__name(sheetIdentityValueKey, "sheetIdentityValueKey");

// src/constants/sheet-select-options.ts
var SHEET_SELECT_OPTIONS_SOURCES = [
  "team",
  "incentive_preset_category"
];
var NEW_SELECT_OPTION = "__new__";

// src/constants/sheet-visibility.ts
function sheetExposure(visibility, grantCount) {
  if (visibility === "shared") {
    return "shared";
  }
  return grantCount > 0 ? "partial" : "private";
}
__name(sheetExposure, "sheetExposure");
var SHEET_EXPOSURE_LABELS = {
  shared: "\uC804\uCCB4 \uACF5\uAC1C",
  partial: "\uBD80\uBD84 \uACF5\uAC1C",
  private: "\uBE44\uACF5\uAC1C"
};
function sheetOrgWideShareWarning(sheetNames) {
  const target = sheetNames.length === 0 ? "\uC774 \uC2DC\uD2B8" : sheetNames.length === 1 ? `\u300C${sheetNames[0]}\u300D` : `\u300C${sheetNames[0]}\u300D \uC678 ${sheetNames.length - 1}\uAC1C \uC2DC\uD2B8`;
  return `${target}\uB97C \uC804\uCCB4 \uACF5\uAC1C\uD558\uBA74 \uAE09\uC5EC \uAD00\uB9AC\uC790 \uC804\uC6D0\uACFC \uBAA8\uB4E0 \uD300\uC7A5(\uC790\uAE30 \uD300\xB7\uD558\uC704 \uD300 \uC9C1\uC6D0\uC758 \uD589)\uC774 \uAE09\uC5EC\xB7\uAC1C\uC778\uC815\uBCF4\uB97C \uBCFC \uC218 \uC788\uC5B4\uC694.
\uC77C\uBD80\uB9CC \uBCF4\uAC8C \uD558\uB824\uBA74 \u300C\uC9C0\uC815\uD55C \uD300\xB7\uAC1C\uC778\uB9CC\u300D(\uBD80\uBD84 \uACF5\uAC1C)\uC744 \uAD8C\uC7A5\uD574\uC694.
\uADF8\uB798\uB3C4 \uC804\uCCB4 \uACF5\uAC1C\uD560\uAE4C\uC694?`;
}
__name(sheetOrgWideShareWarning, "sheetOrgWideShareWarning");
function summarizeSheetExposure(items) {
  const out = {
    shared: 0,
    partial: 0,
    private: 0
  };
  for (const it of items) {
    out[sheetExposure(it.visibility, it.grantCount)] += 1;
  }
  return out;
}
__name(summarizeSheetExposure, "summarizeSheetExposure");
function sheetExposureSummaryLabel(summary) {
  return [
    "shared",
    "partial",
    "private"
  ].filter((k) => summary[k] > 0).map((k) => `${SHEET_EXPOSURE_LABELS[k]} ${summary[k]}\uAC1C`).join(" \xB7 ");
}
__name(sheetExposureSummaryLabel, "sheetExposureSummaryLabel");
function planSheetCarryVisibility(source, mode, actorId) {
  if (mode === "private") {
    return {
      visibility: "private",
      createdBy: actorId,
      copyGrants: false
    };
  }
  if (source.visibility === "shared") {
    return {
      visibility: "shared",
      createdBy: actorId,
      copyGrants: true
    };
  }
  return {
    visibility: "private",
    createdBy: source.createdBy || actorId,
    copyGrants: true
  };
}
__name(planSheetCarryVisibility, "planSheetCarryVisibility");

// src/constants/upload-limits.ts
var MESSAGE_ATTACHMENT_LIMITS = {
  image: 10 * 1024 * 1024,
  video: 50 * 1024 * 1024,
  file: 25 * 1024 * 1024
};
function messageAttachmentKind(mime) {
  const m = (mime || "").toLowerCase();
  if (m.startsWith("image/")) {
    return "image";
  }
  if (m.startsWith("video/")) {
    return "video";
  }
  return "file";
}
__name(messageAttachmentKind, "messageAttachmentKind");
function messageAttachmentLimit(mime) {
  return MESSAGE_ATTACHMENT_LIMITS[messageAttachmentKind(mime)];
}
__name(messageAttachmentLimit, "messageAttachmentLimit");
function formatBytes(bytes) {
  if (bytes >= 1024 * 1024) {
    const mb = bytes / (1024 * 1024);
    return `${Number.isInteger(mb) ? mb : mb.toFixed(1)}MB`;
  }
  if (bytes >= 1024) {
    return `${Math.round(bytes / 1024)}KB`;
  }
  return `${bytes}B`;
}
__name(formatBytes, "formatBytes");

// src/constants/index.ts
var SHIFT_CODE_COLORS = [
  "#F66014",
  "#A3C75A",
  "#A0D3F9",
  "#F2C7E3",
  "#26426B",
  "#2463EB",
  "#826AED",
  "#E63224",
  "#0F6625",
  "#A2812D",
  "#F09C00",
  "#00A19D",
  "#B55239",
  "#713838",
  "#B8B8B8"
];
function nextShiftCodeColor(usedColors) {
  const used = new Set(usedColors.map((c) => c.toUpperCase()));
  const free = SHIFT_CODE_COLORS.find((c) => !used.has(c.toUpperCase()));
  if (free) {
    return free;
  }
  return SHIFT_CODE_COLORS[usedColors.length % SHIFT_CODE_COLORS.length];
}
__name(nextShiftCodeColor, "nextShiftCodeColor");
var INSURANCE_RATES = {
  // 국민연금 (National Pension)
  NATIONAL_PENSION: {
    EMPLOYEE: 0.045,
    EMPLOYER: 0.045,
    MONTHLY_MAX: 59e5,
    MONTHLY_MIN: 37e4
  },
  // 건강보험 (Health Insurance)
  HEALTH_INSURANCE: {
    BASE_RATE: 0.0709,
    EMPLOYEE: 0.03545,
    EMPLOYER: 0.03545
  },
  // 장기요양보험 (Long-term Care Insurance)
  LONG_TERM_CARE: {
    RATE_OF_HEALTH: 0.1295,
    EMPLOYEE: 4591e-6,
    EMPLOYER: 4591e-6
  },
  // 고용보험 (Employment Insurance)
  EMPLOYMENT_INSURANCE: {
    EMPLOYEE: 9e-3,
    EMPLOYER: 9e-3,
    // Job Skills Development (employer only)
    EMPLOYER_JOB_SKILLS: {
      SMALL: 25e-4,
      MEDIUM: 45e-4,
      LARGE: 65e-4
    }
  },
  // 산재보험 (Industrial Accident Insurance)
  INDUSTRIAL_ACCIDENT: {
    MIN_RATE: 6e-3,
    MAX_RATE: 0.34,
    AVERAGE_RATE: 0.018
  }
};
var TAX_RATES = {
  // Income tax brackets (annual income)
  INCOME_TAX_BRACKETS: [
    {
      min: 0,
      max: 14e6,
      rate: 0.06
    },
    {
      min: 14e6,
      max: 5e7,
      rate: 0.15
    },
    {
      min: 5e7,
      max: 88e6,
      rate: 0.24
    },
    {
      min: 88e6,
      max: 15e7,
      rate: 0.35
    },
    {
      min: 15e7,
      max: 3e8,
      rate: 0.38
    },
    {
      min: 3e8,
      max: 5e8,
      rate: 0.4
    },
    {
      min: 5e8,
      max: 1e9,
      rate: 0.42
    },
    {
      min: 1e9,
      max: Number.POSITIVE_INFINITY,
      rate: 0.45
    }
  ],
  // Local income tax
  LOCAL_INCOME_TAX_RATE: 0.1,
  // Standard deductions
  STANDARD_DEDUCTIONS: {
    PERSONAL: 15e5,
    SPOUSE: 15e5,
    DEPENDENT: 15e5
  }
};
var WORK_HOURS = {
  STANDARD_WEEKLY: 40,
  MAX_WEEKLY: 52,
  MAX_OVERTIME_WEEKLY: 12,
  NIGHT_SHIFT_START: "22:00",
  NIGHT_SHIFT_END: "06:00",
  NIGHT_SHIFT_PREMIUM: 0.5,
  WEEKEND_PREMIUM: 0.5,
  HOLIDAY_PREMIUM: 0.5,
  OVERTIME_PREMIUM: 0.5
};
var LEAVE_ENTITLEMENTS = {
  // Annual leave by years of service
  ANNUAL_LEAVE: [
    {
      years: 1,
      days: 15
    },
    {
      years: 3,
      days: 16
    },
    {
      years: 5,
      days: 17
    },
    {
      years: 7,
      days: 18
    },
    {
      years: 9,
      days: 19
    },
    {
      years: 11,
      days: 20
    },
    {
      years: 13,
      days: 21
    },
    {
      years: 15,
      days: 22
    },
    {
      years: 17,
      days: 23
    },
    {
      years: 19,
      days: 24
    },
    {
      years: 21,
      days: 25
    }
  ],
  // Special leave
  MATERNITY_LEAVE: 90,
  PATERNITY_LEAVE: 10,
  PARENTAL_LEAVE: 365,
  BEREAVEMENT_LEAVE: {
    PARENT: 5,
    SPOUSE: 5,
    CHILD: 5,
    GRANDPARENT: 3,
    SIBLING: 1
  },
  MARRIAGE_LEAVE: {
    SELF: 5,
    CHILD: 1,
    SIBLING: 1
  }
};
var DEFAULTS = {
  TIMEZONE: "Asia/Seoul",
  CURRENCY: "KRW",
  DATE_FORMAT: "YYYY-MM-DD",
  TIME_FORMAT: "HH:mm",
  DATETIME_FORMAT: "YYYY-MM-DD HH:mm:ss",
  LOCALE: "ko-KR",
  FIRST_DAY_OF_WEEK: 1,
  FISCAL_YEAR_START: 1
};
var PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 20,
  MAX_LIMIT: 100,
  MIN_LIMIT: 1
};
var FILE_LIMITS = {
  MAX_FILE_SIZE: 10 * 1024 * 1024,
  MAX_IMAGE_SIZE: 5 * 1024 * 1024,
  MAX_DOCUMENT_SIZE: 10 * 1024 * 1024,
  ALLOWED_IMAGE_TYPES: [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp"
  ],
  ALLOWED_DOCUMENT_TYPES: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ]
};
var SYSTEM_ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  HR_MANAGER: "hr_manager",
  PAYROLL_MANAGER: "payroll_manager",
  TEAM_LEADER: "team_leader",
  EMPLOYEE: "employee"
};
var RESOURCES = {
  EMPLOYEE: "employee",
  PAYROLL: "payroll",
  ATTENDANCE: "attendance",
  LEAVE: "leave",
  TEAM: "team",
  ORGANIZATION: "organization",
  REPORT: "report",
  SETTING: "setting"
};
var ACTIONS = {
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
  APPROVE: "approve",
  REJECT: "reject",
  EXPORT: "export",
  IMPORT: "import"
};
var REGEX = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\+?[1-9]\d{1,14}$/,
  KOREAN_PHONE: /^(01[016789]|02|0[3-6][1-5])\d{7,8}$/,
  BUSINESS_NUMBER: /^\d{3}-?\d{2}-?\d{5}$/,
  RESIDENT_NUMBER: /^\d{6}-?[1-4]\d{6}$/,
  POSTAL_CODE: /^\d{5}$/,
  URL: /^https?:\/\/.+/
};
var ERROR_MESSAGES = {
  UNAUTHORIZED: "You are not authorized to perform this action",
  NOT_FOUND: "The requested resource was not found",
  VALIDATION_FAILED: "Validation failed. Please check your input",
  INTERNAL_ERROR: "An internal error occurred. Please try again later",
  DUPLICATE_ENTRY: "This entry already exists",
  INSUFFICIENT_BALANCE: "Insufficient balance for this operation",
  QUOTA_EXCEEDED: "You have exceeded your quota limit"
};
export {
  ACTIONS,
  ADMIN_FULL_ENTRY_PERMISSIONS,
  AIDE_PATIENT_RATIO_SUNSET,
  AI_ATTACHMENT_LIMITS,
  APPROVAL_LINE_TYPES,
  APPROVAL_LINE_TYPE_LABEL,
  APPROVAL_REMINDER_HOURS_DEFAULT,
  APPROVAL_REMINDER_HOURS_MAX,
  APPROVAL_STEP_STATUS_VIEW,
  APPROVAL_TYPE_CATALOG,
  APPROVAL_TYPE_LABEL,
  APPROVAL_VISIBILITY_DEFAULT,
  APP_GUIDE_HOSPITAL_CODE_PLACEHOLDER,
  APP_GUIDE_LOGIN_LINK_PLACEHOLDER,
  APP_GUIDE_PLACEHOLDERS,
  APP_HOSPITAL_CODE_MAX_LENGTH,
  APP_HOSPITAL_CODE_MIN_LENGTH,
  APP_HOSPITAL_CODE_PATTERN,
  APP_ONBOARDING_CHECKLIST_DEFS,
  APP_ONBOARDING_GOAL_STAGE,
  APP_ONBOARDING_STAGE_LABELS,
  APP_ONBOARDING_STAGE_ORDER,
  APP_ONBOARDING_STAGE_SHORT_LABELS,
  APP_ONBOARDING_TARGET_RATE_DEFAULT,
  APP_ONBOARDING_TARGET_RATE_MAX,
  APP_ONBOARDING_TARGET_RATE_MIN,
  APP_TUTORIAL_AI_SUBSTEPS,
  APP_TUTORIAL_ENTRY_COPY,
  APP_TUTORIAL_SHIFTS_COPY,
  APP_TUTORIAL_STEP_DEFS,
  APP_TUTORIAL_VERSION,
  ATTENDANCE_DEFAULT_CHECK_IN,
  ATTENDANCE_DEFAULT_CHECK_OUT,
  ATTENDANCE_RECORD_SOURCE_LABELS,
  Action,
  CERTIFICATE_REQUEST_FIELD_CATALOG,
  CERTIFICATE_REQUEST_FIELD_KEYS,
  CERT_FIELD_COLUMN_MAP,
  CERT_TYPE_LABELS,
  CHANGE_EVENT_LABEL,
  CONTRACT_TYPE_OPTIONS,
  CURRENT_TERMS_VERSION,
  DEFAULTS,
  DEFAULT_APP_GUIDE_EMAIL_TEMPLATE,
  DEFAULT_APP_GUIDE_SMS_TEMPLATE,
  DEFAULT_APP_ONBOARDING_NOTICE,
  DEFAULT_APP_ONBOARDING_SETTINGS,
  DEFAULT_CERTIFICATE_REQUEST_FIELDS,
  DEFAULT_CERTIFICATION_TYPES,
  DEFAULT_CERT_FIELD_TEMPLATE,
  DEFAULT_EMPLOYEE_HOME_LAYOUT,
  DEFAULT_HR_ACTION_ATTACHMENT_POLICY,
  DEFAULT_LEAVE_REASON_PRESETS,
  DEFAULT_MESSAGE_REACTION,
  DEFAULT_REQUEST_TIME_STEP_MINUTES,
  DEFAULT_TERMS,
  DEFAULT_USER_PASSWORD_MIN_LENGTH,
  DEFAULT_WORK_PATTERN_MULTIPLIERS,
  DOCUMENT_TEMPLATE_PRESETS,
  DbAction,
  EMPLOYEE_HOME_DEFAULT_SECTION_ORDER,
  EMPLOYEE_HOME_NOTICE_KEEP_DAYS_DEFAULT,
  EMPLOYEE_HOME_NOTICE_KEEP_DAYS_MAX,
  EMPLOYEE_HOME_NOTICE_KEEP_DAYS_MIN,
  EMPLOYEE_HOME_NOTICE_LIMIT_DEFAULT,
  EMPLOYEE_HOME_NOTICE_LIMIT_MAX,
  EMPLOYEE_HOME_NOTICE_LIMIT_MIN,
  EMPLOYEE_HOME_SECTION_LABELS,
  EMPLOYEE_HR_ACTION_KINDS,
  EMPLOYEE_MASTER_FIELDS,
  EMPLOYEE_MASTER_WRITABLE_REF_FIELDS,
  ERROR_MESSAGES,
  FEATURE_BUNDLE_GROUP_LABELS,
  FEATURE_PERMISSION_BUNDLES,
  FILE_LIMITS,
  FORM_TEMPLATE_CODES,
  GENERAL_WARD_NURSING_GRADES,
  HALF_DAY_PERIOD_LABELS,
  HR_ACTION_CATALOG,
  HR_ACTION_FORM_TEMPLATE_CODES,
  HR_ACTION_KINDS,
  HR_APPOINTMENT_ACTION_LABELS,
  IMPERSONATION_DEFAULT_TTL_MINUTES,
  IMPERSONATION_MAX_TTL_MINUTES,
  IMPERSONATION_TTL_OPTIONS,
  INSURANCE_RATES,
  INTEGRATED_WARD_STAFFING,
  JOB_CATEGORY_LABELS,
  LEAVE_ENTITLEMENTS,
  LEAVE_OF_ABSENCE_REASONS,
  LEAVE_OVERUSE_CONFIRM_PREFIX,
  LEAVE_OVERUSE_MODE_LABELS,
  LEAVE_REASON_PRESET_MAX,
  LTC_HOSPITAL_DOCTOR_GRADES,
  LTC_HOSPITAL_NURSING_GRADES,
  MASTER_DATA_SHEET_SOURCES,
  MESSAGE_ATTACHMENT_LIMITS,
  MESSAGE_REACTION_EMOJIS,
  NEW_SELECT_OPTION,
  NOTIFICATION_PUSH_CATEGORIES,
  NOTIFICATION_PUSH_CATEGORY_PREFIX,
  ORGANIZATION_DATA_RETENTION_MONTHS,
  P,
  PAGINATION,
  REGEX,
  REQUEST_TIME_STEP_LABELS,
  REQUEST_TIME_STEP_OPTIONS,
  RESIGNATION_DOCUMENT_TYPE,
  RESOURCES,
  ROLE_SCOPE_UNSET,
  Resource,
  SEARCH_HISTORY_CONTEXT_MAX_LENGTH,
  SEARCH_HISTORY_CONTEXT_PATTERN,
  SEARCH_HISTORY_FREQUENT_LIMIT,
  SEARCH_HISTORY_FREQUENT_MIN_COUNT,
  SEARCH_HISTORY_KEEP_LIMIT,
  SEARCH_HISTORY_RECENT_LIMIT,
  SEARCH_HISTORY_TERM_MAX_LENGTH,
  SEARCH_HISTORY_TERM_MIN_LENGTH,
  SEARCH_SUGGESTION_LIMIT,
  SECOM_PUNCH_EVENT_TYPES,
  SHEET_EXPOSURE_LABELS,
  SHEET_IDENTITY_FIELDS,
  SHEET_IDENTITY_FIELD_ALIASES,
  SHEET_IDENTITY_FIELD_GROUPS,
  SHEET_REF_FIELD_CATALOG,
  SHEET_SELECT_OPTIONS_SOURCES,
  SHIFT_ASSIGNMENT_SOURCE_LABELS,
  SHIFT_CODE_COLORS,
  SHIFT_DAY_SHORT_LABELS,
  SHIFT_RESOLUTION_SOURCE_LABELS,
  SYSTEM_ROLES,
  Scope,
  TAX_RATES,
  TEAM_LEADER_GRANTS,
  TEAM_LEADER_GRANT_CODES,
  TEMPORARY_PASSWORD_VALIDITY_DAYS_MAX,
  TEMPORARY_PASSWORD_VALIDITY_DAYS_MIN,
  TERMS_VERSION_PATTERN,
  TERM_KEYS,
  TERM_LABELS,
  TERM_MAX_LENGTH,
  WAGE_TYPE_OPTIONS,
  WEEKS_PER_MONTH,
  WORKS_APP_STORE_URL,
  WORKS_PLAY_STORE_URL,
  WORK_HOURS,
  WORK_PATTERN_DERIVED_FIELDS,
  WORK_PATTERN_DERIVED_FIELD_LABELS,
  allowModeOf,
  allowOnDisabledReason,
  allowValueOf,
  appGuideLinkText,
  appGuideTemplateIncludesPassword,
  appGuideTemplateNeedsHospitalCode,
  appOnboardingStageAtLeast,
  appTutorialShiftsCopy,
  applicableDayKeys,
  applyReactionChange,
  applySummary,
  applyTargets,
  approvalDecisionHint,
  approvalLineEnabledFor,
  approvalLineEnabledTypes,
  approvalNextLabel,
  approvalOthersTurnMessage,
  approvalOutcomeFromSteps,
  approvalProgressLabel,
  approvalReminderDue,
  approvalReplaceHint,
  approvalRowActionable,
  approvalRowState,
  approvalStatusDetail,
  approvalStepReadText,
  approvalStepReplaceable,
  approvalStepStatusView,
  approvalTypeInfo,
  approverIdsFromSelection,
  approverLabel,
  attachJosa,
  attendanceRecordSourceLabel,
  buildTeamTreeRows,
  canEnterAdminFull,
  candidatesToPickerEmployees,
  changeLogLine,
  compactTerminology,
  compareTeamName,
  compareTeamOrder,
  computeHourlyRate,
  computeWageHours,
  defaultCertFields,
  defaultCertLicenseName,
  deriveFromWorkPattern,
  deriveMonthlyStandardHours,
  describeHrActionFields,
  describeShiftSchedule,
  describeTemporaryPasswordPolicy,
  describeUserPasswordPolicy,
  diffDerivedValues,
  documentTemplatePresetByCode,
  effectiveLine,
  employeeMasterField,
  employeeMatchesQuery,
  employeeNumbersEqual,
  enabledAppTutorialSteps,
  entityPickerQuery,
  entityPickerRecentContext,
  expandEntitySelection,
  featureBundleById,
  filterEmployees,
  filterOverviewRows,
  filterTeamTreeRows,
  findUnknownAppGuidePlaceholders,
  flattenEntitySelection,
  formatBytes,
  formatDayRange,
  formatHoursKo,
  formatMinutesToTime,
  formatPermissionLabelKo,
  groupReactionChips,
  halfDayPeriodLabel,
  hasOrgWidePermission,
  hrActionApprovalHint,
  hrActionDetails,
  hrActionKindByDocumentType,
  hrActionKindByFormTemplateCode,
  hrActionRequiresFile,
  inheritHint,
  isCertificateTemplateCode,
  isDepartmentTeam,
  isEmployeeHomeNoticeSeen,
  isHrActionDocument,
  isMasterDataSheetSource,
  isMessageReactionEmoji,
  isOnTimeStep,
  isPickerHistoryContext,
  isPushAllowed,
  isRequestTimeStep,
  isResignationDocument,
  isSecomPunchEventType,
  isSensitiveSearchTerm,
  isTemporaryPasswordExpired,
  isValidQuietHours,
  isValidSearchHistoryContext,
  isWithinQuietHours,
  isWorkPatternDerivedField,
  josa,
  leaveCalendarDays,
  leaveCancelPlanLabel,
  leaveReasonUnit,
  maskAccountNumber,
  maskResidentNumber,
  matchesTemporaryPasswordPolicy,
  mergeSearchSuggestions,
  messageAttachmentKind,
  messageAttachmentLimit,
  minuteOfDayInTimezone,
  minuteStepOptions,
  missingCertificatePresets,
  missingRequiredCertificateFields,
  monthlyHoursFromDaily,
  monthlyWorkingDaysFromWeekly,
  moveSibling,
  nextShiftCodeColor,
  normalizeAppHospitalCode,
  normalizeEmployeeHomeSectionOrder,
  normalizeEmployeeNumber,
  normalizeRoleOrgScope,
  normalizeSearchTerm,
  normalizeTerm,
  notificationPushCategoryEventType,
  organizationPurgeCutoff,
  organizationPurgeDate,
  overviewAllowOptions,
  overviewAllowTip,
  overviewCellText,
  overviewTypes,
  parseApprovalLineEnabled,
  parseHHMM,
  parseTimeToMinutes,
  pickRoleScopeId,
  pickerSelectionOf,
  planHrActionApplication,
  planLeaveCancellation,
  planResignationApplication,
  planSheetCarryVisibility,
  quietHoursLabel,
  renderAppGuideTemplate,
  resignationDocumentDetails,
  resolveAppOnboardingSettings,
  resolveAppOnboardingStage,
  resolveApprovalReminderHours,
  resolveApprovalVisibility,
  resolveCertificateRequestFields,
  resolveEmployeeHomeLayout,
  resolveHrActionAttachmentPolicy,
  resolveHrActionKind,
  resolveLeaveOveruseMode,
  resolveMasterOption,
  resolveNotificationAppLabel,
  resolveNotificationPushCategory,
  resolveNotificationTarget,
  resolveNursingGrade,
  resolveRequestTimeStepMinutes,
  resolveScreenCaptureProtection,
  resolveSimplifiedOvertimeType,
  resolveTemporaryPasswordValidityDays,
  resolveTerminology,
  resolveUserPasswordPolicy,
  resolveWorkPatternMultipliers,
  roleDepartmentOptions,
  roleMatchesOrgFilter,
  roleScopeTeamLabel,
  roleTeamOptionGroups,
  rootTeamIdOf,
  roundHours,
  selectEmployeeHomeNotices,
  sheetExposure,
  sheetExposureSummaryLabel,
  sheetIdentityValueKey,
  sheetOrgWideShareWarning,
  shouldRecordSearchTerm,
  shouldRecordSearchTermFor,
  splitSearchHistory,
  summarizeSheetExposure,
  teamDescendantIds,
  teamLeaderGrantCovers,
  teamMatchesQuery,
  templateRows,
  temporaryPasswordLength,
  timeSlotOptions,
  userPasswordPolicyError,
  visibleEmployeeHomeSections
};
//# sourceMappingURL=constants.mjs.map